/* oxlint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as OnboardingRouteImport } from './routes/onboarding';
import { Route as JoinRequestRouteImport } from './routes/join-request';
import { Route as DesignStudioEmbedRouteImport } from './routes/design-studio-embed';
import { Route as CliRouteImport } from './routes/cli';
import { Route as CheckoutRouteImport } from './routes/checkout';
import { Route as AcceptGuestInvitationRouteImport } from './routes/accept-guest-invitation';
import { Route as AcademyLoginRouteImport } from './routes/academy-login';
import { Route as AuthenticatedRouteImport } from './routes/_authenticated';
import { Route as OnboardingIndexRouteImport } from './routes/onboarding.index';
import { Route as CliIndexRouteImport } from './routes/cli.index';
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated.index';
import { Route as VwbDemoSplatRouteImport } from './routes/vwb-demo.$';
import { Route as UsersSplatRouteImport } from './routes/users.$';
import { Route as SignupSplatRouteImport } from './routes/signup.$';
import { Route as Reset_passwordSplatRouteImport } from './routes/reset_password.$';
import { Route as Post_registrationSplatRouteImport } from './routes/post_registration.$';
import { Route as Post_cancelSplatRouteImport } from './routes/post_cancel.$';
import { Route as OnboardingWizardRouteImport } from './routes/onboarding.wizard';
import { Route as OnboardingVerificationRouteImport } from './routes/onboarding.verification';
import { Route as OnboardingGetStartedRouteImport } from './routes/onboarding.get-started';
import { Route as Oauth2SplatRouteImport } from './routes/oauth2.$';
import { Route as OauthSplatRouteImport } from './routes/oauth.$';
import { Route as No_accessible_workspacesSplatRouteImport } from './routes/no_accessible_workspaces.$';
import { Route as LogoutSplatRouteImport } from './routes/logout.$';
import { Route as LoginSplatRouteImport } from './routes/login.$';
import { Route as JourneysSplatRouteImport } from './routes/journeys.$';
import { Route as IntegrationsSplatRouteImport } from './routes/integrations.$';
import { Route as HarSanitizerSplatRouteImport } from './routes/har-sanitizer.$';
import { Route as EnvSplatRouteImport } from './routes/env.$';
import { Route as Confirm_account_noticeSplatRouteImport } from './routes/confirm_account_notice.$';
import { Route as Confirm_accountSplatRouteImport } from './routes/confirm_account.$';
import { Route as CliDnsSetupRouteImport } from './routes/cli.dns-setup';
import { Route as Account_cancelledSplatRouteImport } from './routes/account_cancelled.$';
import { Route as Account_canceledSplatRouteImport } from './routes/account_canceled.$';
import { Route as AccountSplatRouteImport } from './routes/account.$';
import { Route as AuthenticatedWorkspacesRouteImport } from './routes/_authenticated.workspaces';
import { Route as AuthenticatedSplatRouteImport } from './routes/_authenticated.$';
import { Route as R2fa_setupSplatRouteImport } from './routes/2fa_setup.$';
import { Route as DesignStudioEmbedCioIndexRouteImport } from './routes/design-studio-embed.cio.index';
import { Route as AuthenticatedWorkspacesIndexRouteImport } from './routes/_authenticated.workspaces.index';
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated.settings.index';
import { Route as AuthenticatedSampleWorkspaceIndexRouteImport } from './routes/_authenticated.sample-workspace.index';
import { Route as AuthenticatedInternalToolsIndexRouteImport } from './routes/_authenticated.internal-tools.index';
import { Route as DesignStudioEmbedCioSplatRouteImport } from './routes/design-studio-embed.cio.$';
import { Route as AccountCancelledSplatRouteImport } from './routes/account.cancelled.$';
import { Route as AuthenticatedWorkspacesWorkspaceIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId';
import { Route as AuthenticatedTrialExpiredJourneysRouteImport } from './routes/_authenticated.trial-expired.journeys';
import { Route as AuthenticatedSettingsSubscriptionRouteImport } from './routes/_authenticated.settings.subscription';
import { Route as AuthenticatedSettingsSlackAgentRouteImport } from './routes/_authenticated.settings.slack-agent';
import { Route as AuthenticatedSettingsReceiptsRouteImport } from './routes/_authenticated.settings.receipts';
import { Route as AuthenticatedSettingsPrivacyRouteImport } from './routes/_authenticated.settings.privacy';
import { Route as AuthenticatedSettingsPartnerRouteImport } from './routes/_authenticated.settings.partner';
import { Route as AuthenticatedSettingsExperimentalFeaturesRouteImport } from './routes/_authenticated.settings.experimental-features';
import { Route as AuthenticatedSettingsBillingRouteImport } from './routes/_authenticated.settings.billing';
import { Route as AuthenticatedSettingsAuditLogsRouteImport } from './routes/_authenticated.settings.audit-logs';
import { Route as AuthenticatedSettingsApiKeysRouteImport } from './routes/_authenticated.settings.api-keys';
import { Route as AuthenticatedSettingsAiRouteImport } from './routes/_authenticated.settings.ai';
import { Route as AuthenticatedSettingsSplatRouteImport } from './routes/_authenticated.settings.$';
import { Route as AuthenticatedSampleWorkspaceSplatRouteImport } from './routes/_authenticated.sample-workspace.$';
import { Route as AuthenticatedInternalToolsSplatRouteImport } from './routes/_authenticated.internal-tools.$';
import { Route as PipelinesWorkspacesWorkspaceIdIndexRouteImport } from './routes/pipelines.workspaces.$workspaceId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.index';
import { Route as AuthenticatedSettingsWorkspacesIndexRouteImport } from './routes/_authenticated.settings.workspaces.index';
import { Route as AuthenticatedSettingsTeamIndexRouteImport } from './routes/_authenticated.settings.team.index';
import { Route as AuthenticatedSettingsSecurityIndexRouteImport } from './routes/_authenticated.settings.security.index';
import { Route as AuthenticatedSettingsRolesIndexRouteImport } from './routes/_authenticated.settings.roles.index';
import { Route as AuthenticatedSettingsPersonalIndexRouteImport } from './routes/_authenticated.settings.personal.index';
import { Route as AuthenticatedSettingsPartnerIndexRouteImport } from './routes/_authenticated.settings.partner.index';
import { Route as AuthenticatedSettingsBillingIndexRouteImport } from './routes/_authenticated.settings.billing.index';
import { Route as AuthenticatedSettingsApi_credentialsIndexRouteImport } from './routes/_authenticated.settings.api_credentials.index';
import { Route as AuthenticatedSettingsAccountIndexRouteImport } from './routes/_authenticated.settings.account.index';
import { Route as PipelinesWorkspacesWorkspaceIdSplatRouteImport } from './routes/pipelines.workspaces.$workspaceId.$';
import { Route as AuthenticatedWorkspacesWorkspaceIdTasksRouteImport } from './routes/_authenticated.workspaces.$workspaceId.tasks';
import { Route as AuthenticatedWorkspacesWorkspaceIdSnippetsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.snippets';
import { Route as AuthenticatedWorkspacesWorkspaceIdOutcomesRouteImport } from './routes/_authenticated.workspaces.$workspaceId.outcomes';
import { Route as AuthenticatedWorkspacesWorkspaceIdMessageLibraryRouteImport } from './routes/_authenticated.workspaces.$workspaceId.message-library';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys_';
import { Route as AuthenticatedWorkspacesWorkspaceIdHomeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.home';
import { Route as AuthenticatedWorkspacesWorkspaceIdHealthRouteImport } from './routes/_authenticated.workspaces.$workspaceId.health';
import { Route as AuthenticatedWorkspacesWorkspaceIdGeosetsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.geosets';
import { Route as AuthenticatedWorkspacesWorkspaceIdExportsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.exports';
import { Route as AuthenticatedWorkspacesWorkspaceIdExperimentsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.experiments';
import { Route as AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteImport } from './routes/_authenticated.workspaces.$workspaceId.design-studio';
import { Route as AuthenticatedWorkspacesWorkspaceIdAssetsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.assets';
import { Route as AuthenticatedWorkspacesWorkspaceIdAgentRouteImport } from './routes/_authenticated.workspaces.$workspaceId.agent';
import { Route as AuthenticatedWorkspacesWorkspaceIdSplatRouteImport } from './routes/_authenticated.workspaces.$workspaceId.$';
import { Route as AuthenticatedSettingsWorkspacesNewRouteImport } from './routes/_authenticated.settings.workspaces.new';
import { Route as AuthenticatedSettingsTeamInviteGuestRouteImport } from './routes/_authenticated.settings.team.invite-guest';
import { Route as AuthenticatedSettingsTeamAddRouteImport } from './routes/_authenticated.settings.team.add';
import { Route as AuthenticatedSettingsSlackAgentLinkRouteImport } from './routes/_authenticated.settings.slack-agent_.link';
import { Route as AuthenticatedSettingsSecuritySsoRouteImport } from './routes/_authenticated.settings.security.sso';
import { Route as AuthenticatedSettingsRolesNewRouteImport } from './routes/_authenticated.settings.roles.new';
import { Route as AuthenticatedSettingsRolesRoleIdRouteImport } from './routes/_authenticated.settings.roles.$roleId';
import { Route as AuthenticatedSettingsPersonalGoogleIdentitiesRouteImport } from './routes/_authenticated.settings.personal.google-identities';
import { Route as AuthenticatedSettingsPartnerCreateRouteImport } from './routes/_authenticated.settings.partner.create';
import { Route as AuthenticatedSettingsBillingYourPlanRouteImport } from './routes/_authenticated.settings.billing.your-plan';
import { Route as AuthenticatedSettingsBillingUsageRouteImport } from './routes/_authenticated.settings.billing.usage';
import { Route as AuthenticatedSettingsBillingProfileGrowthRouteImport } from './routes/_authenticated.settings.billing.profile-growth';
import { Route as AuthenticatedSettingsBillingPaymentMethodsRouteImport } from './routes/_authenticated.settings.billing.payment-methods';
import { Route as AuthenticatedSettingsBillingOverviewRouteImport } from './routes/_authenticated.settings.billing.overview';
import { Route as AuthenticatedSettingsBillingLlmUsageRouteImport } from './routes/_authenticated.settings.billing.llm-usage';
import { Route as AuthenticatedSettingsBillingInboxPreviewUsageRouteImport } from './routes/_authenticated.settings.billing.inbox-preview-usage';
import { Route as AuthenticatedSettingsBillingCheckoutRouteImport } from './routes/_authenticated.settings.billing.checkout';
import { Route as AuthenticatedSettingsBillingBillingHistoryRouteImport } from './routes/_authenticated.settings.billing.billing-history';
import { Route as AuthenticatedSettingsBillingBillingDetailsRouteImport } from './routes/_authenticated.settings.billing.billing-details';
import { Route as AuthenticatedSettingsBillingSplatRouteImport } from './routes/_authenticated.settings.billing.$';
import { Route as AuthenticatedSettingsAccountEditRouteImport } from './routes/_authenticated.settings.account.edit';
import { Route as AuthenticatedWorkspacesWorkspaceIdTemplateIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.template.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdSnippetsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.snippets.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdProfilesIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.profiles.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdPeopleIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.people.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdParcelIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.parcel.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdOutcomesIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.outcomes.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdObjectsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.objects.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdImportsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.imports.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdHomeIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.home.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdGeosetsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.geosets.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdExperimentsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.experiments.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdDesignStudioIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.design-studio.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdBoardsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.boards.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdAgentIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.agent.index';
import { Route as AuthenticatedSettingsBillingAvailablePlansIndexRouteImport } from './routes/_authenticated.settings.billing.available-plans.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdTemplateTemplateIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.template.$templateId';
import { Route as AuthenticatedWorkspacesWorkspaceIdSnippetsNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.snippets.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdSnippetsSnippetIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.snippets.$snippetId';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsSuppressionsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.suppressions';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.subscription_center';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsMerge_optionsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.merge_options';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.llm_configuration';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsLanguageRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.language';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsGeofencesRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.geofences';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsEditRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.edit';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsConfirm_deleteRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.confirm_delete';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsAuto_archiveRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.auto_archive';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsAuditLogsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.audit-logs';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsApiKeysRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.api-keys';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsAnonymous_eventsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.anonymous_events';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsAiBusinessProfileRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.ai-business-profile';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsSplatRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.$';
import { Route as AuthenticatedWorkspacesWorkspaceIdReportsEmailClientsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.reports.email-clients';
import { Route as AuthenticatedWorkspacesWorkspaceIdReportsDeliverabilityRouteImport } from './routes/_authenticated.workspaces.$workspaceId.reports.deliverability';
import { Route as AuthenticatedWorkspacesWorkspaceIdProfilesWelcomeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.profiles.welcome';
import { Route as AuthenticatedWorkspacesWorkspaceIdProfilesNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.profiles.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdProfilesMergeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.profiles.merge';
import { Route as AuthenticatedWorkspacesWorkspaceIdProfilesCreateRouteImport } from './routes/_authenticated.workspaces.$workspaceId.profiles.create';
import { Route as AuthenticatedWorkspacesWorkspaceIdPeopleWelcomeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.people.welcome';
import { Route as AuthenticatedWorkspacesWorkspaceIdPeopleNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.people.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdPeopleMergeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.people.merge';
import { Route as AuthenticatedWorkspacesWorkspaceIdPeopleCreateRouteImport } from './routes/_authenticated.workspaces.$workspaceId.people.create';
import { Route as AuthenticatedWorkspacesWorkspaceIdParcelSplatRouteImport } from './routes/_authenticated.workspaces.$workspaceId.parcel.$';
import { Route as AuthenticatedWorkspacesWorkspaceIdOutcomesGoalIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.outcomes.$goalId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysTasksRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.tasks';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.snippets';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.settings';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysMessageLibraryRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.message-library';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.geofences';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysExportsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.exports';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysDraftsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.drafts';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysDeliveriesRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.deliveries';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.collections';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysAssetsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.assets';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysSplatRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.$';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_outRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.segment_out';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_inRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.segment_in';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsMparticle_outRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.mparticle_out';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsCustomerioRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.customerio';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_outRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.cdp_out';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_inRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.cdp_in';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.all';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsTypeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.$type';
import { Route as AuthenticatedWorkspacesWorkspaceIdImportsNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.imports.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteImport } from './routes/_authenticated.workspaces.$workspaceId.home.workspace-setup';
import { Route as AuthenticatedWorkspacesWorkspaceIdHomeAddPeopleRouteImport } from './routes/_authenticated.workspaces.$workspaceId.home.add-people';
import { Route as AuthenticatedWorkspacesWorkspaceIdGeosetsNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.geosets.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdGeosetsImportRouteImport } from './routes/_authenticated.workspaces.$workspaceId.geosets.import';
import { Route as AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.geosets.$geosetId';
import { Route as AuthenticatedWorkspacesWorkspaceIdExperimentsNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.experiments.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdExperimentsExperimentIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.experiments.$experimentId';
import { Route as AuthenticatedWorkspacesWorkspaceIdDevConditionViewerRouteImport } from './routes/_authenticated.workspaces.$workspaceId.dev.condition-viewer';
import { Route as AuthenticatedWorkspacesWorkspaceIdDesignStudioGlobalStylesRouteImport } from './routes/_authenticated.workspaces.$workspaceId.design-studio_.global-styles';
import { Route as AuthenticatedWorkspacesWorkspaceIdDesignStudioDashboardRouteImport } from './routes/_authenticated.workspaces.$workspaceId.design-studio_.dashboard';
import { Route as AuthenticatedWorkspacesWorkspaceIdDesignStudioSplatRouteImport } from './routes/_authenticated.workspaces.$workspaceId.design-studio.$';
import { Route as AuthenticatedWorkspacesWorkspaceIdBoardsBoardIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.boards.$boardId';
import { Route as AuthenticatedWorkspacesWorkspaceIdAnalysisEmailClientsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.analysis.email-clients';
import { Route as AuthenticatedWorkspacesWorkspaceIdAnalysisDeliverabilityRouteImport } from './routes/_authenticated.workspaces.$workspaceId.analysis.deliverability';
import { Route as AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.agent.skills';
import { Route as AuthenticatedWorkspacesWorkspaceIdAgentRoutinesRouteImport } from './routes/_authenticated.workspaces.$workspaceId.agent.routines';
import { Route as AuthenticatedSettingsTeamJoinRequestsRequestIdRouteImport } from './routes/_authenticated.settings.team.join-requests.$requestId';
import { Route as AuthenticatedSettingsBillingAvailablePlansJourneysRouteImport } from './routes/_authenticated.settings.billing.available-plans.journeys';
import { Route as AuthenticatedSettingsApi_credentialsService_accountsServiceAccountIdRouteImport } from './routes/_authenticated.settings.api_credentials.service_accounts.$serviceAccountId';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.webhook_configuration.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.subscription_center.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsObjectsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.objects.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.llm_configuration.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.api_credentials.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdObjectsSlugIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.objects.$slug.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.triggered.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysTemplateIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.template.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.snippets.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysProfilesIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.profiles.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.profile_activity.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysPeopleIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.people.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysObjectsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.objects.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.layouts.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysImportsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.imports.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.geofences.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.collections.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.activity_logs.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.reporting-webhooks.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsAllIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.all.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdImportsImportIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.imports.$importId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.home.workspace-setup.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.geosets.$geosetId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdAgentSkillsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.agent.skills.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.webhook_configuration.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerSettingsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.subscription_center.settings';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsObjectsNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.objects.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.llm_configuration.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.url_params';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrban_airshipRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.urban_airship';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsTime_zone_matchRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.time_zone_match';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.sms-providers';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsSlackRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.slack';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessaging_limitRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.messaging_limit';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessage_frequency_limitsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.message_frequency_limits';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsLineRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.line';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.email';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesJourneysRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.journeys';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.add';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.$sourceId';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsJourneysRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.journeys';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.add';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.$destinationId';
import { Route as AuthenticatedWorkspacesWorkspaceIdObjectsSlugNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.objects.$slug.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdObjectsSlugGuideRouteImport } from './routes/_authenticated.workspaces.$workspaceId.objects.$slug.guide';
import { Route as AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.objects.$slug.$objectId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysV2SplatRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.v2.$';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.triggered.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysTemplateTemplateIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.template.$templateId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.snippets.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsSnippetIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.snippets.$snippetId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysSetupGuideSplatRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.setup-guide.$';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysSettingsSplatRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.settings.$';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysProfilesWelcomeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.profiles.welcome';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysProfilesNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.profiles.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysProfilesMergeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.profiles.merge';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysProfilesCreateRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.profiles.create';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityTabRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.profile_activity.$tab';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysPeopleWelcomeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.people.welcome';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysPeopleNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.people.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysPeopleMergeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.people.merge';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysPeopleCreateRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.people.create';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysOutboxSplatRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.outbox.$';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysMessage_activitySplatRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.message_activity.$';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsStartersRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.layouts.starters';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.layouts.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_outRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.segment_out';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_inRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.segment_in';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.reporting-webhooks';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsMparticle_outRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.mparticle_out';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCustomerioRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.customerio';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_outRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.cdp_out';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_inRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.cdp_in';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.all';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsTypeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.$type';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysImportsNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.imports.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.geofences.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesGeofenceIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.geofences.$geofenceId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.collections.$collectionId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisDeliverabilityRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.analysis.deliverability';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsTabRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.activity_logs.$tab';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseSnowflakeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.warehouse.snowflake';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseRedshiftRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.warehouse.redshift';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseBigqueryRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.warehouse.bigquery';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.warehouse.$type';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.sql-sync.$type';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.reporting-webhooks.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksWebhookIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.reporting-webhooks.$webhookId';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsData_outTypeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.data_out.$type';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsAllWebhooksRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.all.webhooks';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsAllOverviewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.all.overview';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDirectoryRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.all.directory';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDevelopersRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.all.developers';
import { Route as AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupAddPeopleRouteImport } from './routes/_authenticated.workspaces.$workspaceId.home.workspace-setup.add-people';
import { Route as AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRouteImport } from './routes/_authenticated.workspaces.$workspaceId.geosets.$geosetId.geofences';
import { Route as AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdEditRouteImport } from './routes/_authenticated.workspaces.$workspaceId.geosets.$geosetId.edit';
import { Route as AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.dev.db.campaigns';
import { Route as AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdWorkflowRouteImport } from './routes/_authenticated.workspaces.$workspaceId.automations.$campaignId.workflow';
import { Route as AuthenticatedWorkspacesWorkspaceIdAgentSkillsNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.agent.skills.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdAgentSkillsSkillPathRouteImport } from './routes/_authenticated.workspaces.$workspaceId.agent.skills.$skillPath';
import { Route as AuthenticatedSettingsTeamMembersUserIdEditRouteImport } from './routes/_authenticated.settings.team.members.$userId.edit';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.subscription_center.topics.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.url_params.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.sms-providers.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.email.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.$sourceId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.$destinationId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.objects.$slug.$objectId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.objects.$slug.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.layouts.$layoutId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.reporting-webhooks.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.all.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.imports.$importId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.collections.$collectionId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.sql-sync.$type.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.imports.$importId.setup.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.geosets.$geosetId.geofences.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.dev.db.campaigns.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationWebhookIdEditRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.webhook_configuration.$webhookId.edit';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsSet_preferencesRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.subscription_center.topics.set_preferences';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerLocalizationEditRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.subscription_center.localization.edit';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerBrandingEditRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.subscription_center.branding.edit';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsObjectsEditObjectTypeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.objects.edit.$objectType';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationConfigurationIdEditRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.llm_configuration.$configurationId.edit';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsService_accountsServiceAccountIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.api_credentials.service_accounts.$serviceAccountId';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsEditRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.url_params.edit';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSuppression_listRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.email.suppression_list';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSmtpRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.email.smtp';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailFrom_addressesRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.email.from_addresses';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDynamic_addressesRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.email.dynamic_addresses';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDeliverabilityRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.email.deliverability';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDefaultsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.email.defaults';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddSourceOptionIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.add_.$sourceOptionId';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.$sourceId.syncs';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSettingsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.$sourceId.settings';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdImportsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.$sourceId.imports';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDatabasesRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.$sourceId.databases';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDataInRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.$sourceId.data-in';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddDestinationOptionIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.add_.$destinationOptionId';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdTesterRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.$destinationId.tester';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.$destinationId.subscriptions';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSettingsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.$destinationId.settings';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdExportsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.$destinationId.exports';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdDataOutRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.$destinationId.data-out';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.objects.$slug.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugGuideRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.objects.$slug.guide';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdEditRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.layouts.$layoutId.edit';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseSnowflakeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.warehouse.snowflake';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseRedshiftRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.warehouse.redshift';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseBigqueryRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.warehouse.bigquery';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.warehouse.$type';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.sql-sync.$type';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.reporting-webhooks.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksWebhookIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.reporting-webhooks.$webhookId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsData_outTypeRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.data_out.$type';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllWebhooksRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.all.webhooks';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllOverviewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.all.overview';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDirectoryRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.all.directory';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDevelopersRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.all.developers';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdUsageRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.collections.$collectionId.usage';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdImportingRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.collections.$collectionId.importing';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdDataRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.collections.$collectionId.data';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdSplatRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.collections.$collectionId.$';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeSyncRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.warehouse.$type_.sync';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.sql-sync.$type.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.sql-sync.$type.$sqlImportId';
import { Route as AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupValidatingRouteImport } from './routes/_authenticated.workspaces.$workspaceId.imports.$importId.setup.validating';
import { Route as AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupReviewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.imports.$importId.setup.review';
import { Route as AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreviewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.imports.$importId.setup.preview';
import { Route as AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreprocessingRouteImport } from './routes/_authenticated.workspaces.$workspaceId.imports.$importId.setup.preprocessing';
import { Route as AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupImportingRouteImport } from './routes/_authenticated.workspaces.$workspaceId.imports.$importId.setup.importing';
import { Route as AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupFieldsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.imports.$importId.setup.fields';
import { Route as AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.geosets.$geosetId.geofences.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesImportRouteImport } from './routes/_authenticated.workspaces.$workspaceId.geosets.$geosetId.geofences.import';
import { Route as AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesGeofenceIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.geosets.$geosetId.geofences.$geofenceId';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.email.sending_domains.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.$destinationId.subscriptions.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.objects.$slug.$objectId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.sql-sync.$type.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.imports.$importId.setup.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdIndexRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.sql-sync.$type.$sqlImportId.index';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersCredentialsCredentialIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.sms-providers.credentials.$credentialId';
import { Route as AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsDomainIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.settings.actions.email.sending_domains.$domainId';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsAddRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.$sourceId_.syncs.add';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsSyncIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.sources.$sourceId_.syncs.$syncId';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsAddRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.$destinationId.subscriptions.add';
import { Route as AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsSubscriptionIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.pipelines.destinations.$destinationId.subscriptions.$subscriptionId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeSyncRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.warehouse.$type_.sync';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeNewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.sql-sync.$type.new';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.sql-sync.$type.$sqlImportId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupValidatingRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.imports.$importId.setup.validating';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupReviewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.imports.$importId.setup.review';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreviewRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.imports.$importId.setup.preview';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreprocessingRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.imports.$importId.setup.preprocessing';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupImportingRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.imports.$importId.setup.importing';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupFieldsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.imports.$importId.setup.fields';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdSettingsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.sql-sync.$type.$sqlImportId.settings';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.sql-sync.$type.$sqlImportId.relationships-query';
import { Route as AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdQueryRouteImport } from './routes/_authenticated.workspaces.$workspaceId.integrations.sql-sync.$type.$sqlImportId.query';
import { Route as AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsActionsActionIdRouteImport } from './routes/_authenticated.workspaces.$workspaceId.dev.db.campaigns.actions.$actionId';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdSettingsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.sql-sync.$type.$sqlImportId_.settings';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.sql-sync.$type.$sqlImportId_.relationships-query';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdQueryRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.integrations.sql-sync.$type.$sqlImportId_.query';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdSetupWorkflowActionsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.campaigns.$campaignId.setup.workflow.actions';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewWorkflowActionsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.campaigns.$campaignId.overview.workflow.actions';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdSetupWorkflowActionsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.automations.$campaignId.setup.workflow.actions';
import { Route as AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewWorkflowActionsRouteImport } from './routes/_authenticated.workspaces.$workspaceId.journeys.automations.$campaignId.overview.workflow.actions';

const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any);
const JoinRequestRoute = JoinRequestRouteImport.update({
  id: '/join-request',
  path: '/join-request',
  getParentRoute: () => rootRouteImport,
} as any);
const DesignStudioEmbedRoute = DesignStudioEmbedRouteImport.update({
  id: '/design-studio-embed',
  path: '/design-studio-embed',
  getParentRoute: () => rootRouteImport,
} as any);
const CliRoute = CliRouteImport.update({
  id: '/cli',
  path: '/cli',
  getParentRoute: () => rootRouteImport,
} as any);
const CheckoutRoute = CheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => rootRouteImport,
} as any);
const AcceptGuestInvitationRoute = AcceptGuestInvitationRouteImport.update({
  id: '/accept-guest-invitation',
  path: '/accept-guest-invitation',
  getParentRoute: () => rootRouteImport,
} as any);
const AcademyLoginRoute = AcademyLoginRouteImport.update({
  id: '/academy-login',
  path: '/academy-login',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any);
const OnboardingIndexRoute = OnboardingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OnboardingRoute,
} as any);
const CliIndexRoute = CliIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CliRoute,
} as any);
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const VwbDemoSplatRoute = VwbDemoSplatRouteImport.update({
  id: '/vwb-demo/$',
  path: '/vwb-demo/$',
  getParentRoute: () => rootRouteImport,
} as any);
const UsersSplatRoute = UsersSplatRouteImport.update({
  id: '/users/$',
  path: '/users/$',
  getParentRoute: () => rootRouteImport,
} as any);
const SignupSplatRoute = SignupSplatRouteImport.update({
  id: '/signup/$',
  path: '/signup/$',
  getParentRoute: () => rootRouteImport,
} as any);
const Reset_passwordSplatRoute = Reset_passwordSplatRouteImport.update({
  id: '/reset_password/$',
  path: '/reset_password/$',
  getParentRoute: () => rootRouteImport,
} as any);
const Post_registrationSplatRoute = Post_registrationSplatRouteImport.update({
  id: '/post_registration/$',
  path: '/post_registration/$',
  getParentRoute: () => rootRouteImport,
} as any);
const Post_cancelSplatRoute = Post_cancelSplatRouteImport.update({
  id: '/post_cancel/$',
  path: '/post_cancel/$',
  getParentRoute: () => rootRouteImport,
} as any);
const OnboardingWizardRoute = OnboardingWizardRouteImport.update({
  id: '/wizard',
  path: '/wizard',
  getParentRoute: () => OnboardingRoute,
} as any);
const OnboardingVerificationRoute = OnboardingVerificationRouteImport.update({
  id: '/verification',
  path: '/verification',
  getParentRoute: () => OnboardingRoute,
} as any);
const OnboardingGetStartedRoute = OnboardingGetStartedRouteImport.update({
  id: '/get-started',
  path: '/get-started',
  getParentRoute: () => OnboardingRoute,
} as any);
const Oauth2SplatRoute = Oauth2SplatRouteImport.update({
  id: '/oauth2/$',
  path: '/oauth2/$',
  getParentRoute: () => rootRouteImport,
} as any);
const OauthSplatRoute = OauthSplatRouteImport.update({
  id: '/oauth/$',
  path: '/oauth/$',
  getParentRoute: () => rootRouteImport,
} as any);
const No_accessible_workspacesSplatRoute =
  No_accessible_workspacesSplatRouteImport.update({
    id: '/no_accessible_workspaces/$',
    path: '/no_accessible_workspaces/$',
    getParentRoute: () => rootRouteImport,
  } as any);
const LogoutSplatRoute = LogoutSplatRouteImport.update({
  id: '/logout/$',
  path: '/logout/$',
  getParentRoute: () => rootRouteImport,
} as any);
const LoginSplatRoute = LoginSplatRouteImport.update({
  id: '/login/$',
  path: '/login/$',
  getParentRoute: () => rootRouteImport,
} as any);
const JourneysSplatRoute = JourneysSplatRouteImport.update({
  id: '/journeys/$',
  path: '/journeys/$',
  getParentRoute: () => rootRouteImport,
} as any);
const IntegrationsSplatRoute = IntegrationsSplatRouteImport.update({
  id: '/integrations/$',
  path: '/integrations/$',
  getParentRoute: () => rootRouteImport,
} as any);
const HarSanitizerSplatRoute = HarSanitizerSplatRouteImport.update({
  id: '/har-sanitizer/$',
  path: '/har-sanitizer/$',
  getParentRoute: () => rootRouteImport,
} as any);
const EnvSplatRoute = EnvSplatRouteImport.update({
  id: '/env/$',
  path: '/env/$',
  getParentRoute: () => rootRouteImport,
} as any);
const Confirm_account_noticeSplatRoute =
  Confirm_account_noticeSplatRouteImport.update({
    id: '/confirm_account_notice/$',
    path: '/confirm_account_notice/$',
    getParentRoute: () => rootRouteImport,
  } as any);
const Confirm_accountSplatRoute = Confirm_accountSplatRouteImport.update({
  id: '/confirm_account/$',
  path: '/confirm_account/$',
  getParentRoute: () => rootRouteImport,
} as any);
const CliDnsSetupRoute = CliDnsSetupRouteImport.update({
  id: '/dns-setup',
  path: '/dns-setup',
  getParentRoute: () => CliRoute,
} as any);
const Account_cancelledSplatRoute = Account_cancelledSplatRouteImport.update({
  id: '/account_cancelled/$',
  path: '/account_cancelled/$',
  getParentRoute: () => rootRouteImport,
} as any);
const Account_canceledSplatRoute = Account_canceledSplatRouteImport.update({
  id: '/account_canceled/$',
  path: '/account_canceled/$',
  getParentRoute: () => rootRouteImport,
} as any);
const AccountSplatRoute = AccountSplatRouteImport.update({
  id: '/account/$',
  path: '/account/$',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedWorkspacesRoute = AuthenticatedWorkspacesRouteImport.update({
  id: '/workspaces',
  path: '/workspaces',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedSplatRoute = AuthenticatedSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const R2fa_setupSplatRoute = R2fa_setupSplatRouteImport.update({
  id: '/2fa_setup/$',
  path: '/2fa_setup/$',
  getParentRoute: () => rootRouteImport,
} as any);
const DesignStudioEmbedCioIndexRoute =
  DesignStudioEmbedCioIndexRouteImport.update({
    id: '/cio/',
    path: '/cio/',
    getParentRoute: () => DesignStudioEmbedRoute,
  } as any);
const AuthenticatedWorkspacesIndexRoute =
  AuthenticatedWorkspacesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesRoute,
  } as any);
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSampleWorkspaceIndexRoute =
  AuthenticatedSampleWorkspaceIndexRouteImport.update({
    id: '/sample-workspace/',
    path: '/sample-workspace/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedInternalToolsIndexRoute =
  AuthenticatedInternalToolsIndexRouteImport.update({
    id: '/internal-tools/',
    path: '/internal-tools/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const DesignStudioEmbedCioSplatRoute =
  DesignStudioEmbedCioSplatRouteImport.update({
    id: '/cio/$',
    path: '/cio/$',
    getParentRoute: () => DesignStudioEmbedRoute,
  } as any);
const AccountCancelledSplatRoute = AccountCancelledSplatRouteImport.update({
  id: '/account/cancelled/$',
  path: '/account/cancelled/$',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedWorkspacesWorkspaceIdRoute =
  AuthenticatedWorkspacesWorkspaceIdRouteImport.update({
    id: '/$workspaceId',
    path: '/$workspaceId',
    getParentRoute: () => AuthenticatedWorkspacesRoute,
  } as any);
const AuthenticatedTrialExpiredJourneysRoute =
  AuthenticatedTrialExpiredJourneysRouteImport.update({
    id: '/trial-expired/journeys',
    path: '/trial-expired/journeys',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsSubscriptionRoute =
  AuthenticatedSettingsSubscriptionRouteImport.update({
    id: '/settings/subscription',
    path: '/settings/subscription',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsSlackAgentRoute =
  AuthenticatedSettingsSlackAgentRouteImport.update({
    id: '/settings/slack-agent',
    path: '/settings/slack-agent',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsReceiptsRoute =
  AuthenticatedSettingsReceiptsRouteImport.update({
    id: '/settings/receipts',
    path: '/settings/receipts',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsPrivacyRoute =
  AuthenticatedSettingsPrivacyRouteImport.update({
    id: '/settings/privacy',
    path: '/settings/privacy',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsPartnerRoute =
  AuthenticatedSettingsPartnerRouteImport.update({
    id: '/settings/partner',
    path: '/settings/partner',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsExperimentalFeaturesRoute =
  AuthenticatedSettingsExperimentalFeaturesRouteImport.update({
    id: '/settings/experimental-features',
    path: '/settings/experimental-features',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsBillingRoute =
  AuthenticatedSettingsBillingRouteImport.update({
    id: '/settings/billing',
    path: '/settings/billing',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsAuditLogsRoute =
  AuthenticatedSettingsAuditLogsRouteImport.update({
    id: '/settings/audit-logs',
    path: '/settings/audit-logs',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsApiKeysRoute =
  AuthenticatedSettingsApiKeysRouteImport.update({
    id: '/settings/api-keys',
    path: '/settings/api-keys',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsAiRoute = AuthenticatedSettingsAiRouteImport.update({
  id: '/settings/ai',
  path: '/settings/ai',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedSettingsSplatRoute =
  AuthenticatedSettingsSplatRouteImport.update({
    id: '/settings/$',
    path: '/settings/$',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSampleWorkspaceSplatRoute =
  AuthenticatedSampleWorkspaceSplatRouteImport.update({
    id: '/sample-workspace/$',
    path: '/sample-workspace/$',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedInternalToolsSplatRoute =
  AuthenticatedInternalToolsSplatRouteImport.update({
    id: '/internal-tools/$',
    path: '/internal-tools/$',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const PipelinesWorkspacesWorkspaceIdIndexRoute =
  PipelinesWorkspacesWorkspaceIdIndexRouteImport.update({
    id: '/pipelines/workspaces/$workspaceId/',
    path: '/pipelines/workspaces/$workspaceId/',
    getParentRoute: () => rootRouteImport,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedSettingsWorkspacesIndexRoute =
  AuthenticatedSettingsWorkspacesIndexRouteImport.update({
    id: '/settings/workspaces/',
    path: '/settings/workspaces/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsTeamIndexRoute =
  AuthenticatedSettingsTeamIndexRouteImport.update({
    id: '/settings/team/',
    path: '/settings/team/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsSecurityIndexRoute =
  AuthenticatedSettingsSecurityIndexRouteImport.update({
    id: '/settings/security/',
    path: '/settings/security/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsRolesIndexRoute =
  AuthenticatedSettingsRolesIndexRouteImport.update({
    id: '/settings/roles/',
    path: '/settings/roles/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsPersonalIndexRoute =
  AuthenticatedSettingsPersonalIndexRouteImport.update({
    id: '/settings/personal/',
    path: '/settings/personal/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsPartnerIndexRoute =
  AuthenticatedSettingsPartnerIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsPartnerRoute,
  } as any);
const AuthenticatedSettingsBillingIndexRoute =
  AuthenticatedSettingsBillingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsBillingRoute,
  } as any);
const AuthenticatedSettingsApi_credentialsIndexRoute =
  AuthenticatedSettingsApi_credentialsIndexRouteImport.update({
    id: '/settings/api_credentials/',
    path: '/settings/api_credentials/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsAccountIndexRoute =
  AuthenticatedSettingsAccountIndexRouteImport.update({
    id: '/settings/account/',
    path: '/settings/account/',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const PipelinesWorkspacesWorkspaceIdSplatRoute =
  PipelinesWorkspacesWorkspaceIdSplatRouteImport.update({
    id: '/pipelines/workspaces/$workspaceId/$',
    path: '/pipelines/workspaces/$workspaceId/$',
    getParentRoute: () => rootRouteImport,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdTasksRoute =
  AuthenticatedWorkspacesWorkspaceIdTasksRouteImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSnippetsRoute =
  AuthenticatedWorkspacesWorkspaceIdSnippetsRouteImport.update({
    id: '/snippets',
    path: '/snippets',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdOutcomesRoute =
  AuthenticatedWorkspacesWorkspaceIdOutcomesRouteImport.update({
    id: '/outcomes',
    path: '/outcomes',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdMessageLibraryRoute =
  AuthenticatedWorkspacesWorkspaceIdMessageLibraryRouteImport.update({
    id: '/message-library',
    path: '/message-library',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysRouteImport.update({
    id: '/journeys_',
    path: '/journeys',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdHomeRoute =
  AuthenticatedWorkspacesWorkspaceIdHomeRouteImport.update({
    id: '/home',
    path: '/home',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdHealthRoute =
  AuthenticatedWorkspacesWorkspaceIdHealthRouteImport.update({
    id: '/health',
    path: '/health',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdGeosetsRoute =
  AuthenticatedWorkspacesWorkspaceIdGeosetsRouteImport.update({
    id: '/geosets',
    path: '/geosets',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdExportsRoute =
  AuthenticatedWorkspacesWorkspaceIdExportsRouteImport.update({
    id: '/exports',
    path: '/exports',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdExperimentsRoute =
  AuthenticatedWorkspacesWorkspaceIdExperimentsRouteImport.update({
    id: '/experiments',
    path: '/experiments',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdDesignStudioRoute =
  AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteImport.update({
    id: '/design-studio',
    path: '/design-studio',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAssetsRoute =
  AuthenticatedWorkspacesWorkspaceIdAssetsRouteImport.update({
    id: '/assets',
    path: '/assets',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAgentRoute =
  AuthenticatedWorkspacesWorkspaceIdAgentRouteImport.update({
    id: '/agent',
    path: '/agent',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSplatRoute =
  AuthenticatedWorkspacesWorkspaceIdSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedSettingsWorkspacesNewRoute =
  AuthenticatedSettingsWorkspacesNewRouteImport.update({
    id: '/settings/workspaces/new',
    path: '/settings/workspaces/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsTeamInviteGuestRoute =
  AuthenticatedSettingsTeamInviteGuestRouteImport.update({
    id: '/settings/team/invite-guest',
    path: '/settings/team/invite-guest',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsTeamAddRoute =
  AuthenticatedSettingsTeamAddRouteImport.update({
    id: '/settings/team/add',
    path: '/settings/team/add',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsSlackAgentLinkRoute =
  AuthenticatedSettingsSlackAgentLinkRouteImport.update({
    id: '/settings/slack-agent_/link',
    path: '/settings/slack-agent/link',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsSecuritySsoRoute =
  AuthenticatedSettingsSecuritySsoRouteImport.update({
    id: '/settings/security/sso',
    path: '/settings/security/sso',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsRolesNewRoute =
  AuthenticatedSettingsRolesNewRouteImport.update({
    id: '/settings/roles/new',
    path: '/settings/roles/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsRolesRoleIdRoute =
  AuthenticatedSettingsRolesRoleIdRouteImport.update({
    id: '/settings/roles/$roleId',
    path: '/settings/roles/$roleId',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsPersonalGoogleIdentitiesRoute =
  AuthenticatedSettingsPersonalGoogleIdentitiesRouteImport.update({
    id: '/settings/personal/google-identities',
    path: '/settings/personal/google-identities',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsPartnerCreateRoute =
  AuthenticatedSettingsPartnerCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthenticatedSettingsPartnerRoute,
  } as any);
const AuthenticatedSettingsBillingYourPlanRoute =
  AuthenticatedSettingsBillingYourPlanRouteImport.update({
    id: '/your-plan',
    path: '/your-plan',
    getParentRoute: () => AuthenticatedSettingsBillingRoute,
  } as any);
const AuthenticatedSettingsBillingUsageRoute =
  AuthenticatedSettingsBillingUsageRouteImport.update({
    id: '/usage',
    path: '/usage',
    getParentRoute: () => AuthenticatedSettingsBillingRoute,
  } as any);
const AuthenticatedSettingsBillingProfileGrowthRoute =
  AuthenticatedSettingsBillingProfileGrowthRouteImport.update({
    id: '/profile-growth',
    path: '/profile-growth',
    getParentRoute: () => AuthenticatedSettingsBillingRoute,
  } as any);
const AuthenticatedSettingsBillingPaymentMethodsRoute =
  AuthenticatedSettingsBillingPaymentMethodsRouteImport.update({
    id: '/payment-methods',
    path: '/payment-methods',
    getParentRoute: () => AuthenticatedSettingsBillingRoute,
  } as any);
const AuthenticatedSettingsBillingOverviewRoute =
  AuthenticatedSettingsBillingOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AuthenticatedSettingsBillingRoute,
  } as any);
const AuthenticatedSettingsBillingLlmUsageRoute =
  AuthenticatedSettingsBillingLlmUsageRouteImport.update({
    id: '/llm-usage',
    path: '/llm-usage',
    getParentRoute: () => AuthenticatedSettingsBillingRoute,
  } as any);
const AuthenticatedSettingsBillingInboxPreviewUsageRoute =
  AuthenticatedSettingsBillingInboxPreviewUsageRouteImport.update({
    id: '/inbox-preview-usage',
    path: '/inbox-preview-usage',
    getParentRoute: () => AuthenticatedSettingsBillingRoute,
  } as any);
const AuthenticatedSettingsBillingCheckoutRoute =
  AuthenticatedSettingsBillingCheckoutRouteImport.update({
    id: '/checkout',
    path: '/checkout',
    getParentRoute: () => AuthenticatedSettingsBillingRoute,
  } as any);
const AuthenticatedSettingsBillingBillingHistoryRoute =
  AuthenticatedSettingsBillingBillingHistoryRouteImport.update({
    id: '/billing-history',
    path: '/billing-history',
    getParentRoute: () => AuthenticatedSettingsBillingRoute,
  } as any);
const AuthenticatedSettingsBillingBillingDetailsRoute =
  AuthenticatedSettingsBillingBillingDetailsRouteImport.update({
    id: '/billing-details',
    path: '/billing-details',
    getParentRoute: () => AuthenticatedSettingsBillingRoute,
  } as any);
const AuthenticatedSettingsBillingSplatRoute =
  AuthenticatedSettingsBillingSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => AuthenticatedSettingsBillingRoute,
  } as any);
const AuthenticatedSettingsAccountEditRoute =
  AuthenticatedSettingsAccountEditRouteImport.update({
    id: '/settings/account/edit',
    path: '/settings/account/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdTemplateIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdTemplateIndexRouteImport.update({
    id: '/template/',
    path: '/template/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSnippetsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdSnippetsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdSnippetsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdProfilesIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdProfilesIndexRouteImport.update({
    id: '/profiles/',
    path: '/profiles/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPipelinesIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesIndexRouteImport.update({
    id: '/pipelines/',
    path: '/pipelines/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPeopleIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdPeopleIndexRouteImport.update({
    id: '/people/',
    path: '/people/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdParcelIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdParcelIndexRouteImport.update({
    id: '/parcel/',
    path: '/parcel/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdOutcomesIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdOutcomesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdOutcomesRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdObjectsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdObjectsIndexRouteImport.update({
    id: '/objects/',
    path: '/objects/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdIntegrationsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsIndexRouteImport.update({
    id: '/integrations/',
    path: '/integrations/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdImportsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdImportsIndexRouteImport.update({
    id: '/imports/',
    path: '/imports/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdHomeIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdHomeIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdHomeRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdGeosetsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdGeosetsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdGeosetsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdExperimentsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdExperimentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdExperimentsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdDesignStudioIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdDesignStudioIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdDesignStudioRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdBoardsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdBoardsIndexRouteImport.update({
    id: '/boards/',
    path: '/boards/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAgentIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdAgentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdAgentRoute,
  } as any);
const AuthenticatedSettingsBillingAvailablePlansIndexRoute =
  AuthenticatedSettingsBillingAvailablePlansIndexRouteImport.update({
    id: '/available-plans/',
    path: '/available-plans/',
    getParentRoute: () => AuthenticatedSettingsBillingRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdTemplateTemplateIdRoute =
  AuthenticatedWorkspacesWorkspaceIdTemplateTemplateIdRouteImport.update({
    id: '/template/$templateId',
    path: '/template/$templateId',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSnippetsNewRoute =
  AuthenticatedWorkspacesWorkspaceIdSnippetsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdSnippetsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSnippetsSnippetIdRoute =
  AuthenticatedWorkspacesWorkspaceIdSnippetsSnippetIdRouteImport.update({
    id: '/$snippetId',
    path: '/$snippetId',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdSnippetsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsSuppressionsRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsSuppressionsRouteImport.update({
    id: '/settings/suppressions',
    path: '/settings/suppressions',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRouteImport.update(
    {
      id: '/settings/subscription_center',
      path: '/settings/subscription_center',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsMerge_optionsRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsMerge_optionsRouteImport.update({
    id: '/settings/merge_options',
    path: '/settings/merge_options',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRouteImport.update(
    {
      id: '/settings/llm_configuration',
      path: '/settings/llm_configuration',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsLanguageRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsLanguageRouteImport.update({
    id: '/settings/language',
    path: '/settings/language',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsGeofencesRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsGeofencesRouteImport.update({
    id: '/settings/geofences',
    path: '/settings/geofences',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsEditRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsEditRouteImport.update({
    id: '/settings/edit',
    path: '/settings/edit',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsConfirm_deleteRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsConfirm_deleteRouteImport.update({
    id: '/settings/confirm_delete',
    path: '/settings/confirm_delete',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsAuto_archiveRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsAuto_archiveRouteImport.update({
    id: '/settings/auto_archive',
    path: '/settings/auto_archive',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsAuditLogsRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsAuditLogsRouteImport.update({
    id: '/settings/audit-logs',
    path: '/settings/audit-logs',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsApiKeysRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsApiKeysRouteImport.update({
    id: '/settings/api-keys',
    path: '/settings/api-keys',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsAnonymous_eventsRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsAnonymous_eventsRouteImport.update({
    id: '/settings/anonymous_events',
    path: '/settings/anonymous_events',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsAiBusinessProfileRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsAiBusinessProfileRouteImport.update(
    {
      id: '/settings/ai-business-profile',
      path: '/settings/ai-business-profile',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsSplatRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsSplatRouteImport.update({
    id: '/settings/$',
    path: '/settings/$',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdReportsEmailClientsRoute =
  AuthenticatedWorkspacesWorkspaceIdReportsEmailClientsRouteImport.update({
    id: '/reports/email-clients',
    path: '/reports/email-clients',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdReportsDeliverabilityRoute =
  AuthenticatedWorkspacesWorkspaceIdReportsDeliverabilityRouteImport.update({
    id: '/reports/deliverability',
    path: '/reports/deliverability',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdProfilesWelcomeRoute =
  AuthenticatedWorkspacesWorkspaceIdProfilesWelcomeRouteImport.update({
    id: '/profiles/welcome',
    path: '/profiles/welcome',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdProfilesNewRoute =
  AuthenticatedWorkspacesWorkspaceIdProfilesNewRouteImport.update({
    id: '/profiles/new',
    path: '/profiles/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdProfilesMergeRoute =
  AuthenticatedWorkspacesWorkspaceIdProfilesMergeRouteImport.update({
    id: '/profiles/merge',
    path: '/profiles/merge',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdProfilesCreateRoute =
  AuthenticatedWorkspacesWorkspaceIdProfilesCreateRouteImport.update({
    id: '/profiles/create',
    path: '/profiles/create',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPeopleWelcomeRoute =
  AuthenticatedWorkspacesWorkspaceIdPeopleWelcomeRouteImport.update({
    id: '/people/welcome',
    path: '/people/welcome',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPeopleNewRoute =
  AuthenticatedWorkspacesWorkspaceIdPeopleNewRouteImport.update({
    id: '/people/new',
    path: '/people/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPeopleMergeRoute =
  AuthenticatedWorkspacesWorkspaceIdPeopleMergeRouteImport.update({
    id: '/people/merge',
    path: '/people/merge',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPeopleCreateRoute =
  AuthenticatedWorkspacesWorkspaceIdPeopleCreateRouteImport.update({
    id: '/people/create',
    path: '/people/create',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdParcelSplatRoute =
  AuthenticatedWorkspacesWorkspaceIdParcelSplatRouteImport.update({
    id: '/parcel/$',
    path: '/parcel/$',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdOutcomesGoalIdRoute =
  AuthenticatedWorkspacesWorkspaceIdOutcomesGoalIdRouteImport.update({
    id: '/$goalId',
    path: '/$goalId',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdOutcomesRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysTasksRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysTasksRouteImport.update({
    id: '/journeys/tasks',
    path: '/journeys/tasks',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteImport.update({
    id: '/journeys/snippets',
    path: '/journeys/snippets',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteImport.update({
    id: '/journeys/settings',
    path: '/journeys/settings',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysMessageLibraryRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysMessageLibraryRouteImport.update({
    id: '/journeys/message-library',
    path: '/journeys/message-library',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteImport.update({
    id: '/journeys/geofences',
    path: '/journeys/geofences',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysExportsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysExportsRouteImport.update({
    id: '/journeys/exports',
    path: '/journeys/exports',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysDraftsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysDraftsRouteImport.update({
    id: '/journeys/drafts',
    path: '/journeys/drafts',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysDeliveriesRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysDeliveriesRouteImport.update({
    id: '/journeys/deliveries',
    path: '/journeys/deliveries',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRouteImport.update({
    id: '/journeys/collections',
    path: '/journeys/collections',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysAssetsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysAssetsRouteImport.update({
    id: '/journeys/assets',
    path: '/journeys/assets',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysSplatRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysSplatRouteImport.update({
    id: '/journeys/$',
    path: '/journeys/$',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_outRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_outRouteImport.update({
    id: '/integrations/segment_out',
    path: '/integrations/segment_out',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_inRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_inRouteImport.update({
    id: '/integrations/segment_in',
    path: '/integrations/segment_in',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdIntegrationsMparticle_outRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsMparticle_outRouteImport.update(
    {
      id: '/integrations/mparticle_out',
      path: '/integrations/mparticle_out',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsCustomerioRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsCustomerioRouteImport.update({
    id: '/integrations/customerio',
    path: '/integrations/customerio',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_outRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_outRouteImport.update({
    id: '/integrations/cdp_out',
    path: '/integrations/cdp_out',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_inRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_inRouteImport.update({
    id: '/integrations/cdp_in',
    path: '/integrations/cdp_in',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRouteImport.update({
    id: '/integrations/all',
    path: '/integrations/all',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdIntegrationsTypeRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsTypeRouteImport.update({
    id: '/integrations/$type',
    path: '/integrations/$type',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdImportsNewRoute =
  AuthenticatedWorkspacesWorkspaceIdImportsNewRouteImport.update({
    id: '/imports/new',
    path: '/imports/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRoute =
  AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteImport.update({
    id: '/workspace-setup',
    path: '/workspace-setup',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdHomeRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdHomeAddPeopleRoute =
  AuthenticatedWorkspacesWorkspaceIdHomeAddPeopleRouteImport.update({
    id: '/add-people',
    path: '/add-people',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdHomeRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdGeosetsNewRoute =
  AuthenticatedWorkspacesWorkspaceIdGeosetsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdGeosetsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdGeosetsImportRoute =
  AuthenticatedWorkspacesWorkspaceIdGeosetsImportRouteImport.update({
    id: '/import',
    path: '/import',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdGeosetsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRoute =
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRouteImport.update({
    id: '/$geosetId',
    path: '/$geosetId',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdGeosetsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdExperimentsNewRoute =
  AuthenticatedWorkspacesWorkspaceIdExperimentsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdExperimentsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdExperimentsExperimentIdRoute =
  AuthenticatedWorkspacesWorkspaceIdExperimentsExperimentIdRouteImport.update({
    id: '/$experimentId',
    path: '/$experimentId',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdExperimentsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdDevConditionViewerRoute =
  AuthenticatedWorkspacesWorkspaceIdDevConditionViewerRouteImport.update({
    id: '/dev/condition-viewer',
    path: '/dev/condition-viewer',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdDesignStudioGlobalStylesRoute =
  AuthenticatedWorkspacesWorkspaceIdDesignStudioGlobalStylesRouteImport.update({
    id: '/design-studio_/global-styles',
    path: '/design-studio/global-styles',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdDesignStudioDashboardRoute =
  AuthenticatedWorkspacesWorkspaceIdDesignStudioDashboardRouteImport.update({
    id: '/design-studio_/dashboard',
    path: '/design-studio/dashboard',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdDesignStudioSplatRoute =
  AuthenticatedWorkspacesWorkspaceIdDesignStudioSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdDesignStudioRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdBoardsBoardIdRoute =
  AuthenticatedWorkspacesWorkspaceIdBoardsBoardIdRouteImport.update({
    id: '/boards/$boardId',
    path: '/boards/$boardId',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAnalysisEmailClientsRoute =
  AuthenticatedWorkspacesWorkspaceIdAnalysisEmailClientsRouteImport.update({
    id: '/analysis/email-clients',
    path: '/analysis/email-clients',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAnalysisDeliverabilityRoute =
  AuthenticatedWorkspacesWorkspaceIdAnalysisDeliverabilityRouteImport.update({
    id: '/analysis/deliverability',
    path: '/analysis/deliverability',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAgentSkillsRoute =
  AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteImport.update({
    id: '/skills',
    path: '/skills',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdAgentRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAgentRoutinesRoute =
  AuthenticatedWorkspacesWorkspaceIdAgentRoutinesRouteImport.update({
    id: '/routines',
    path: '/routines',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdAgentRoute,
  } as any);
const AuthenticatedSettingsTeamJoinRequestsRequestIdRoute =
  AuthenticatedSettingsTeamJoinRequestsRequestIdRouteImport.update({
    id: '/settings/team/join-requests/$requestId',
    path: '/settings/team/join-requests/$requestId',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsBillingAvailablePlansJourneysRoute =
  AuthenticatedSettingsBillingAvailablePlansJourneysRouteImport.update({
    id: '/available-plans/journeys',
    path: '/available-plans/journeys',
    getParentRoute: () => AuthenticatedSettingsBillingRoute,
  } as any);
const AuthenticatedSettingsApi_credentialsService_accountsServiceAccountIdRoute =
  AuthenticatedSettingsApi_credentialsService_accountsServiceAccountIdRouteImport.update(
    {
      id: '/settings/api_credentials/service_accounts/$serviceAccountId',
      path: '/settings/api_credentials/service_accounts/$serviceAccountId',
      getParentRoute: () => AuthenticatedRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationIndexRouteImport.update(
    {
      id: '/settings/webhook_configuration/',
      path: '/settings/webhook_configuration/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsObjectsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsObjectsIndexRouteImport.update({
    id: '/settings/objects/',
    path: '/settings/objects/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsIndexRouteImport.update(
    {
      id: '/settings/api_credentials/',
      path: '/settings/api_credentials/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesIndexRouteImport.update({
    id: '/pipelines/sources/',
    path: '/pipelines/sources/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsIndexRouteImport.update(
    {
      id: '/pipelines/destinations/',
      path: '/pipelines/destinations/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdObjectsSlugIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdObjectsSlugIndexRouteImport.update({
    id: '/objects/$slug/',
    path: '/objects/$slug/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredIndexRouteImport.update({
    id: '/journeys/triggered/',
    path: '/journeys/triggered/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysTemplateIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysTemplateIndexRouteImport.update({
    id: '/journeys/template/',
    path: '/journeys/template/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysProfilesIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysProfilesIndexRouteImport.update({
    id: '/journeys/profiles/',
    path: '/journeys/profiles/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityIndexRouteImport.update(
    {
      id: '/journeys/profile_activity/',
      path: '/journeys/profile_activity/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysPeopleIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysPeopleIndexRouteImport.update({
    id: '/journeys/people/',
    path: '/journeys/people/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysObjectsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysObjectsIndexRouteImport.update({
    id: '/journeys/objects/',
    path: '/journeys/objects/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsIndexRouteImport.update({
    id: '/journeys/layouts/',
    path: '/journeys/layouts/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsIndexRouteImport.update(
    {
      id: '/journeys/integrations/',
      path: '/journeys/integrations/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysImportsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsIndexRouteImport.update({
    id: '/journeys/imports/',
    path: '/journeys/imports/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsIndexRouteImport.update(
    {
      id: '/journeys/activity_logs/',
      path: '/journeys/activity_logs/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksIndexRouteImport.update(
    {
      id: '/integrations/reporting-webhooks/',
      path: '/integrations/reporting-webhooks/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsAllIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsAllIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdImportsImportIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdImportsImportIdIndexRouteImport.update({
    id: '/imports/$importId/',
    path: '/imports/$importId/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAgentSkillsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdAgentSkillsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdAgentSkillsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationNewRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationNewRouteImport.update(
    {
      id: '/settings/webhook_configuration/new',
      path: '/settings/webhook_configuration/new',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerSettingsRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerSettingsRouteImport.update(
    {
      id: '/settings',
      path: '/settings',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsObjectsNewRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsObjectsNewRouteImport.update({
    id: '/settings/objects/new',
    path: '/settings/objects/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationNewRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationNewRouteImport.update(
    {
      id: '/new',
      path: '/new',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRouteImport.update(
    {
      id: '/settings/actions/url_params',
      path: '/settings/actions/url_params',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrban_airshipRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrban_airshipRouteImport.update(
    {
      id: '/settings/actions/urban_airship',
      path: '/settings/actions/urban_airship',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsTime_zone_matchRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsTime_zone_matchRouteImport.update(
    {
      id: '/settings/actions/time_zone_match',
      path: '/settings/actions/time_zone_match',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRouteImport.update(
    {
      id: '/settings/actions/sms-providers',
      path: '/settings/actions/sms-providers',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsSlackRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSlackRouteImport.update({
    id: '/settings/actions/slack',
    path: '/settings/actions/slack',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessaging_limitRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessaging_limitRouteImport.update(
    {
      id: '/settings/actions/messaging_limit',
      path: '/settings/actions/messaging_limit',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessage_frequency_limitsRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessage_frequency_limitsRouteImport.update(
    {
      id: '/settings/actions/message_frequency_limits',
      path: '/settings/actions/message_frequency_limits',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsLineRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsLineRouteImport.update({
    id: '/settings/actions/line',
    path: '/settings/actions/line',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRouteImport.update({
    id: '/settings/actions/email',
    path: '/settings/actions/email',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesJourneysRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesJourneysRouteImport.update({
    id: '/pipelines/sources/journeys',
    path: '/pipelines/sources/journeys',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddRouteImport.update({
    id: '/pipelines/sources/add',
    path: '/pipelines/sources/add',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteImport.update({
    id: '/pipelines/sources/$sourceId',
    path: '/pipelines/sources/$sourceId',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsJourneysRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsJourneysRouteImport.update(
    {
      id: '/pipelines/destinations/journeys',
      path: '/pipelines/destinations/journeys',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddRouteImport.update({
    id: '/pipelines/destinations/add',
    path: '/pipelines/destinations/add',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteImport.update(
    {
      id: '/pipelines/destinations/$destinationId',
      path: '/pipelines/destinations/$destinationId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdObjectsSlugNewRoute =
  AuthenticatedWorkspacesWorkspaceIdObjectsSlugNewRouteImport.update({
    id: '/objects/$slug/new',
    path: '/objects/$slug/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdObjectsSlugGuideRoute =
  AuthenticatedWorkspacesWorkspaceIdObjectsSlugGuideRouteImport.update({
    id: '/objects/$slug/guide',
    path: '/objects/$slug/guide',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRoute =
  AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRouteImport.update({
    id: '/objects/$slug/$objectId',
    path: '/objects/$slug/$objectId',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysV2SplatRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysV2SplatRouteImport.update({
    id: '/journeys/v2/$',
    path: '/journeys/v2/$',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredNewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredNewRouteImport.update({
    id: '/journeys/triggered/new',
    path: '/journeys/triggered/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysTemplateTemplateIdRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysTemplateTemplateIdRouteImport.update(
    {
      id: '/journeys/template/$templateId',
      path: '/journeys/template/$templateId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsNewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsSnippetIdRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsSnippetIdRouteImport.update(
    {
      id: '/$snippetId',
      path: '/$snippetId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysSetupGuideSplatRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysSetupGuideSplatRouteImport.update({
    id: '/journeys/setup-guide/$',
    path: '/journeys/setup-guide/$',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysSettingsSplatRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysSettingsSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysProfilesWelcomeRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysProfilesWelcomeRouteImport.update({
    id: '/journeys/profiles/welcome',
    path: '/journeys/profiles/welcome',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysProfilesNewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysProfilesNewRouteImport.update({
    id: '/journeys/profiles/new',
    path: '/journeys/profiles/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysProfilesMergeRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysProfilesMergeRouteImport.update({
    id: '/journeys/profiles/merge',
    path: '/journeys/profiles/merge',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysProfilesCreateRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysProfilesCreateRouteImport.update({
    id: '/journeys/profiles/create',
    path: '/journeys/profiles/create',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityTabRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityTabRouteImport.update(
    {
      id: '/journeys/profile_activity/$tab',
      path: '/journeys/profile_activity/$tab',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysPeopleWelcomeRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysPeopleWelcomeRouteImport.update({
    id: '/journeys/people/welcome',
    path: '/journeys/people/welcome',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysPeopleNewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysPeopleNewRouteImport.update({
    id: '/journeys/people/new',
    path: '/journeys/people/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysPeopleMergeRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysPeopleMergeRouteImport.update({
    id: '/journeys/people/merge',
    path: '/journeys/people/merge',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysPeopleCreateRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysPeopleCreateRouteImport.update({
    id: '/journeys/people/create',
    path: '/journeys/people/create',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysOutboxSplatRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysOutboxSplatRouteImport.update({
    id: '/journeys/outbox/$',
    path: '/journeys/outbox/$',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysMessage_activitySplatRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysMessage_activitySplatRouteImport.update(
    {
      id: '/journeys/message_activity/$',
      path: '/journeys/message_activity/$',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsStartersRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsStartersRouteImport.update({
    id: '/journeys/layouts/starters',
    path: '/journeys/layouts/starters',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsNewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsNewRouteImport.update({
    id: '/journeys/layouts/new',
    path: '/journeys/layouts/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_outRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_outRouteImport.update(
    {
      id: '/journeys/integrations/segment_out',
      path: '/journeys/integrations/segment_out',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_inRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_inRouteImport.update(
    {
      id: '/journeys/integrations/segment_in',
      path: '/journeys/integrations/segment_in',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRouteImport.update(
    {
      id: '/journeys/integrations/reporting-webhooks',
      path: '/journeys/integrations/reporting-webhooks',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsMparticle_outRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsMparticle_outRouteImport.update(
    {
      id: '/journeys/integrations/mparticle_out',
      path: '/journeys/integrations/mparticle_out',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCustomerioRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCustomerioRouteImport.update(
    {
      id: '/journeys/integrations/customerio',
      path: '/journeys/integrations/customerio',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_outRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_outRouteImport.update(
    {
      id: '/journeys/integrations/cdp_out',
      path: '/journeys/integrations/cdp_out',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_inRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_inRouteImport.update(
    {
      id: '/journeys/integrations/cdp_in',
      path: '/journeys/integrations/cdp_in',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRouteImport.update({
    id: '/journeys/integrations/all',
    path: '/journeys/integrations/all',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsTypeRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsTypeRouteImport.update({
    id: '/journeys/integrations/$type',
    path: '/journeys/integrations/$type',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysImportsNewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsNewRouteImport.update({
    id: '/journeys/imports/new',
    path: '/journeys/imports/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesNewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesGeofenceIdRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesGeofenceIdRouteImport.update(
    {
      id: '/$geofenceId',
      path: '/$geofenceId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdRouteImport.update(
    {
      id: '/$collectionId',
      path: '/$collectionId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisDeliverabilityRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisDeliverabilityRouteImport.update(
    {
      id: '/journeys/analysis/deliverability',
      path: '/journeys/analysis/deliverability',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsTabRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsTabRouteImport.update({
    id: '/journeys/activity_logs/$tab',
    path: '/journeys/activity_logs/$tab',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseSnowflakeRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseSnowflakeRouteImport.update(
    {
      id: '/integrations/warehouse/snowflake',
      path: '/integrations/warehouse/snowflake',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseRedshiftRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseRedshiftRouteImport.update(
    {
      id: '/integrations/warehouse/redshift',
      path: '/integrations/warehouse/redshift',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseBigqueryRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseBigqueryRouteImport.update(
    {
      id: '/integrations/warehouse/bigquery',
      path: '/integrations/warehouse/bigquery',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeRouteImport.update(
    {
      id: '/integrations/warehouse/$type',
      path: '/integrations/warehouse/$type',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRouteImport.update({
    id: '/integrations/sql-sync/$type',
    path: '/integrations/sql-sync/$type',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksNewRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksNewRouteImport.update(
    {
      id: '/integrations/reporting-webhooks/new',
      path: '/integrations/reporting-webhooks/new',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksWebhookIdRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksWebhookIdRouteImport.update(
    {
      id: '/integrations/reporting-webhooks/$webhookId',
      path: '/integrations/reporting-webhooks/$webhookId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsData_outTypeRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsData_outTypeRouteImport.update({
    id: '/integrations/data_out/$type',
    path: '/integrations/data_out/$type',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdIntegrationsAllWebhooksRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsAllWebhooksRouteImport.update({
    id: '/webhooks',
    path: '/webhooks',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdIntegrationsAllOverviewRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsAllOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDirectoryRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDirectoryRouteImport.update({
    id: '/directory',
    path: '/directory',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDevelopersRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDevelopersRouteImport.update(
    {
      id: '/developers',
      path: '/developers',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupAddPeopleRoute =
  AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupAddPeopleRouteImport.update(
    {
      id: '/add-people',
      path: '/add-people',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRoute =
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRouteImport.update({
    id: '/geofences',
    path: '/geofences',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdEditRoute =
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRoute =
  AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteImport.update({
    id: '/dev/db/campaigns',
    path: '/dev/db/campaigns',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdWorkflowRoute =
  AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdWorkflowRouteImport.update(
    {
      id: '/automations/$campaignId/workflow',
      path: '/automations/$campaignId/workflow',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdAgentSkillsNewRoute =
  AuthenticatedWorkspacesWorkspaceIdAgentSkillsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdAgentSkillsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdAgentSkillsSkillPathRoute =
  AuthenticatedWorkspacesWorkspaceIdAgentSkillsSkillPathRouteImport.update({
    id: '/$skillPath',
    path: '/$skillPath',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdAgentSkillsRoute,
  } as any);
const AuthenticatedSettingsTeamMembersUserIdEditRoute =
  AuthenticatedSettingsTeamMembersUserIdEditRouteImport.update({
    id: '/settings/team/members/$userId/edit',
    path: '/settings/team/members/$userId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsIndexRouteImport.update(
    {
      id: '/topics/',
      path: '/topics/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugIndexRouteImport.update({
    id: '/journeys/objects/$slug/',
    path: '/journeys/objects/$slug/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdIndexRouteImport.update(
    {
      id: '/journeys/layouts/$layoutId/',
      path: '/journeys/layouts/$layoutId/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdIndexRouteImport.update(
    {
      id: '/journeys/imports/$importId/',
      path: '/journeys/imports/$importId/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupIndexRouteImport.update(
    {
      id: '/imports/$importId/setup/',
      path: '/imports/$importId/setup/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationWebhookIdEditRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationWebhookIdEditRouteImport.update(
    {
      id: '/settings/webhook_configuration/$webhookId/edit',
      path: '/settings/webhook_configuration/$webhookId/edit',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsSet_preferencesRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsSet_preferencesRouteImport.update(
    {
      id: '/topics/set_preferences',
      path: '/topics/set_preferences',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerLocalizationEditRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerLocalizationEditRouteImport.update(
    {
      id: '/localization/edit',
      path: '/localization/edit',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerBrandingEditRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerBrandingEditRouteImport.update(
    {
      id: '/branding/edit',
      path: '/branding/edit',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsObjectsEditObjectTypeRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsObjectsEditObjectTypeRouteImport.update(
    {
      id: '/settings/objects/edit/$objectType',
      path: '/settings/objects/edit/$objectType',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationConfigurationIdEditRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationConfigurationIdEditRouteImport.update(
    {
      id: '/$configurationId/edit',
      path: '/$configurationId/edit',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsService_accountsServiceAccountIdRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsService_accountsServiceAccountIdRouteImport.update(
    {
      id: '/settings/api_credentials/service_accounts/$serviceAccountId',
      path: '/settings/api_credentials/service_accounts/$serviceAccountId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsEditRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsEditRouteImport.update(
    {
      id: '/edit',
      path: '/edit',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSuppression_listRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSuppression_listRouteImport.update(
    {
      id: '/suppression_list',
      path: '/suppression_list',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSmtpRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSmtpRouteImport.update({
    id: '/smtp',
    path: '/smtp',
    getParentRoute: () =>
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailFrom_addressesRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailFrom_addressesRouteImport.update(
    {
      id: '/from_addresses',
      path: '/from_addresses',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDynamic_addressesRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDynamic_addressesRouteImport.update(
    {
      id: '/dynamic_addresses',
      path: '/dynamic_addresses',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDeliverabilityRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDeliverabilityRouteImport.update(
    {
      id: '/deliverability',
      path: '/deliverability',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDefaultsRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDefaultsRouteImport.update(
    {
      id: '/defaults',
      path: '/defaults',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddSourceOptionIdRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddSourceOptionIdRouteImport.update(
    {
      id: '/pipelines/sources/add_/$sourceOptionId',
      path: '/pipelines/sources/add/$sourceOptionId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsRouteImport.update(
    {
      id: '/syncs',
      path: '/syncs',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSettingsRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSettingsRouteImport.update(
    {
      id: '/settings',
      path: '/settings',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdImportsRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdImportsRouteImport.update(
    {
      id: '/imports',
      path: '/imports',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDatabasesRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDatabasesRouteImport.update(
    {
      id: '/databases',
      path: '/databases',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDataInRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDataInRouteImport.update(
    {
      id: '/data-in',
      path: '/data-in',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddDestinationOptionIdRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddDestinationOptionIdRouteImport.update(
    {
      id: '/pipelines/destinations/add_/$destinationOptionId',
      path: '/pipelines/destinations/add/$destinationOptionId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdTesterRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdTesterRouteImport.update(
    {
      id: '/tester',
      path: '/tester',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteImport.update(
    {
      id: '/subscriptions',
      path: '/subscriptions',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSettingsRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSettingsRouteImport.update(
    {
      id: '/settings',
      path: '/settings',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdExportsRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdExportsRouteImport.update(
    {
      id: '/exports',
      path: '/exports',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdDataOutRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdDataOutRouteImport.update(
    {
      id: '/data-out',
      path: '/data-out',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugNewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugNewRouteImport.update({
    id: '/journeys/objects/$slug/new',
    path: '/journeys/objects/$slug/new',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugGuideRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugGuideRouteImport.update({
    id: '/journeys/objects/$slug/guide',
    path: '/journeys/objects/$slug/guide',
    getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
  } as any);
const AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdEditRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdEditRouteImport.update(
    {
      id: '/journeys/layouts/$layoutId/edit',
      path: '/journeys/layouts/$layoutId/edit',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseSnowflakeRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseSnowflakeRouteImport.update(
    {
      id: '/journeys/integrations/warehouse/snowflake',
      path: '/journeys/integrations/warehouse/snowflake',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseRedshiftRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseRedshiftRouteImport.update(
    {
      id: '/journeys/integrations/warehouse/redshift',
      path: '/journeys/integrations/warehouse/redshift',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseBigqueryRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseBigqueryRouteImport.update(
    {
      id: '/journeys/integrations/warehouse/bigquery',
      path: '/journeys/integrations/warehouse/bigquery',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeRouteImport.update(
    {
      id: '/journeys/integrations/warehouse/$type',
      path: '/journeys/integrations/warehouse/$type',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRouteImport.update(
    {
      id: '/journeys/integrations/sql-sync/$type',
      path: '/journeys/integrations/sql-sync/$type',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksNewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksNewRouteImport.update(
    {
      id: '/new',
      path: '/new',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksWebhookIdRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksWebhookIdRouteImport.update(
    {
      id: '/$webhookId',
      path: '/$webhookId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsData_outTypeRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsData_outTypeRouteImport.update(
    {
      id: '/journeys/integrations/data_out/$type',
      path: '/journeys/integrations/data_out/$type',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllWebhooksRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllWebhooksRouteImport.update(
    {
      id: '/webhooks',
      path: '/webhooks',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllOverviewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllOverviewRouteImport.update(
    {
      id: '/overview',
      path: '/overview',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDirectoryRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDirectoryRouteImport.update(
    {
      id: '/directory',
      path: '/directory',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDevelopersRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDevelopersRouteImport.update(
    {
      id: '/developers',
      path: '/developers',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdUsageRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdUsageRouteImport.update(
    {
      id: '/usage',
      path: '/usage',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdImportingRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdImportingRouteImport.update(
    {
      id: '/importing',
      path: '/importing',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdDataRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdDataRouteImport.update(
    {
      id: '/data',
      path: '/data',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdSplatRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdSplatRouteImport.update(
    {
      id: '/$',
      path: '/$',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeSyncRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeSyncRouteImport.update(
    {
      id: '/integrations/warehouse/$type_/sync',
      path: '/integrations/warehouse/$type/sync',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeNewRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeNewRouteImport.update(
    {
      id: '/new',
      path: '/new',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRouteImport.update(
    {
      id: '/$sqlImportId',
      path: '/$sqlImportId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupValidatingRoute =
  AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupValidatingRouteImport.update(
    {
      id: '/imports/$importId/setup/validating',
      path: '/imports/$importId/setup/validating',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupReviewRoute =
  AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupReviewRouteImport.update(
    {
      id: '/imports/$importId/setup/review',
      path: '/imports/$importId/setup/review',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreviewRoute =
  AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreviewRouteImport.update(
    {
      id: '/imports/$importId/setup/preview',
      path: '/imports/$importId/setup/preview',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreprocessingRoute =
  AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreprocessingRouteImport.update(
    {
      id: '/imports/$importId/setup/preprocessing',
      path: '/imports/$importId/setup/preprocessing',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupImportingRoute =
  AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupImportingRouteImport.update(
    {
      id: '/imports/$importId/setup/importing',
      path: '/imports/$importId/setup/importing',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupFieldsRoute =
  AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupFieldsRouteImport.update(
    {
      id: '/imports/$importId/setup/fields',
      path: '/imports/$importId/setup/fields',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesNewRoute =
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesNewRouteImport.update(
    {
      id: '/new',
      path: '/new',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesImportRoute =
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesImportRouteImport.update(
    {
      id: '/import',
      path: '/import',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesGeofenceIdRoute =
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesGeofenceIdRouteImport.update(
    {
      id: '/$geofenceId',
      path: '/$geofenceId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsIndexRouteImport.update(
    {
      id: '/sending_domains/',
      path: '/sending_domains/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdIndexRouteImport.update(
    {
      id: '/journeys/objects/$slug/$objectId/',
      path: '/journeys/objects/$slug/$objectId/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupIndexRouteImport.update(
    {
      id: '/journeys/imports/$importId/setup/',
      path: '/journeys/imports/$importId/setup/',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdIndexRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersCredentialsCredentialIdRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersCredentialsCredentialIdRouteImport.update(
    {
      id: '/credentials/$credentialId',
      path: '/credentials/$credentialId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsDomainIdRoute =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsDomainIdRouteImport.update(
    {
      id: '/sending_domains/$domainId',
      path: '/sending_domains/$domainId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsAddRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsAddRouteImport.update(
    {
      id: '/pipelines/sources/$sourceId_/syncs/add',
      path: '/pipelines/sources/$sourceId/syncs/add',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsSyncIdRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsSyncIdRouteImport.update(
    {
      id: '/pipelines/sources/$sourceId_/syncs/$syncId',
      path: '/pipelines/sources/$sourceId/syncs/$syncId',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsAddRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsAddRouteImport.update(
    {
      id: '/add',
      path: '/add',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsSubscriptionIdRoute =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsSubscriptionIdRouteImport.update(
    {
      id: '/$subscriptionId',
      path: '/$subscriptionId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeSyncRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeSyncRouteImport.update(
    {
      id: '/journeys/integrations/warehouse/$type_/sync',
      path: '/journeys/integrations/warehouse/$type/sync',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeNewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeNewRouteImport.update(
    {
      id: '/new',
      path: '/new',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRouteImport.update(
    {
      id: '/$sqlImportId',
      path: '/$sqlImportId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupValidatingRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupValidatingRouteImport.update(
    {
      id: '/journeys/imports/$importId/setup/validating',
      path: '/journeys/imports/$importId/setup/validating',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupReviewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupReviewRouteImport.update(
    {
      id: '/journeys/imports/$importId/setup/review',
      path: '/journeys/imports/$importId/setup/review',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreviewRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreviewRouteImport.update(
    {
      id: '/journeys/imports/$importId/setup/preview',
      path: '/journeys/imports/$importId/setup/preview',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreprocessingRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreprocessingRouteImport.update(
    {
      id: '/journeys/imports/$importId/setup/preprocessing',
      path: '/journeys/imports/$importId/setup/preprocessing',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupImportingRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupImportingRouteImport.update(
    {
      id: '/journeys/imports/$importId/setup/importing',
      path: '/journeys/imports/$importId/setup/importing',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupFieldsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupFieldsRouteImport.update(
    {
      id: '/journeys/imports/$importId/setup/fields',
      path: '/journeys/imports/$importId/setup/fields',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdSettingsRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdSettingsRouteImport.update(
    {
      id: '/settings',
      path: '/settings',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRouteImport.update(
    {
      id: '/relationships-query',
      path: '/relationships-query',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdQueryRoute =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdQueryRouteImport.update(
    {
      id: '/query',
      path: '/query',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsActionsActionIdRoute =
  AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsActionsActionIdRouteImport.update(
    {
      id: '/actions/$actionId',
      path: '/actions/$actionId',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdSettingsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdSettingsRouteImport.update(
    {
      id: '/$sqlImportId_/settings',
      path: '/$sqlImportId/settings',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRouteImport.update(
    {
      id: '/$sqlImportId_/relationships-query',
      path: '/$sqlImportId/relationships-query',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdQueryRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdQueryRouteImport.update(
    {
      id: '/$sqlImportId_/query',
      path: '/$sqlImportId/query',
      getParentRoute: () =>
        AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdSetupWorkflowActionsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdSetupWorkflowActionsRouteImport.update(
    {
      id: '/journeys/campaigns/$campaignId/setup/workflow/actions',
      path: '/journeys/campaigns/$campaignId/setup/workflow/actions',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewWorkflowActionsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewWorkflowActionsRouteImport.update(
    {
      id: '/journeys/campaigns/$campaignId/overview/workflow/actions',
      path: '/journeys/campaigns/$campaignId/overview/workflow/actions',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdSetupWorkflowActionsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdSetupWorkflowActionsRouteImport.update(
    {
      id: '/journeys/automations/$campaignId/setup/workflow/actions',
      path: '/journeys/automations/$campaignId/setup/workflow/actions',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );
const AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewWorkflowActionsRoute =
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewWorkflowActionsRouteImport.update(
    {
      id: '/journeys/automations/$campaignId/overview/workflow/actions',
      path: '/journeys/automations/$campaignId/overview/workflow/actions',
      getParentRoute: () => AuthenticatedWorkspacesWorkspaceIdRoute,
    } as any,
  );

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute;
  '/academy-login': typeof AcademyLoginRoute;
  '/accept-guest-invitation': typeof AcceptGuestInvitationRoute;
  '/checkout': typeof CheckoutRoute;
  '/cli': typeof CliRouteWithChildren;
  '/design-studio-embed': typeof DesignStudioEmbedRouteWithChildren;
  '/join-request': typeof JoinRequestRoute;
  '/onboarding': typeof OnboardingRouteWithChildren;
  '/2fa_setup/$': typeof R2fa_setupSplatRoute;
  '/$': typeof AuthenticatedSplatRoute;
  '/workspaces': typeof AuthenticatedWorkspacesRouteWithChildren;
  '/account/$': typeof AccountSplatRoute;
  '/account_canceled/$': typeof Account_canceledSplatRoute;
  '/account_cancelled/$': typeof Account_cancelledSplatRoute;
  '/cli/dns-setup': typeof CliDnsSetupRoute;
  '/confirm_account/$': typeof Confirm_accountSplatRoute;
  '/confirm_account_notice/$': typeof Confirm_account_noticeSplatRoute;
  '/env/$': typeof EnvSplatRoute;
  '/har-sanitizer/$': typeof HarSanitizerSplatRoute;
  '/integrations/$': typeof IntegrationsSplatRoute;
  '/journeys/$': typeof JourneysSplatRoute;
  '/login/$': typeof LoginSplatRoute;
  '/logout/$': typeof LogoutSplatRoute;
  '/no_accessible_workspaces/$': typeof No_accessible_workspacesSplatRoute;
  '/oauth/$': typeof OauthSplatRoute;
  '/oauth2/$': typeof Oauth2SplatRoute;
  '/onboarding/get-started': typeof OnboardingGetStartedRoute;
  '/onboarding/verification': typeof OnboardingVerificationRoute;
  '/onboarding/wizard': typeof OnboardingWizardRoute;
  '/post_cancel/$': typeof Post_cancelSplatRoute;
  '/post_registration/$': typeof Post_registrationSplatRoute;
  '/reset_password/$': typeof Reset_passwordSplatRoute;
  '/signup/$': typeof SignupSplatRoute;
  '/users/$': typeof UsersSplatRoute;
  '/vwb-demo/$': typeof VwbDemoSplatRoute;
  '/cli/': typeof CliIndexRoute;
  '/onboarding/': typeof OnboardingIndexRoute;
  '/internal-tools/$': typeof AuthenticatedInternalToolsSplatRoute;
  '/sample-workspace/$': typeof AuthenticatedSampleWorkspaceSplatRoute;
  '/settings/$': typeof AuthenticatedSettingsSplatRoute;
  '/settings/ai': typeof AuthenticatedSettingsAiRoute;
  '/settings/api-keys': typeof AuthenticatedSettingsApiKeysRoute;
  '/settings/audit-logs': typeof AuthenticatedSettingsAuditLogsRoute;
  '/settings/billing': typeof AuthenticatedSettingsBillingRouteWithChildren;
  '/settings/experimental-features': typeof AuthenticatedSettingsExperimentalFeaturesRoute;
  '/settings/partner': typeof AuthenticatedSettingsPartnerRouteWithChildren;
  '/settings/privacy': typeof AuthenticatedSettingsPrivacyRoute;
  '/settings/receipts': typeof AuthenticatedSettingsReceiptsRoute;
  '/settings/slack-agent': typeof AuthenticatedSettingsSlackAgentRoute;
  '/settings/subscription': typeof AuthenticatedSettingsSubscriptionRoute;
  '/trial-expired/journeys': typeof AuthenticatedTrialExpiredJourneysRoute;
  '/workspaces/$workspaceId': typeof AuthenticatedWorkspacesWorkspaceIdRouteWithChildren;
  '/account/cancelled/$': typeof AccountCancelledSplatRoute;
  '/design-studio-embed/cio/$': typeof DesignStudioEmbedCioSplatRoute;
  '/internal-tools/': typeof AuthenticatedInternalToolsIndexRoute;
  '/sample-workspace/': typeof AuthenticatedSampleWorkspaceIndexRoute;
  '/settings/': typeof AuthenticatedSettingsIndexRoute;
  '/workspaces/': typeof AuthenticatedWorkspacesIndexRoute;
  '/design-studio-embed/cio/': typeof DesignStudioEmbedCioIndexRoute;
  '/settings/account/edit': typeof AuthenticatedSettingsAccountEditRoute;
  '/settings/billing/$': typeof AuthenticatedSettingsBillingSplatRoute;
  '/settings/billing/billing-details': typeof AuthenticatedSettingsBillingBillingDetailsRoute;
  '/settings/billing/billing-history': typeof AuthenticatedSettingsBillingBillingHistoryRoute;
  '/settings/billing/checkout': typeof AuthenticatedSettingsBillingCheckoutRoute;
  '/settings/billing/inbox-preview-usage': typeof AuthenticatedSettingsBillingInboxPreviewUsageRoute;
  '/settings/billing/llm-usage': typeof AuthenticatedSettingsBillingLlmUsageRoute;
  '/settings/billing/overview': typeof AuthenticatedSettingsBillingOverviewRoute;
  '/settings/billing/payment-methods': typeof AuthenticatedSettingsBillingPaymentMethodsRoute;
  '/settings/billing/profile-growth': typeof AuthenticatedSettingsBillingProfileGrowthRoute;
  '/settings/billing/usage': typeof AuthenticatedSettingsBillingUsageRoute;
  '/settings/billing/your-plan': typeof AuthenticatedSettingsBillingYourPlanRoute;
  '/settings/partner/create': typeof AuthenticatedSettingsPartnerCreateRoute;
  '/settings/personal/google-identities': typeof AuthenticatedSettingsPersonalGoogleIdentitiesRoute;
  '/settings/roles/$roleId': typeof AuthenticatedSettingsRolesRoleIdRoute;
  '/settings/roles/new': typeof AuthenticatedSettingsRolesNewRoute;
  '/settings/security/sso': typeof AuthenticatedSettingsSecuritySsoRoute;
  '/settings/slack-agent/link': typeof AuthenticatedSettingsSlackAgentLinkRoute;
  '/settings/team/add': typeof AuthenticatedSettingsTeamAddRoute;
  '/settings/team/invite-guest': typeof AuthenticatedSettingsTeamInviteGuestRoute;
  '/settings/workspaces/new': typeof AuthenticatedSettingsWorkspacesNewRoute;
  '/workspaces/$workspaceId/$': typeof AuthenticatedWorkspacesWorkspaceIdSplatRoute;
  '/workspaces/$workspaceId/agent': typeof AuthenticatedWorkspacesWorkspaceIdAgentRouteWithChildren;
  '/workspaces/$workspaceId/assets': typeof AuthenticatedWorkspacesWorkspaceIdAssetsRoute;
  '/workspaces/$workspaceId/design-studio': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteWithChildren;
  '/workspaces/$workspaceId/experiments': typeof AuthenticatedWorkspacesWorkspaceIdExperimentsRouteWithChildren;
  '/workspaces/$workspaceId/exports': typeof AuthenticatedWorkspacesWorkspaceIdExportsRoute;
  '/workspaces/$workspaceId/geosets': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsRouteWithChildren;
  '/workspaces/$workspaceId/health': typeof AuthenticatedWorkspacesWorkspaceIdHealthRoute;
  '/workspaces/$workspaceId/home': typeof AuthenticatedWorkspacesWorkspaceIdHomeRouteWithChildren;
  '/workspaces/$workspaceId/journeys': typeof AuthenticatedWorkspacesWorkspaceIdJourneysRoute;
  '/workspaces/$workspaceId/message-library': typeof AuthenticatedWorkspacesWorkspaceIdMessageLibraryRoute;
  '/workspaces/$workspaceId/outcomes': typeof AuthenticatedWorkspacesWorkspaceIdOutcomesRouteWithChildren;
  '/workspaces/$workspaceId/snippets': typeof AuthenticatedWorkspacesWorkspaceIdSnippetsRouteWithChildren;
  '/workspaces/$workspaceId/tasks': typeof AuthenticatedWorkspacesWorkspaceIdTasksRoute;
  '/pipelines/workspaces/$workspaceId/$': typeof PipelinesWorkspacesWorkspaceIdSplatRoute;
  '/settings/account/': typeof AuthenticatedSettingsAccountIndexRoute;
  '/settings/api_credentials/': typeof AuthenticatedSettingsApi_credentialsIndexRoute;
  '/settings/billing/': typeof AuthenticatedSettingsBillingIndexRoute;
  '/settings/partner/': typeof AuthenticatedSettingsPartnerIndexRoute;
  '/settings/personal/': typeof AuthenticatedSettingsPersonalIndexRoute;
  '/settings/roles/': typeof AuthenticatedSettingsRolesIndexRoute;
  '/settings/security/': typeof AuthenticatedSettingsSecurityIndexRoute;
  '/settings/team/': typeof AuthenticatedSettingsTeamIndexRoute;
  '/settings/workspaces/': typeof AuthenticatedSettingsWorkspacesIndexRoute;
  '/workspaces/$workspaceId/': typeof AuthenticatedWorkspacesWorkspaceIdIndexRoute;
  '/pipelines/workspaces/$workspaceId/': typeof PipelinesWorkspacesWorkspaceIdIndexRoute;
  '/settings/api_credentials/service_accounts/$serviceAccountId': typeof AuthenticatedSettingsApi_credentialsService_accountsServiceAccountIdRoute;
  '/settings/billing/available-plans/journeys': typeof AuthenticatedSettingsBillingAvailablePlansJourneysRoute;
  '/settings/team/join-requests/$requestId': typeof AuthenticatedSettingsTeamJoinRequestsRequestIdRoute;
  '/workspaces/$workspaceId/agent/routines': typeof AuthenticatedWorkspacesWorkspaceIdAgentRoutinesRoute;
  '/workspaces/$workspaceId/agent/skills': typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteWithChildren;
  '/workspaces/$workspaceId/analysis/deliverability': typeof AuthenticatedWorkspacesWorkspaceIdAnalysisDeliverabilityRoute;
  '/workspaces/$workspaceId/analysis/email-clients': typeof AuthenticatedWorkspacesWorkspaceIdAnalysisEmailClientsRoute;
  '/workspaces/$workspaceId/boards/$boardId': typeof AuthenticatedWorkspacesWorkspaceIdBoardsBoardIdRoute;
  '/workspaces/$workspaceId/design-studio/$': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioSplatRoute;
  '/workspaces/$workspaceId/design-studio/dashboard': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioDashboardRoute;
  '/workspaces/$workspaceId/design-studio/global-styles': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioGlobalStylesRoute;
  '/workspaces/$workspaceId/dev/condition-viewer': typeof AuthenticatedWorkspacesWorkspaceIdDevConditionViewerRoute;
  '/workspaces/$workspaceId/experiments/$experimentId': typeof AuthenticatedWorkspacesWorkspaceIdExperimentsExperimentIdRoute;
  '/workspaces/$workspaceId/experiments/new': typeof AuthenticatedWorkspacesWorkspaceIdExperimentsNewRoute;
  '/workspaces/$workspaceId/geosets/$geosetId': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRouteWithChildren;
  '/workspaces/$workspaceId/geosets/import': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsImportRoute;
  '/workspaces/$workspaceId/geosets/new': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsNewRoute;
  '/workspaces/$workspaceId/home/add-people': typeof AuthenticatedWorkspacesWorkspaceIdHomeAddPeopleRoute;
  '/workspaces/$workspaceId/home/workspace-setup': typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteWithChildren;
  '/workspaces/$workspaceId/imports/new': typeof AuthenticatedWorkspacesWorkspaceIdImportsNewRoute;
  '/workspaces/$workspaceId/integrations/$type': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsTypeRoute;
  '/workspaces/$workspaceId/integrations/all': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRouteWithChildren;
  '/workspaces/$workspaceId/integrations/cdp_in': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_inRoute;
  '/workspaces/$workspaceId/integrations/cdp_out': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_outRoute;
  '/workspaces/$workspaceId/integrations/customerio': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsCustomerioRoute;
  '/workspaces/$workspaceId/integrations/mparticle_out': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsMparticle_outRoute;
  '/workspaces/$workspaceId/integrations/segment_in': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_inRoute;
  '/workspaces/$workspaceId/integrations/segment_out': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_outRoute;
  '/workspaces/$workspaceId/journeys/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSplatRoute;
  '/workspaces/$workspaceId/journeys/assets': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAssetsRoute;
  '/workspaces/$workspaceId/journeys/collections': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRouteWithChildren;
  '/workspaces/$workspaceId/journeys/deliveries': typeof AuthenticatedWorkspacesWorkspaceIdJourneysDeliveriesRoute;
  '/workspaces/$workspaceId/journeys/drafts': typeof AuthenticatedWorkspacesWorkspaceIdJourneysDraftsRoute;
  '/workspaces/$workspaceId/journeys/exports': typeof AuthenticatedWorkspacesWorkspaceIdJourneysExportsRoute;
  '/workspaces/$workspaceId/journeys/geofences': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteWithChildren;
  '/workspaces/$workspaceId/journeys/message-library': typeof AuthenticatedWorkspacesWorkspaceIdJourneysMessageLibraryRoute;
  '/workspaces/$workspaceId/journeys/settings': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteWithChildren;
  '/workspaces/$workspaceId/journeys/snippets': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteWithChildren;
  '/workspaces/$workspaceId/journeys/tasks': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTasksRoute;
  '/workspaces/$workspaceId/outcomes/$goalId': typeof AuthenticatedWorkspacesWorkspaceIdOutcomesGoalIdRoute;
  '/workspaces/$workspaceId/parcel/$': typeof AuthenticatedWorkspacesWorkspaceIdParcelSplatRoute;
  '/workspaces/$workspaceId/people/create': typeof AuthenticatedWorkspacesWorkspaceIdPeopleCreateRoute;
  '/workspaces/$workspaceId/people/merge': typeof AuthenticatedWorkspacesWorkspaceIdPeopleMergeRoute;
  '/workspaces/$workspaceId/people/new': typeof AuthenticatedWorkspacesWorkspaceIdPeopleNewRoute;
  '/workspaces/$workspaceId/people/welcome': typeof AuthenticatedWorkspacesWorkspaceIdPeopleWelcomeRoute;
  '/workspaces/$workspaceId/profiles/create': typeof AuthenticatedWorkspacesWorkspaceIdProfilesCreateRoute;
  '/workspaces/$workspaceId/profiles/merge': typeof AuthenticatedWorkspacesWorkspaceIdProfilesMergeRoute;
  '/workspaces/$workspaceId/profiles/new': typeof AuthenticatedWorkspacesWorkspaceIdProfilesNewRoute;
  '/workspaces/$workspaceId/profiles/welcome': typeof AuthenticatedWorkspacesWorkspaceIdProfilesWelcomeRoute;
  '/workspaces/$workspaceId/reports/deliverability': typeof AuthenticatedWorkspacesWorkspaceIdReportsDeliverabilityRoute;
  '/workspaces/$workspaceId/reports/email-clients': typeof AuthenticatedWorkspacesWorkspaceIdReportsEmailClientsRoute;
  '/workspaces/$workspaceId/settings/$': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSplatRoute;
  '/workspaces/$workspaceId/settings/ai-business-profile': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAiBusinessProfileRoute;
  '/workspaces/$workspaceId/settings/anonymous_events': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAnonymous_eventsRoute;
  '/workspaces/$workspaceId/settings/api-keys': typeof AuthenticatedWorkspacesWorkspaceIdSettingsApiKeysRoute;
  '/workspaces/$workspaceId/settings/audit-logs': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAuditLogsRoute;
  '/workspaces/$workspaceId/settings/auto_archive': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAuto_archiveRoute;
  '/workspaces/$workspaceId/settings/confirm_delete': typeof AuthenticatedWorkspacesWorkspaceIdSettingsConfirm_deleteRoute;
  '/workspaces/$workspaceId/settings/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsEditRoute;
  '/workspaces/$workspaceId/settings/geofences': typeof AuthenticatedWorkspacesWorkspaceIdSettingsGeofencesRoute;
  '/workspaces/$workspaceId/settings/language': typeof AuthenticatedWorkspacesWorkspaceIdSettingsLanguageRoute;
  '/workspaces/$workspaceId/settings/llm_configuration': typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRouteWithChildren;
  '/workspaces/$workspaceId/settings/merge_options': typeof AuthenticatedWorkspacesWorkspaceIdSettingsMerge_optionsRoute;
  '/workspaces/$workspaceId/settings/subscription_center': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRouteWithChildren;
  '/workspaces/$workspaceId/settings/suppressions': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSuppressionsRoute;
  '/workspaces/$workspaceId/snippets/$snippetId': typeof AuthenticatedWorkspacesWorkspaceIdSnippetsSnippetIdRoute;
  '/workspaces/$workspaceId/snippets/new': typeof AuthenticatedWorkspacesWorkspaceIdSnippetsNewRoute;
  '/workspaces/$workspaceId/template/$templateId': typeof AuthenticatedWorkspacesWorkspaceIdTemplateTemplateIdRoute;
  '/settings/billing/available-plans/': typeof AuthenticatedSettingsBillingAvailablePlansIndexRoute;
  '/workspaces/$workspaceId/agent/': typeof AuthenticatedWorkspacesWorkspaceIdAgentIndexRoute;
  '/workspaces/$workspaceId/boards/': typeof AuthenticatedWorkspacesWorkspaceIdBoardsIndexRoute;
  '/workspaces/$workspaceId/design-studio/': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioIndexRoute;
  '/workspaces/$workspaceId/experiments/': typeof AuthenticatedWorkspacesWorkspaceIdExperimentsIndexRoute;
  '/workspaces/$workspaceId/geosets/': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsIndexRoute;
  '/workspaces/$workspaceId/home/': typeof AuthenticatedWorkspacesWorkspaceIdHomeIndexRoute;
  '/workspaces/$workspaceId/imports/': typeof AuthenticatedWorkspacesWorkspaceIdImportsIndexRoute;
  '/workspaces/$workspaceId/integrations/': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsIndexRoute;
  '/workspaces/$workspaceId/objects/': typeof AuthenticatedWorkspacesWorkspaceIdObjectsIndexRoute;
  '/workspaces/$workspaceId/outcomes/': typeof AuthenticatedWorkspacesWorkspaceIdOutcomesIndexRoute;
  '/workspaces/$workspaceId/parcel/': typeof AuthenticatedWorkspacesWorkspaceIdParcelIndexRoute;
  '/workspaces/$workspaceId/people/': typeof AuthenticatedWorkspacesWorkspaceIdPeopleIndexRoute;
  '/workspaces/$workspaceId/pipelines/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesIndexRoute;
  '/workspaces/$workspaceId/profiles/': typeof AuthenticatedWorkspacesWorkspaceIdProfilesIndexRoute;
  '/workspaces/$workspaceId/settings/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsIndexRoute;
  '/workspaces/$workspaceId/snippets/': typeof AuthenticatedWorkspacesWorkspaceIdSnippetsIndexRoute;
  '/workspaces/$workspaceId/template/': typeof AuthenticatedWorkspacesWorkspaceIdTemplateIndexRoute;
  '/settings/team/members/$userId/edit': typeof AuthenticatedSettingsTeamMembersUserIdEditRoute;
  '/workspaces/$workspaceId/agent/skills/$skillPath': typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsSkillPathRoute;
  '/workspaces/$workspaceId/agent/skills/new': typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsNewRoute;
  '/workspaces/$workspaceId/automations/$campaignId/workflow': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdWorkflowRoute;
  '/workspaces/$workspaceId/dev/db/campaigns': typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteWithChildren;
  '/workspaces/$workspaceId/geosets/$geosetId/edit': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdEditRoute;
  '/workspaces/$workspaceId/geosets/$geosetId/geofences': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRouteWithChildren;
  '/workspaces/$workspaceId/home/workspace-setup/add-people': typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupAddPeopleRoute;
  '/workspaces/$workspaceId/integrations/all/developers': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDevelopersRoute;
  '/workspaces/$workspaceId/integrations/all/directory': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDirectoryRoute;
  '/workspaces/$workspaceId/integrations/all/overview': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllOverviewRoute;
  '/workspaces/$workspaceId/integrations/all/webhooks': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllWebhooksRoute;
  '/workspaces/$workspaceId/integrations/data_out/$type': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsData_outTypeRoute;
  '/workspaces/$workspaceId/integrations/reporting-webhooks/$webhookId': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksWebhookIdRoute;
  '/workspaces/$workspaceId/integrations/reporting-webhooks/new': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksNewRoute;
  '/workspaces/$workspaceId/integrations/sql-sync/$type': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRouteWithChildren;
  '/workspaces/$workspaceId/integrations/warehouse/$type': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeRoute;
  '/workspaces/$workspaceId/integrations/warehouse/bigquery': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseBigqueryRoute;
  '/workspaces/$workspaceId/integrations/warehouse/redshift': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseRedshiftRoute;
  '/workspaces/$workspaceId/integrations/warehouse/snowflake': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseSnowflakeRoute;
  '/workspaces/$workspaceId/journeys/activity_logs/$tab': typeof AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsTabRoute;
  '/workspaces/$workspaceId/journeys/analysis/deliverability': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisDeliverabilityRoute;
  '/workspaces/$workspaceId/journeys/collections/$collectionId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdRouteWithChildren;
  '/workspaces/$workspaceId/journeys/geofences/$geofenceId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesGeofenceIdRoute;
  '/workspaces/$workspaceId/journeys/geofences/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesNewRoute;
  '/workspaces/$workspaceId/journeys/imports/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsNewRoute;
  '/workspaces/$workspaceId/journeys/integrations/$type': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsTypeRoute;
  '/workspaces/$workspaceId/journeys/integrations/all': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRouteWithChildren;
  '/workspaces/$workspaceId/journeys/integrations/cdp_in': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_inRoute;
  '/workspaces/$workspaceId/journeys/integrations/cdp_out': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_outRoute;
  '/workspaces/$workspaceId/journeys/integrations/customerio': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCustomerioRoute;
  '/workspaces/$workspaceId/journeys/integrations/mparticle_out': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsMparticle_outRoute;
  '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRouteWithChildren;
  '/workspaces/$workspaceId/journeys/integrations/segment_in': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_inRoute;
  '/workspaces/$workspaceId/journeys/integrations/segment_out': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_outRoute;
  '/workspaces/$workspaceId/journeys/layouts/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsNewRoute;
  '/workspaces/$workspaceId/journeys/layouts/starters': typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsStartersRoute;
  '/workspaces/$workspaceId/journeys/message_activity/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysMessage_activitySplatRoute;
  '/workspaces/$workspaceId/journeys/outbox/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysOutboxSplatRoute;
  '/workspaces/$workspaceId/journeys/people/create': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleCreateRoute;
  '/workspaces/$workspaceId/journeys/people/merge': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleMergeRoute;
  '/workspaces/$workspaceId/journeys/people/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleNewRoute;
  '/workspaces/$workspaceId/journeys/people/welcome': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleWelcomeRoute;
  '/workspaces/$workspaceId/journeys/profile_activity/$tab': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityTabRoute;
  '/workspaces/$workspaceId/journeys/profiles/create': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesCreateRoute;
  '/workspaces/$workspaceId/journeys/profiles/merge': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesMergeRoute;
  '/workspaces/$workspaceId/journeys/profiles/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesNewRoute;
  '/workspaces/$workspaceId/journeys/profiles/welcome': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesWelcomeRoute;
  '/workspaces/$workspaceId/journeys/settings/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSettingsSplatRoute;
  '/workspaces/$workspaceId/journeys/setup-guide/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSetupGuideSplatRoute;
  '/workspaces/$workspaceId/journeys/snippets/$snippetId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsSnippetIdRoute;
  '/workspaces/$workspaceId/journeys/snippets/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsNewRoute;
  '/workspaces/$workspaceId/journeys/template/$templateId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTemplateTemplateIdRoute;
  '/workspaces/$workspaceId/journeys/triggered/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredNewRoute;
  '/workspaces/$workspaceId/journeys/v2/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysV2SplatRoute;
  '/workspaces/$workspaceId/objects/$slug/$objectId': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRouteWithChildren;
  '/workspaces/$workspaceId/objects/$slug/guide': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugGuideRoute;
  '/workspaces/$workspaceId/objects/$slug/new': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugNewRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteWithChildren;
  '/workspaces/$workspaceId/pipelines/destinations/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddRoute;
  '/workspaces/$workspaceId/pipelines/destinations/journeys': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsJourneysRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteWithChildren;
  '/workspaces/$workspaceId/pipelines/sources/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddRoute;
  '/workspaces/$workspaceId/pipelines/sources/journeys': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesJourneysRoute;
  '/workspaces/$workspaceId/settings/actions/email': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRouteWithChildren;
  '/workspaces/$workspaceId/settings/actions/line': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsLineRoute;
  '/workspaces/$workspaceId/settings/actions/message_frequency_limits': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessage_frequency_limitsRoute;
  '/workspaces/$workspaceId/settings/actions/messaging_limit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessaging_limitRoute;
  '/workspaces/$workspaceId/settings/actions/slack': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSlackRoute;
  '/workspaces/$workspaceId/settings/actions/sms-providers': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRouteWithChildren;
  '/workspaces/$workspaceId/settings/actions/time_zone_match': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsTime_zone_matchRoute;
  '/workspaces/$workspaceId/settings/actions/urban_airship': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrban_airshipRoute;
  '/workspaces/$workspaceId/settings/actions/url_params': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRouteWithChildren;
  '/workspaces/$workspaceId/settings/llm_configuration/new': typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationNewRoute;
  '/workspaces/$workspaceId/settings/objects/new': typeof AuthenticatedWorkspacesWorkspaceIdSettingsObjectsNewRoute;
  '/workspaces/$workspaceId/settings/subscription_center/settings': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerSettingsRoute;
  '/workspaces/$workspaceId/settings/webhook_configuration/new': typeof AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationNewRoute;
  '/workspaces/$workspaceId/agent/skills/': typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsIndexRoute;
  '/workspaces/$workspaceId/geosets/$geosetId/': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdIndexRoute;
  '/workspaces/$workspaceId/home/workspace-setup/': typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupIndexRoute;
  '/workspaces/$workspaceId/imports/$importId/': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdIndexRoute;
  '/workspaces/$workspaceId/integrations/all/': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllIndexRoute;
  '/workspaces/$workspaceId/integrations/reporting-webhooks/': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksIndexRoute;
  '/workspaces/$workspaceId/journeys/activity_logs/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsIndexRoute;
  '/workspaces/$workspaceId/journeys/collections/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsIndexRoute;
  '/workspaces/$workspaceId/journeys/geofences/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesIndexRoute;
  '/workspaces/$workspaceId/journeys/imports/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsIndexRoute;
  '/workspaces/$workspaceId/journeys/integrations/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsIndexRoute;
  '/workspaces/$workspaceId/journeys/layouts/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsIndexRoute;
  '/workspaces/$workspaceId/journeys/objects/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsIndexRoute;
  '/workspaces/$workspaceId/journeys/people/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleIndexRoute;
  '/workspaces/$workspaceId/journeys/profile_activity/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityIndexRoute;
  '/workspaces/$workspaceId/journeys/profiles/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesIndexRoute;
  '/workspaces/$workspaceId/journeys/snippets/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsIndexRoute;
  '/workspaces/$workspaceId/journeys/template/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTemplateIndexRoute;
  '/workspaces/$workspaceId/journeys/triggered/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredIndexRoute;
  '/workspaces/$workspaceId/objects/$slug/': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugIndexRoute;
  '/workspaces/$workspaceId/pipelines/destinations/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsIndexRoute;
  '/workspaces/$workspaceId/pipelines/sources/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesIndexRoute;
  '/workspaces/$workspaceId/settings/api_credentials/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsIndexRoute;
  '/workspaces/$workspaceId/settings/llm_configuration/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationIndexRoute;
  '/workspaces/$workspaceId/settings/objects/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsObjectsIndexRoute;
  '/workspaces/$workspaceId/settings/subscription_center/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerIndexRoute;
  '/workspaces/$workspaceId/settings/webhook_configuration/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationIndexRoute;
  '/workspaces/$workspaceId/geosets/$geosetId/geofences/$geofenceId': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesGeofenceIdRoute;
  '/workspaces/$workspaceId/geosets/$geosetId/geofences/import': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesImportRoute;
  '/workspaces/$workspaceId/geosets/$geosetId/geofences/new': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesNewRoute;
  '/workspaces/$workspaceId/imports/$importId/setup/fields': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupFieldsRoute;
  '/workspaces/$workspaceId/imports/$importId/setup/importing': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupImportingRoute;
  '/workspaces/$workspaceId/imports/$importId/setup/preprocessing': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreprocessingRoute;
  '/workspaces/$workspaceId/imports/$importId/setup/preview': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreviewRoute;
  '/workspaces/$workspaceId/imports/$importId/setup/review': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupReviewRoute;
  '/workspaces/$workspaceId/imports/$importId/setup/validating': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupValidatingRoute;
  '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRouteWithChildren;
  '/workspaces/$workspaceId/integrations/sql-sync/$type/new': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeNewRoute;
  '/workspaces/$workspaceId/integrations/warehouse/$type/sync': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeSyncRoute;
  '/workspaces/$workspaceId/journeys/collections/$collectionId/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdSplatRoute;
  '/workspaces/$workspaceId/journeys/collections/$collectionId/data': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdDataRoute;
  '/workspaces/$workspaceId/journeys/collections/$collectionId/importing': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdImportingRoute;
  '/workspaces/$workspaceId/journeys/collections/$collectionId/usage': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdUsageRoute;
  '/workspaces/$workspaceId/journeys/integrations/all/developers': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDevelopersRoute;
  '/workspaces/$workspaceId/journeys/integrations/all/directory': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDirectoryRoute;
  '/workspaces/$workspaceId/journeys/integrations/all/overview': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllOverviewRoute;
  '/workspaces/$workspaceId/journeys/integrations/all/webhooks': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllWebhooksRoute;
  '/workspaces/$workspaceId/journeys/integrations/data_out/$type': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsData_outTypeRoute;
  '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/$webhookId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksWebhookIdRoute;
  '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksNewRoute;
  '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRouteWithChildren;
  '/workspaces/$workspaceId/journeys/integrations/warehouse/$type': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeRoute;
  '/workspaces/$workspaceId/journeys/integrations/warehouse/bigquery': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseBigqueryRoute;
  '/workspaces/$workspaceId/journeys/integrations/warehouse/redshift': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseRedshiftRoute;
  '/workspaces/$workspaceId/journeys/integrations/warehouse/snowflake': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseSnowflakeRoute;
  '/workspaces/$workspaceId/journeys/layouts/$layoutId/edit': typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdEditRoute;
  '/workspaces/$workspaceId/journeys/objects/$slug/guide': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugGuideRoute;
  '/workspaces/$workspaceId/journeys/objects/$slug/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugNewRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/data-out': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdDataOutRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/exports': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdExportsRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/settings': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSettingsRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteWithChildren;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/tester': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdTesterRoute;
  '/workspaces/$workspaceId/pipelines/destinations/add/$destinationOptionId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddDestinationOptionIdRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/data-in': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDataInRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/databases': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDatabasesRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/imports': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdImportsRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/settings': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSettingsRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsRoute;
  '/workspaces/$workspaceId/pipelines/sources/add/$sourceOptionId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddSourceOptionIdRoute;
  '/workspaces/$workspaceId/settings/actions/email/defaults': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDefaultsRoute;
  '/workspaces/$workspaceId/settings/actions/email/deliverability': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDeliverabilityRoute;
  '/workspaces/$workspaceId/settings/actions/email/dynamic_addresses': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDynamic_addressesRoute;
  '/workspaces/$workspaceId/settings/actions/email/from_addresses': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailFrom_addressesRoute;
  '/workspaces/$workspaceId/settings/actions/email/smtp': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSmtpRoute;
  '/workspaces/$workspaceId/settings/actions/email/suppression_list': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSuppression_listRoute;
  '/workspaces/$workspaceId/settings/actions/url_params/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsEditRoute;
  '/workspaces/$workspaceId/settings/api_credentials/service_accounts/$serviceAccountId': typeof AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsService_accountsServiceAccountIdRoute;
  '/workspaces/$workspaceId/settings/llm_configuration/$configurationId/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationConfigurationIdEditRoute;
  '/workspaces/$workspaceId/settings/objects/edit/$objectType': typeof AuthenticatedWorkspacesWorkspaceIdSettingsObjectsEditObjectTypeRoute;
  '/workspaces/$workspaceId/settings/subscription_center/branding/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerBrandingEditRoute;
  '/workspaces/$workspaceId/settings/subscription_center/localization/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerLocalizationEditRoute;
  '/workspaces/$workspaceId/settings/subscription_center/topics/set_preferences': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsSet_preferencesRoute;
  '/workspaces/$workspaceId/settings/webhook_configuration/$webhookId/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationWebhookIdEditRoute;
  '/workspaces/$workspaceId/dev/db/campaigns/': typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsIndexRoute;
  '/workspaces/$workspaceId/geosets/$geosetId/geofences/': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesIndexRoute;
  '/workspaces/$workspaceId/imports/$importId/setup/': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupIndexRoute;
  '/workspaces/$workspaceId/integrations/sql-sync/$type/': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeIndexRoute;
  '/workspaces/$workspaceId/journeys/collections/$collectionId/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdIndexRoute;
  '/workspaces/$workspaceId/journeys/imports/$importId/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdIndexRoute;
  '/workspaces/$workspaceId/journeys/integrations/all/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllIndexRoute;
  '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksIndexRoute;
  '/workspaces/$workspaceId/journeys/layouts/$layoutId/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdIndexRoute;
  '/workspaces/$workspaceId/journeys/objects/$slug/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugIndexRoute;
  '/workspaces/$workspaceId/objects/$slug/$objectId/': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdIndexRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdIndexRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdIndexRoute;
  '/workspaces/$workspaceId/settings/actions/email/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailIndexRoute;
  '/workspaces/$workspaceId/settings/actions/sms-providers/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersIndexRoute;
  '/workspaces/$workspaceId/settings/actions/url_params/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsIndexRoute;
  '/workspaces/$workspaceId/settings/subscription_center/topics/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsIndexRoute;
  '/workspaces/$workspaceId/dev/db/campaigns/actions/$actionId': typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsActionsActionIdRoute;
  '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/query': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdQueryRoute;
  '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/relationships-query': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRoute;
  '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/settings': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdSettingsRoute;
  '/workspaces/$workspaceId/journeys/imports/$importId/setup/fields': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupFieldsRoute;
  '/workspaces/$workspaceId/journeys/imports/$importId/setup/importing': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupImportingRoute;
  '/workspaces/$workspaceId/journeys/imports/$importId/setup/preprocessing': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreprocessingRoute;
  '/workspaces/$workspaceId/journeys/imports/$importId/setup/preview': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreviewRoute;
  '/workspaces/$workspaceId/journeys/imports/$importId/setup/review': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupReviewRoute;
  '/workspaces/$workspaceId/journeys/imports/$importId/setup/validating': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupValidatingRoute;
  '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRoute;
  '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeNewRoute;
  '/workspaces/$workspaceId/journeys/integrations/warehouse/$type/sync': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeSyncRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/$subscriptionId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsSubscriptionIdRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsAddRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs/$syncId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsSyncIdRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsAddRoute;
  '/workspaces/$workspaceId/settings/actions/email/sending_domains/$domainId': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsDomainIdRoute;
  '/workspaces/$workspaceId/settings/actions/sms-providers/credentials/$credentialId': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersCredentialsCredentialIdRoute;
  '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdIndexRoute;
  '/workspaces/$workspaceId/journeys/imports/$importId/setup/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupIndexRoute;
  '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeIndexRoute;
  '/workspaces/$workspaceId/journeys/objects/$slug/$objectId/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdIndexRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsIndexRoute;
  '/workspaces/$workspaceId/settings/actions/email/sending_domains/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsIndexRoute;
  '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/workflow/actions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewWorkflowActionsRoute;
  '/workspaces/$workspaceId/journeys/automations/$campaignId/setup/workflow/actions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdSetupWorkflowActionsRoute;
  '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/workflow/actions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewWorkflowActionsRoute;
  '/workspaces/$workspaceId/journeys/campaigns/$campaignId/setup/workflow/actions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdSetupWorkflowActionsRoute;
  '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId/query': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdQueryRoute;
  '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId/relationships-query': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRoute;
  '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId/settings': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdSettingsRoute;
}
export interface FileRoutesByTo {
  '/academy-login': typeof AcademyLoginRoute;
  '/accept-guest-invitation': typeof AcceptGuestInvitationRoute;
  '/checkout': typeof CheckoutRoute;
  '/design-studio-embed': typeof DesignStudioEmbedRouteWithChildren;
  '/join-request': typeof JoinRequestRoute;
  '/2fa_setup/$': typeof R2fa_setupSplatRoute;
  '/$': typeof AuthenticatedSplatRoute;
  '/account/$': typeof AccountSplatRoute;
  '/account_canceled/$': typeof Account_canceledSplatRoute;
  '/account_cancelled/$': typeof Account_cancelledSplatRoute;
  '/cli/dns-setup': typeof CliDnsSetupRoute;
  '/confirm_account/$': typeof Confirm_accountSplatRoute;
  '/confirm_account_notice/$': typeof Confirm_account_noticeSplatRoute;
  '/env/$': typeof EnvSplatRoute;
  '/har-sanitizer/$': typeof HarSanitizerSplatRoute;
  '/integrations/$': typeof IntegrationsSplatRoute;
  '/journeys/$': typeof JourneysSplatRoute;
  '/login/$': typeof LoginSplatRoute;
  '/logout/$': typeof LogoutSplatRoute;
  '/no_accessible_workspaces/$': typeof No_accessible_workspacesSplatRoute;
  '/oauth/$': typeof OauthSplatRoute;
  '/oauth2/$': typeof Oauth2SplatRoute;
  '/onboarding/get-started': typeof OnboardingGetStartedRoute;
  '/onboarding/verification': typeof OnboardingVerificationRoute;
  '/onboarding/wizard': typeof OnboardingWizardRoute;
  '/post_cancel/$': typeof Post_cancelSplatRoute;
  '/post_registration/$': typeof Post_registrationSplatRoute;
  '/reset_password/$': typeof Reset_passwordSplatRoute;
  '/signup/$': typeof SignupSplatRoute;
  '/users/$': typeof UsersSplatRoute;
  '/vwb-demo/$': typeof VwbDemoSplatRoute;
  '/': typeof AuthenticatedIndexRoute;
  '/cli': typeof CliIndexRoute;
  '/onboarding': typeof OnboardingIndexRoute;
  '/internal-tools/$': typeof AuthenticatedInternalToolsSplatRoute;
  '/sample-workspace/$': typeof AuthenticatedSampleWorkspaceSplatRoute;
  '/settings/$': typeof AuthenticatedSettingsSplatRoute;
  '/settings/ai': typeof AuthenticatedSettingsAiRoute;
  '/settings/api-keys': typeof AuthenticatedSettingsApiKeysRoute;
  '/settings/audit-logs': typeof AuthenticatedSettingsAuditLogsRoute;
  '/settings/experimental-features': typeof AuthenticatedSettingsExperimentalFeaturesRoute;
  '/settings/privacy': typeof AuthenticatedSettingsPrivacyRoute;
  '/settings/receipts': typeof AuthenticatedSettingsReceiptsRoute;
  '/settings/slack-agent': typeof AuthenticatedSettingsSlackAgentRoute;
  '/settings/subscription': typeof AuthenticatedSettingsSubscriptionRoute;
  '/trial-expired/journeys': typeof AuthenticatedTrialExpiredJourneysRoute;
  '/account/cancelled/$': typeof AccountCancelledSplatRoute;
  '/design-studio-embed/cio/$': typeof DesignStudioEmbedCioSplatRoute;
  '/internal-tools': typeof AuthenticatedInternalToolsIndexRoute;
  '/sample-workspace': typeof AuthenticatedSampleWorkspaceIndexRoute;
  '/settings': typeof AuthenticatedSettingsIndexRoute;
  '/workspaces': typeof AuthenticatedWorkspacesIndexRoute;
  '/design-studio-embed/cio': typeof DesignStudioEmbedCioIndexRoute;
  '/settings/account/edit': typeof AuthenticatedSettingsAccountEditRoute;
  '/settings/billing/$': typeof AuthenticatedSettingsBillingSplatRoute;
  '/settings/billing/billing-details': typeof AuthenticatedSettingsBillingBillingDetailsRoute;
  '/settings/billing/billing-history': typeof AuthenticatedSettingsBillingBillingHistoryRoute;
  '/settings/billing/checkout': typeof AuthenticatedSettingsBillingCheckoutRoute;
  '/settings/billing/inbox-preview-usage': typeof AuthenticatedSettingsBillingInboxPreviewUsageRoute;
  '/settings/billing/llm-usage': typeof AuthenticatedSettingsBillingLlmUsageRoute;
  '/settings/billing/overview': typeof AuthenticatedSettingsBillingOverviewRoute;
  '/settings/billing/payment-methods': typeof AuthenticatedSettingsBillingPaymentMethodsRoute;
  '/settings/billing/profile-growth': typeof AuthenticatedSettingsBillingProfileGrowthRoute;
  '/settings/billing/usage': typeof AuthenticatedSettingsBillingUsageRoute;
  '/settings/billing/your-plan': typeof AuthenticatedSettingsBillingYourPlanRoute;
  '/settings/partner/create': typeof AuthenticatedSettingsPartnerCreateRoute;
  '/settings/personal/google-identities': typeof AuthenticatedSettingsPersonalGoogleIdentitiesRoute;
  '/settings/roles/$roleId': typeof AuthenticatedSettingsRolesRoleIdRoute;
  '/settings/roles/new': typeof AuthenticatedSettingsRolesNewRoute;
  '/settings/security/sso': typeof AuthenticatedSettingsSecuritySsoRoute;
  '/settings/slack-agent/link': typeof AuthenticatedSettingsSlackAgentLinkRoute;
  '/settings/team/add': typeof AuthenticatedSettingsTeamAddRoute;
  '/settings/team/invite-guest': typeof AuthenticatedSettingsTeamInviteGuestRoute;
  '/settings/workspaces/new': typeof AuthenticatedSettingsWorkspacesNewRoute;
  '/workspaces/$workspaceId/$': typeof AuthenticatedWorkspacesWorkspaceIdSplatRoute;
  '/workspaces/$workspaceId/assets': typeof AuthenticatedWorkspacesWorkspaceIdAssetsRoute;
  '/workspaces/$workspaceId/exports': typeof AuthenticatedWorkspacesWorkspaceIdExportsRoute;
  '/workspaces/$workspaceId/health': typeof AuthenticatedWorkspacesWorkspaceIdHealthRoute;
  '/workspaces/$workspaceId/journeys': typeof AuthenticatedWorkspacesWorkspaceIdJourneysRoute;
  '/workspaces/$workspaceId/message-library': typeof AuthenticatedWorkspacesWorkspaceIdMessageLibraryRoute;
  '/workspaces/$workspaceId/tasks': typeof AuthenticatedWorkspacesWorkspaceIdTasksRoute;
  '/pipelines/workspaces/$workspaceId/$': typeof PipelinesWorkspacesWorkspaceIdSplatRoute;
  '/settings/account': typeof AuthenticatedSettingsAccountIndexRoute;
  '/settings/api_credentials': typeof AuthenticatedSettingsApi_credentialsIndexRoute;
  '/settings/billing': typeof AuthenticatedSettingsBillingIndexRoute;
  '/settings/partner': typeof AuthenticatedSettingsPartnerIndexRoute;
  '/settings/personal': typeof AuthenticatedSettingsPersonalIndexRoute;
  '/settings/roles': typeof AuthenticatedSettingsRolesIndexRoute;
  '/settings/security': typeof AuthenticatedSettingsSecurityIndexRoute;
  '/settings/team': typeof AuthenticatedSettingsTeamIndexRoute;
  '/settings/workspaces': typeof AuthenticatedSettingsWorkspacesIndexRoute;
  '/workspaces/$workspaceId': typeof AuthenticatedWorkspacesWorkspaceIdIndexRoute;
  '/pipelines/workspaces/$workspaceId': typeof PipelinesWorkspacesWorkspaceIdIndexRoute;
  '/settings/api_credentials/service_accounts/$serviceAccountId': typeof AuthenticatedSettingsApi_credentialsService_accountsServiceAccountIdRoute;
  '/settings/billing/available-plans/journeys': typeof AuthenticatedSettingsBillingAvailablePlansJourneysRoute;
  '/settings/team/join-requests/$requestId': typeof AuthenticatedSettingsTeamJoinRequestsRequestIdRoute;
  '/workspaces/$workspaceId/agent/routines': typeof AuthenticatedWorkspacesWorkspaceIdAgentRoutinesRoute;
  '/workspaces/$workspaceId/analysis/deliverability': typeof AuthenticatedWorkspacesWorkspaceIdAnalysisDeliverabilityRoute;
  '/workspaces/$workspaceId/analysis/email-clients': typeof AuthenticatedWorkspacesWorkspaceIdAnalysisEmailClientsRoute;
  '/workspaces/$workspaceId/boards/$boardId': typeof AuthenticatedWorkspacesWorkspaceIdBoardsBoardIdRoute;
  '/workspaces/$workspaceId/design-studio/$': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioSplatRoute;
  '/workspaces/$workspaceId/design-studio/dashboard': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioDashboardRoute;
  '/workspaces/$workspaceId/design-studio/global-styles': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioGlobalStylesRoute;
  '/workspaces/$workspaceId/dev/condition-viewer': typeof AuthenticatedWorkspacesWorkspaceIdDevConditionViewerRoute;
  '/workspaces/$workspaceId/experiments/$experimentId': typeof AuthenticatedWorkspacesWorkspaceIdExperimentsExperimentIdRoute;
  '/workspaces/$workspaceId/experiments/new': typeof AuthenticatedWorkspacesWorkspaceIdExperimentsNewRoute;
  '/workspaces/$workspaceId/geosets/import': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsImportRoute;
  '/workspaces/$workspaceId/geosets/new': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsNewRoute;
  '/workspaces/$workspaceId/home/add-people': typeof AuthenticatedWorkspacesWorkspaceIdHomeAddPeopleRoute;
  '/workspaces/$workspaceId/imports/new': typeof AuthenticatedWorkspacesWorkspaceIdImportsNewRoute;
  '/workspaces/$workspaceId/integrations/$type': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsTypeRoute;
  '/workspaces/$workspaceId/integrations/cdp_in': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_inRoute;
  '/workspaces/$workspaceId/integrations/cdp_out': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_outRoute;
  '/workspaces/$workspaceId/integrations/customerio': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsCustomerioRoute;
  '/workspaces/$workspaceId/integrations/mparticle_out': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsMparticle_outRoute;
  '/workspaces/$workspaceId/integrations/segment_in': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_inRoute;
  '/workspaces/$workspaceId/integrations/segment_out': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_outRoute;
  '/workspaces/$workspaceId/journeys/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSplatRoute;
  '/workspaces/$workspaceId/journeys/assets': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAssetsRoute;
  '/workspaces/$workspaceId/journeys/deliveries': typeof AuthenticatedWorkspacesWorkspaceIdJourneysDeliveriesRoute;
  '/workspaces/$workspaceId/journeys/drafts': typeof AuthenticatedWorkspacesWorkspaceIdJourneysDraftsRoute;
  '/workspaces/$workspaceId/journeys/exports': typeof AuthenticatedWorkspacesWorkspaceIdJourneysExportsRoute;
  '/workspaces/$workspaceId/journeys/message-library': typeof AuthenticatedWorkspacesWorkspaceIdJourneysMessageLibraryRoute;
  '/workspaces/$workspaceId/journeys/settings': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteWithChildren;
  '/workspaces/$workspaceId/journeys/tasks': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTasksRoute;
  '/workspaces/$workspaceId/outcomes/$goalId': typeof AuthenticatedWorkspacesWorkspaceIdOutcomesGoalIdRoute;
  '/workspaces/$workspaceId/parcel/$': typeof AuthenticatedWorkspacesWorkspaceIdParcelSplatRoute;
  '/workspaces/$workspaceId/people/create': typeof AuthenticatedWorkspacesWorkspaceIdPeopleCreateRoute;
  '/workspaces/$workspaceId/people/merge': typeof AuthenticatedWorkspacesWorkspaceIdPeopleMergeRoute;
  '/workspaces/$workspaceId/people/new': typeof AuthenticatedWorkspacesWorkspaceIdPeopleNewRoute;
  '/workspaces/$workspaceId/people/welcome': typeof AuthenticatedWorkspacesWorkspaceIdPeopleWelcomeRoute;
  '/workspaces/$workspaceId/profiles/create': typeof AuthenticatedWorkspacesWorkspaceIdProfilesCreateRoute;
  '/workspaces/$workspaceId/profiles/merge': typeof AuthenticatedWorkspacesWorkspaceIdProfilesMergeRoute;
  '/workspaces/$workspaceId/profiles/new': typeof AuthenticatedWorkspacesWorkspaceIdProfilesNewRoute;
  '/workspaces/$workspaceId/profiles/welcome': typeof AuthenticatedWorkspacesWorkspaceIdProfilesWelcomeRoute;
  '/workspaces/$workspaceId/reports/deliverability': typeof AuthenticatedWorkspacesWorkspaceIdReportsDeliverabilityRoute;
  '/workspaces/$workspaceId/reports/email-clients': typeof AuthenticatedWorkspacesWorkspaceIdReportsEmailClientsRoute;
  '/workspaces/$workspaceId/settings/$': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSplatRoute;
  '/workspaces/$workspaceId/settings/ai-business-profile': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAiBusinessProfileRoute;
  '/workspaces/$workspaceId/settings/anonymous_events': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAnonymous_eventsRoute;
  '/workspaces/$workspaceId/settings/api-keys': typeof AuthenticatedWorkspacesWorkspaceIdSettingsApiKeysRoute;
  '/workspaces/$workspaceId/settings/audit-logs': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAuditLogsRoute;
  '/workspaces/$workspaceId/settings/auto_archive': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAuto_archiveRoute;
  '/workspaces/$workspaceId/settings/confirm_delete': typeof AuthenticatedWorkspacesWorkspaceIdSettingsConfirm_deleteRoute;
  '/workspaces/$workspaceId/settings/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsEditRoute;
  '/workspaces/$workspaceId/settings/geofences': typeof AuthenticatedWorkspacesWorkspaceIdSettingsGeofencesRoute;
  '/workspaces/$workspaceId/settings/language': typeof AuthenticatedWorkspacesWorkspaceIdSettingsLanguageRoute;
  '/workspaces/$workspaceId/settings/merge_options': typeof AuthenticatedWorkspacesWorkspaceIdSettingsMerge_optionsRoute;
  '/workspaces/$workspaceId/settings/suppressions': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSuppressionsRoute;
  '/workspaces/$workspaceId/snippets/$snippetId': typeof AuthenticatedWorkspacesWorkspaceIdSnippetsSnippetIdRoute;
  '/workspaces/$workspaceId/snippets/new': typeof AuthenticatedWorkspacesWorkspaceIdSnippetsNewRoute;
  '/workspaces/$workspaceId/template/$templateId': typeof AuthenticatedWorkspacesWorkspaceIdTemplateTemplateIdRoute;
  '/settings/billing/available-plans': typeof AuthenticatedSettingsBillingAvailablePlansIndexRoute;
  '/workspaces/$workspaceId/agent': typeof AuthenticatedWorkspacesWorkspaceIdAgentIndexRoute;
  '/workspaces/$workspaceId/boards': typeof AuthenticatedWorkspacesWorkspaceIdBoardsIndexRoute;
  '/workspaces/$workspaceId/design-studio': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioIndexRoute;
  '/workspaces/$workspaceId/experiments': typeof AuthenticatedWorkspacesWorkspaceIdExperimentsIndexRoute;
  '/workspaces/$workspaceId/geosets': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsIndexRoute;
  '/workspaces/$workspaceId/home': typeof AuthenticatedWorkspacesWorkspaceIdHomeIndexRoute;
  '/workspaces/$workspaceId/imports': typeof AuthenticatedWorkspacesWorkspaceIdImportsIndexRoute;
  '/workspaces/$workspaceId/integrations': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsIndexRoute;
  '/workspaces/$workspaceId/objects': typeof AuthenticatedWorkspacesWorkspaceIdObjectsIndexRoute;
  '/workspaces/$workspaceId/outcomes': typeof AuthenticatedWorkspacesWorkspaceIdOutcomesIndexRoute;
  '/workspaces/$workspaceId/parcel': typeof AuthenticatedWorkspacesWorkspaceIdParcelIndexRoute;
  '/workspaces/$workspaceId/people': typeof AuthenticatedWorkspacesWorkspaceIdPeopleIndexRoute;
  '/workspaces/$workspaceId/pipelines': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesIndexRoute;
  '/workspaces/$workspaceId/profiles': typeof AuthenticatedWorkspacesWorkspaceIdProfilesIndexRoute;
  '/workspaces/$workspaceId/settings': typeof AuthenticatedWorkspacesWorkspaceIdSettingsIndexRoute;
  '/workspaces/$workspaceId/snippets': typeof AuthenticatedWorkspacesWorkspaceIdSnippetsIndexRoute;
  '/workspaces/$workspaceId/template': typeof AuthenticatedWorkspacesWorkspaceIdTemplateIndexRoute;
  '/settings/team/members/$userId/edit': typeof AuthenticatedSettingsTeamMembersUserIdEditRoute;
  '/workspaces/$workspaceId/agent/skills/$skillPath': typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsSkillPathRoute;
  '/workspaces/$workspaceId/agent/skills/new': typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsNewRoute;
  '/workspaces/$workspaceId/automations/$campaignId/workflow': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdWorkflowRoute;
  '/workspaces/$workspaceId/geosets/$geosetId/edit': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdEditRoute;
  '/workspaces/$workspaceId/home/workspace-setup/add-people': typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupAddPeopleRoute;
  '/workspaces/$workspaceId/integrations/all/developers': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDevelopersRoute;
  '/workspaces/$workspaceId/integrations/all/directory': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDirectoryRoute;
  '/workspaces/$workspaceId/integrations/all/overview': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllOverviewRoute;
  '/workspaces/$workspaceId/integrations/all/webhooks': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllWebhooksRoute;
  '/workspaces/$workspaceId/integrations/data_out/$type': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsData_outTypeRoute;
  '/workspaces/$workspaceId/integrations/reporting-webhooks/$webhookId': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksWebhookIdRoute;
  '/workspaces/$workspaceId/integrations/reporting-webhooks/new': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksNewRoute;
  '/workspaces/$workspaceId/integrations/warehouse/$type': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeRoute;
  '/workspaces/$workspaceId/integrations/warehouse/bigquery': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseBigqueryRoute;
  '/workspaces/$workspaceId/integrations/warehouse/redshift': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseRedshiftRoute;
  '/workspaces/$workspaceId/integrations/warehouse/snowflake': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseSnowflakeRoute;
  '/workspaces/$workspaceId/journeys/activity_logs/$tab': typeof AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsTabRoute;
  '/workspaces/$workspaceId/journeys/analysis/deliverability': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisDeliverabilityRoute;
  '/workspaces/$workspaceId/journeys/geofences/$geofenceId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesGeofenceIdRoute;
  '/workspaces/$workspaceId/journeys/geofences/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesNewRoute;
  '/workspaces/$workspaceId/journeys/imports/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsNewRoute;
  '/workspaces/$workspaceId/journeys/integrations/$type': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsTypeRoute;
  '/workspaces/$workspaceId/journeys/integrations/cdp_in': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_inRoute;
  '/workspaces/$workspaceId/journeys/integrations/cdp_out': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_outRoute;
  '/workspaces/$workspaceId/journeys/integrations/customerio': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCustomerioRoute;
  '/workspaces/$workspaceId/journeys/integrations/mparticle_out': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsMparticle_outRoute;
  '/workspaces/$workspaceId/journeys/integrations/segment_in': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_inRoute;
  '/workspaces/$workspaceId/journeys/integrations/segment_out': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_outRoute;
  '/workspaces/$workspaceId/journeys/layouts/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsNewRoute;
  '/workspaces/$workspaceId/journeys/layouts/starters': typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsStartersRoute;
  '/workspaces/$workspaceId/journeys/message_activity/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysMessage_activitySplatRoute;
  '/workspaces/$workspaceId/journeys/outbox/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysOutboxSplatRoute;
  '/workspaces/$workspaceId/journeys/people/create': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleCreateRoute;
  '/workspaces/$workspaceId/journeys/people/merge': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleMergeRoute;
  '/workspaces/$workspaceId/journeys/people/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleNewRoute;
  '/workspaces/$workspaceId/journeys/people/welcome': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleWelcomeRoute;
  '/workspaces/$workspaceId/journeys/profile_activity/$tab': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityTabRoute;
  '/workspaces/$workspaceId/journeys/profiles/create': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesCreateRoute;
  '/workspaces/$workspaceId/journeys/profiles/merge': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesMergeRoute;
  '/workspaces/$workspaceId/journeys/profiles/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesNewRoute;
  '/workspaces/$workspaceId/journeys/profiles/welcome': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesWelcomeRoute;
  '/workspaces/$workspaceId/journeys/settings/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSettingsSplatRoute;
  '/workspaces/$workspaceId/journeys/setup-guide/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSetupGuideSplatRoute;
  '/workspaces/$workspaceId/journeys/snippets/$snippetId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsSnippetIdRoute;
  '/workspaces/$workspaceId/journeys/snippets/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsNewRoute;
  '/workspaces/$workspaceId/journeys/template/$templateId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTemplateTemplateIdRoute;
  '/workspaces/$workspaceId/journeys/triggered/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredNewRoute;
  '/workspaces/$workspaceId/journeys/v2/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysV2SplatRoute;
  '/workspaces/$workspaceId/objects/$slug/guide': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugGuideRoute;
  '/workspaces/$workspaceId/objects/$slug/new': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugNewRoute;
  '/workspaces/$workspaceId/pipelines/destinations/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddRoute;
  '/workspaces/$workspaceId/pipelines/destinations/journeys': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsJourneysRoute;
  '/workspaces/$workspaceId/pipelines/sources/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddRoute;
  '/workspaces/$workspaceId/pipelines/sources/journeys': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesJourneysRoute;
  '/workspaces/$workspaceId/settings/actions/line': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsLineRoute;
  '/workspaces/$workspaceId/settings/actions/message_frequency_limits': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessage_frequency_limitsRoute;
  '/workspaces/$workspaceId/settings/actions/messaging_limit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessaging_limitRoute;
  '/workspaces/$workspaceId/settings/actions/slack': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSlackRoute;
  '/workspaces/$workspaceId/settings/actions/time_zone_match': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsTime_zone_matchRoute;
  '/workspaces/$workspaceId/settings/actions/urban_airship': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrban_airshipRoute;
  '/workspaces/$workspaceId/settings/llm_configuration/new': typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationNewRoute;
  '/workspaces/$workspaceId/settings/objects/new': typeof AuthenticatedWorkspacesWorkspaceIdSettingsObjectsNewRoute;
  '/workspaces/$workspaceId/settings/subscription_center/settings': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerSettingsRoute;
  '/workspaces/$workspaceId/settings/webhook_configuration/new': typeof AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationNewRoute;
  '/workspaces/$workspaceId/agent/skills': typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsIndexRoute;
  '/workspaces/$workspaceId/geosets/$geosetId': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdIndexRoute;
  '/workspaces/$workspaceId/home/workspace-setup': typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupIndexRoute;
  '/workspaces/$workspaceId/imports/$importId': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdIndexRoute;
  '/workspaces/$workspaceId/integrations/all': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllIndexRoute;
  '/workspaces/$workspaceId/integrations/reporting-webhooks': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksIndexRoute;
  '/workspaces/$workspaceId/journeys/activity_logs': typeof AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsIndexRoute;
  '/workspaces/$workspaceId/journeys/collections': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsIndexRoute;
  '/workspaces/$workspaceId/journeys/geofences': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesIndexRoute;
  '/workspaces/$workspaceId/journeys/imports': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsIndexRoute;
  '/workspaces/$workspaceId/journeys/integrations': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsIndexRoute;
  '/workspaces/$workspaceId/journeys/layouts': typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsIndexRoute;
  '/workspaces/$workspaceId/journeys/objects': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsIndexRoute;
  '/workspaces/$workspaceId/journeys/people': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleIndexRoute;
  '/workspaces/$workspaceId/journeys/profile_activity': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityIndexRoute;
  '/workspaces/$workspaceId/journeys/profiles': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesIndexRoute;
  '/workspaces/$workspaceId/journeys/snippets': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsIndexRoute;
  '/workspaces/$workspaceId/journeys/template': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTemplateIndexRoute;
  '/workspaces/$workspaceId/journeys/triggered': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredIndexRoute;
  '/workspaces/$workspaceId/objects/$slug': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugIndexRoute;
  '/workspaces/$workspaceId/pipelines/destinations': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsIndexRoute;
  '/workspaces/$workspaceId/pipelines/sources': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesIndexRoute;
  '/workspaces/$workspaceId/settings/api_credentials': typeof AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsIndexRoute;
  '/workspaces/$workspaceId/settings/llm_configuration': typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationIndexRoute;
  '/workspaces/$workspaceId/settings/objects': typeof AuthenticatedWorkspacesWorkspaceIdSettingsObjectsIndexRoute;
  '/workspaces/$workspaceId/settings/subscription_center': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerIndexRoute;
  '/workspaces/$workspaceId/settings/webhook_configuration': typeof AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationIndexRoute;
  '/workspaces/$workspaceId/geosets/$geosetId/geofences/$geofenceId': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesGeofenceIdRoute;
  '/workspaces/$workspaceId/geosets/$geosetId/geofences/import': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesImportRoute;
  '/workspaces/$workspaceId/geosets/$geosetId/geofences/new': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesNewRoute;
  '/workspaces/$workspaceId/imports/$importId/setup/fields': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupFieldsRoute;
  '/workspaces/$workspaceId/imports/$importId/setup/importing': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupImportingRoute;
  '/workspaces/$workspaceId/imports/$importId/setup/preprocessing': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreprocessingRoute;
  '/workspaces/$workspaceId/imports/$importId/setup/preview': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreviewRoute;
  '/workspaces/$workspaceId/imports/$importId/setup/review': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupReviewRoute;
  '/workspaces/$workspaceId/imports/$importId/setup/validating': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupValidatingRoute;
  '/workspaces/$workspaceId/integrations/sql-sync/$type/new': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeNewRoute;
  '/workspaces/$workspaceId/integrations/warehouse/$type/sync': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeSyncRoute;
  '/workspaces/$workspaceId/journeys/collections/$collectionId/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdSplatRoute;
  '/workspaces/$workspaceId/journeys/collections/$collectionId/data': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdDataRoute;
  '/workspaces/$workspaceId/journeys/collections/$collectionId/importing': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdImportingRoute;
  '/workspaces/$workspaceId/journeys/collections/$collectionId/usage': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdUsageRoute;
  '/workspaces/$workspaceId/journeys/integrations/all/developers': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDevelopersRoute;
  '/workspaces/$workspaceId/journeys/integrations/all/directory': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDirectoryRoute;
  '/workspaces/$workspaceId/journeys/integrations/all/overview': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllOverviewRoute;
  '/workspaces/$workspaceId/journeys/integrations/all/webhooks': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllWebhooksRoute;
  '/workspaces/$workspaceId/journeys/integrations/data_out/$type': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsData_outTypeRoute;
  '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/$webhookId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksWebhookIdRoute;
  '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksNewRoute;
  '/workspaces/$workspaceId/journeys/integrations/warehouse/$type': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeRoute;
  '/workspaces/$workspaceId/journeys/integrations/warehouse/bigquery': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseBigqueryRoute;
  '/workspaces/$workspaceId/journeys/integrations/warehouse/redshift': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseRedshiftRoute;
  '/workspaces/$workspaceId/journeys/integrations/warehouse/snowflake': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseSnowflakeRoute;
  '/workspaces/$workspaceId/journeys/layouts/$layoutId/edit': typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdEditRoute;
  '/workspaces/$workspaceId/journeys/objects/$slug/guide': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugGuideRoute;
  '/workspaces/$workspaceId/journeys/objects/$slug/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugNewRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/data-out': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdDataOutRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/exports': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdExportsRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/settings': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSettingsRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/tester': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdTesterRoute;
  '/workspaces/$workspaceId/pipelines/destinations/add/$destinationOptionId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddDestinationOptionIdRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/data-in': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDataInRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/databases': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDatabasesRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/imports': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdImportsRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/settings': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSettingsRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsRoute;
  '/workspaces/$workspaceId/pipelines/sources/add/$sourceOptionId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddSourceOptionIdRoute;
  '/workspaces/$workspaceId/settings/actions/email/defaults': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDefaultsRoute;
  '/workspaces/$workspaceId/settings/actions/email/deliverability': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDeliverabilityRoute;
  '/workspaces/$workspaceId/settings/actions/email/dynamic_addresses': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDynamic_addressesRoute;
  '/workspaces/$workspaceId/settings/actions/email/from_addresses': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailFrom_addressesRoute;
  '/workspaces/$workspaceId/settings/actions/email/smtp': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSmtpRoute;
  '/workspaces/$workspaceId/settings/actions/email/suppression_list': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSuppression_listRoute;
  '/workspaces/$workspaceId/settings/actions/url_params/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsEditRoute;
  '/workspaces/$workspaceId/settings/api_credentials/service_accounts/$serviceAccountId': typeof AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsService_accountsServiceAccountIdRoute;
  '/workspaces/$workspaceId/settings/llm_configuration/$configurationId/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationConfigurationIdEditRoute;
  '/workspaces/$workspaceId/settings/objects/edit/$objectType': typeof AuthenticatedWorkspacesWorkspaceIdSettingsObjectsEditObjectTypeRoute;
  '/workspaces/$workspaceId/settings/subscription_center/branding/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerBrandingEditRoute;
  '/workspaces/$workspaceId/settings/subscription_center/localization/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerLocalizationEditRoute;
  '/workspaces/$workspaceId/settings/subscription_center/topics/set_preferences': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsSet_preferencesRoute;
  '/workspaces/$workspaceId/settings/webhook_configuration/$webhookId/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationWebhookIdEditRoute;
  '/workspaces/$workspaceId/dev/db/campaigns': typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsIndexRoute;
  '/workspaces/$workspaceId/geosets/$geosetId/geofences': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesIndexRoute;
  '/workspaces/$workspaceId/imports/$importId/setup': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupIndexRoute;
  '/workspaces/$workspaceId/integrations/sql-sync/$type': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeIndexRoute;
  '/workspaces/$workspaceId/journeys/collections/$collectionId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdIndexRoute;
  '/workspaces/$workspaceId/journeys/imports/$importId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdIndexRoute;
  '/workspaces/$workspaceId/journeys/integrations/all': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllIndexRoute;
  '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksIndexRoute;
  '/workspaces/$workspaceId/journeys/layouts/$layoutId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdIndexRoute;
  '/workspaces/$workspaceId/journeys/objects/$slug': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugIndexRoute;
  '/workspaces/$workspaceId/objects/$slug/$objectId': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdIndexRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdIndexRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdIndexRoute;
  '/workspaces/$workspaceId/settings/actions/email': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailIndexRoute;
  '/workspaces/$workspaceId/settings/actions/sms-providers': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersIndexRoute;
  '/workspaces/$workspaceId/settings/actions/url_params': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsIndexRoute;
  '/workspaces/$workspaceId/settings/subscription_center/topics': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsIndexRoute;
  '/workspaces/$workspaceId/dev/db/campaigns/actions/$actionId': typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsActionsActionIdRoute;
  '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/query': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdQueryRoute;
  '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/relationships-query': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRoute;
  '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/settings': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdSettingsRoute;
  '/workspaces/$workspaceId/journeys/imports/$importId/setup/fields': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupFieldsRoute;
  '/workspaces/$workspaceId/journeys/imports/$importId/setup/importing': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupImportingRoute;
  '/workspaces/$workspaceId/journeys/imports/$importId/setup/preprocessing': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreprocessingRoute;
  '/workspaces/$workspaceId/journeys/imports/$importId/setup/preview': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreviewRoute;
  '/workspaces/$workspaceId/journeys/imports/$importId/setup/review': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupReviewRoute;
  '/workspaces/$workspaceId/journeys/imports/$importId/setup/validating': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupValidatingRoute;
  '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRoute;
  '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeNewRoute;
  '/workspaces/$workspaceId/journeys/integrations/warehouse/$type/sync': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeSyncRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/$subscriptionId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsSubscriptionIdRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsAddRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs/$syncId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsSyncIdRoute;
  '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsAddRoute;
  '/workspaces/$workspaceId/settings/actions/email/sending_domains/$domainId': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsDomainIdRoute;
  '/workspaces/$workspaceId/settings/actions/sms-providers/credentials/$credentialId': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersCredentialsCredentialIdRoute;
  '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdIndexRoute;
  '/workspaces/$workspaceId/journeys/imports/$importId/setup': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupIndexRoute;
  '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeIndexRoute;
  '/workspaces/$workspaceId/journeys/objects/$slug/$objectId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdIndexRoute;
  '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsIndexRoute;
  '/workspaces/$workspaceId/settings/actions/email/sending_domains': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsIndexRoute;
  '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/workflow/actions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewWorkflowActionsRoute;
  '/workspaces/$workspaceId/journeys/automations/$campaignId/setup/workflow/actions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdSetupWorkflowActionsRoute;
  '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/workflow/actions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewWorkflowActionsRoute;
  '/workspaces/$workspaceId/journeys/campaigns/$campaignId/setup/workflow/actions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdSetupWorkflowActionsRoute;
  '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId/query': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdQueryRoute;
  '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId/relationships-query': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRoute;
  '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId/settings': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdSettingsRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/_authenticated': typeof AuthenticatedRouteWithChildren;
  '/academy-login': typeof AcademyLoginRoute;
  '/accept-guest-invitation': typeof AcceptGuestInvitationRoute;
  '/checkout': typeof CheckoutRoute;
  '/cli': typeof CliRouteWithChildren;
  '/design-studio-embed': typeof DesignStudioEmbedRouteWithChildren;
  '/join-request': typeof JoinRequestRoute;
  '/onboarding': typeof OnboardingRouteWithChildren;
  '/2fa_setup/$': typeof R2fa_setupSplatRoute;
  '/_authenticated/$': typeof AuthenticatedSplatRoute;
  '/_authenticated/workspaces': typeof AuthenticatedWorkspacesRouteWithChildren;
  '/account/$': typeof AccountSplatRoute;
  '/account_canceled/$': typeof Account_canceledSplatRoute;
  '/account_cancelled/$': typeof Account_cancelledSplatRoute;
  '/cli/dns-setup': typeof CliDnsSetupRoute;
  '/confirm_account/$': typeof Confirm_accountSplatRoute;
  '/confirm_account_notice/$': typeof Confirm_account_noticeSplatRoute;
  '/env/$': typeof EnvSplatRoute;
  '/har-sanitizer/$': typeof HarSanitizerSplatRoute;
  '/integrations/$': typeof IntegrationsSplatRoute;
  '/journeys/$': typeof JourneysSplatRoute;
  '/login/$': typeof LoginSplatRoute;
  '/logout/$': typeof LogoutSplatRoute;
  '/no_accessible_workspaces/$': typeof No_accessible_workspacesSplatRoute;
  '/oauth/$': typeof OauthSplatRoute;
  '/oauth2/$': typeof Oauth2SplatRoute;
  '/onboarding/get-started': typeof OnboardingGetStartedRoute;
  '/onboarding/verification': typeof OnboardingVerificationRoute;
  '/onboarding/wizard': typeof OnboardingWizardRoute;
  '/post_cancel/$': typeof Post_cancelSplatRoute;
  '/post_registration/$': typeof Post_registrationSplatRoute;
  '/reset_password/$': typeof Reset_passwordSplatRoute;
  '/signup/$': typeof SignupSplatRoute;
  '/users/$': typeof UsersSplatRoute;
  '/vwb-demo/$': typeof VwbDemoSplatRoute;
  '/_authenticated/': typeof AuthenticatedIndexRoute;
  '/cli/': typeof CliIndexRoute;
  '/onboarding/': typeof OnboardingIndexRoute;
  '/_authenticated/internal-tools/$': typeof AuthenticatedInternalToolsSplatRoute;
  '/_authenticated/sample-workspace/$': typeof AuthenticatedSampleWorkspaceSplatRoute;
  '/_authenticated/settings/$': typeof AuthenticatedSettingsSplatRoute;
  '/_authenticated/settings/ai': typeof AuthenticatedSettingsAiRoute;
  '/_authenticated/settings/api-keys': typeof AuthenticatedSettingsApiKeysRoute;
  '/_authenticated/settings/audit-logs': typeof AuthenticatedSettingsAuditLogsRoute;
  '/_authenticated/settings/billing': typeof AuthenticatedSettingsBillingRouteWithChildren;
  '/_authenticated/settings/experimental-features': typeof AuthenticatedSettingsExperimentalFeaturesRoute;
  '/_authenticated/settings/partner': typeof AuthenticatedSettingsPartnerRouteWithChildren;
  '/_authenticated/settings/privacy': typeof AuthenticatedSettingsPrivacyRoute;
  '/_authenticated/settings/receipts': typeof AuthenticatedSettingsReceiptsRoute;
  '/_authenticated/settings/slack-agent': typeof AuthenticatedSettingsSlackAgentRoute;
  '/_authenticated/settings/subscription': typeof AuthenticatedSettingsSubscriptionRoute;
  '/_authenticated/trial-expired/journeys': typeof AuthenticatedTrialExpiredJourneysRoute;
  '/_authenticated/workspaces/$workspaceId': typeof AuthenticatedWorkspacesWorkspaceIdRouteWithChildren;
  '/account/cancelled/$': typeof AccountCancelledSplatRoute;
  '/design-studio-embed/cio/$': typeof DesignStudioEmbedCioSplatRoute;
  '/_authenticated/internal-tools/': typeof AuthenticatedInternalToolsIndexRoute;
  '/_authenticated/sample-workspace/': typeof AuthenticatedSampleWorkspaceIndexRoute;
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute;
  '/_authenticated/workspaces/': typeof AuthenticatedWorkspacesIndexRoute;
  '/design-studio-embed/cio/': typeof DesignStudioEmbedCioIndexRoute;
  '/_authenticated/settings/account/edit': typeof AuthenticatedSettingsAccountEditRoute;
  '/_authenticated/settings/billing/$': typeof AuthenticatedSettingsBillingSplatRoute;
  '/_authenticated/settings/billing/billing-details': typeof AuthenticatedSettingsBillingBillingDetailsRoute;
  '/_authenticated/settings/billing/billing-history': typeof AuthenticatedSettingsBillingBillingHistoryRoute;
  '/_authenticated/settings/billing/checkout': typeof AuthenticatedSettingsBillingCheckoutRoute;
  '/_authenticated/settings/billing/inbox-preview-usage': typeof AuthenticatedSettingsBillingInboxPreviewUsageRoute;
  '/_authenticated/settings/billing/llm-usage': typeof AuthenticatedSettingsBillingLlmUsageRoute;
  '/_authenticated/settings/billing/overview': typeof AuthenticatedSettingsBillingOverviewRoute;
  '/_authenticated/settings/billing/payment-methods': typeof AuthenticatedSettingsBillingPaymentMethodsRoute;
  '/_authenticated/settings/billing/profile-growth': typeof AuthenticatedSettingsBillingProfileGrowthRoute;
  '/_authenticated/settings/billing/usage': typeof AuthenticatedSettingsBillingUsageRoute;
  '/_authenticated/settings/billing/your-plan': typeof AuthenticatedSettingsBillingYourPlanRoute;
  '/_authenticated/settings/partner/create': typeof AuthenticatedSettingsPartnerCreateRoute;
  '/_authenticated/settings/personal/google-identities': typeof AuthenticatedSettingsPersonalGoogleIdentitiesRoute;
  '/_authenticated/settings/roles/$roleId': typeof AuthenticatedSettingsRolesRoleIdRoute;
  '/_authenticated/settings/roles/new': typeof AuthenticatedSettingsRolesNewRoute;
  '/_authenticated/settings/security/sso': typeof AuthenticatedSettingsSecuritySsoRoute;
  '/_authenticated/settings/slack-agent_/link': typeof AuthenticatedSettingsSlackAgentLinkRoute;
  '/_authenticated/settings/team/add': typeof AuthenticatedSettingsTeamAddRoute;
  '/_authenticated/settings/team/invite-guest': typeof AuthenticatedSettingsTeamInviteGuestRoute;
  '/_authenticated/settings/workspaces/new': typeof AuthenticatedSettingsWorkspacesNewRoute;
  '/_authenticated/workspaces/$workspaceId/$': typeof AuthenticatedWorkspacesWorkspaceIdSplatRoute;
  '/_authenticated/workspaces/$workspaceId/agent': typeof AuthenticatedWorkspacesWorkspaceIdAgentRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/assets': typeof AuthenticatedWorkspacesWorkspaceIdAssetsRoute;
  '/_authenticated/workspaces/$workspaceId/design-studio': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/experiments': typeof AuthenticatedWorkspacesWorkspaceIdExperimentsRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/exports': typeof AuthenticatedWorkspacesWorkspaceIdExportsRoute;
  '/_authenticated/workspaces/$workspaceId/geosets': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/health': typeof AuthenticatedWorkspacesWorkspaceIdHealthRoute;
  '/_authenticated/workspaces/$workspaceId/home': typeof AuthenticatedWorkspacesWorkspaceIdHomeRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/journeys_': typeof AuthenticatedWorkspacesWorkspaceIdJourneysRoute;
  '/_authenticated/workspaces/$workspaceId/message-library': typeof AuthenticatedWorkspacesWorkspaceIdMessageLibraryRoute;
  '/_authenticated/workspaces/$workspaceId/outcomes': typeof AuthenticatedWorkspacesWorkspaceIdOutcomesRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/snippets': typeof AuthenticatedWorkspacesWorkspaceIdSnippetsRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/tasks': typeof AuthenticatedWorkspacesWorkspaceIdTasksRoute;
  '/pipelines/workspaces/$workspaceId/$': typeof PipelinesWorkspacesWorkspaceIdSplatRoute;
  '/_authenticated/settings/account/': typeof AuthenticatedSettingsAccountIndexRoute;
  '/_authenticated/settings/api_credentials/': typeof AuthenticatedSettingsApi_credentialsIndexRoute;
  '/_authenticated/settings/billing/': typeof AuthenticatedSettingsBillingIndexRoute;
  '/_authenticated/settings/partner/': typeof AuthenticatedSettingsPartnerIndexRoute;
  '/_authenticated/settings/personal/': typeof AuthenticatedSettingsPersonalIndexRoute;
  '/_authenticated/settings/roles/': typeof AuthenticatedSettingsRolesIndexRoute;
  '/_authenticated/settings/security/': typeof AuthenticatedSettingsSecurityIndexRoute;
  '/_authenticated/settings/team/': typeof AuthenticatedSettingsTeamIndexRoute;
  '/_authenticated/settings/workspaces/': typeof AuthenticatedSettingsWorkspacesIndexRoute;
  '/_authenticated/workspaces/$workspaceId/': typeof AuthenticatedWorkspacesWorkspaceIdIndexRoute;
  '/pipelines/workspaces/$workspaceId/': typeof PipelinesWorkspacesWorkspaceIdIndexRoute;
  '/_authenticated/settings/api_credentials/service_accounts/$serviceAccountId': typeof AuthenticatedSettingsApi_credentialsService_accountsServiceAccountIdRoute;
  '/_authenticated/settings/billing/available-plans/journeys': typeof AuthenticatedSettingsBillingAvailablePlansJourneysRoute;
  '/_authenticated/settings/team/join-requests/$requestId': typeof AuthenticatedSettingsTeamJoinRequestsRequestIdRoute;
  '/_authenticated/workspaces/$workspaceId/agent/routines': typeof AuthenticatedWorkspacesWorkspaceIdAgentRoutinesRoute;
  '/_authenticated/workspaces/$workspaceId/agent/skills': typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/analysis/deliverability': typeof AuthenticatedWorkspacesWorkspaceIdAnalysisDeliverabilityRoute;
  '/_authenticated/workspaces/$workspaceId/analysis/email-clients': typeof AuthenticatedWorkspacesWorkspaceIdAnalysisEmailClientsRoute;
  '/_authenticated/workspaces/$workspaceId/boards/$boardId': typeof AuthenticatedWorkspacesWorkspaceIdBoardsBoardIdRoute;
  '/_authenticated/workspaces/$workspaceId/design-studio/$': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioSplatRoute;
  '/_authenticated/workspaces/$workspaceId/design-studio_/dashboard': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioDashboardRoute;
  '/_authenticated/workspaces/$workspaceId/design-studio_/global-styles': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioGlobalStylesRoute;
  '/_authenticated/workspaces/$workspaceId/dev/condition-viewer': typeof AuthenticatedWorkspacesWorkspaceIdDevConditionViewerRoute;
  '/_authenticated/workspaces/$workspaceId/experiments/$experimentId': typeof AuthenticatedWorkspacesWorkspaceIdExperimentsExperimentIdRoute;
  '/_authenticated/workspaces/$workspaceId/experiments/new': typeof AuthenticatedWorkspacesWorkspaceIdExperimentsNewRoute;
  '/_authenticated/workspaces/$workspaceId/geosets/$geosetId': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/geosets/import': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsImportRoute;
  '/_authenticated/workspaces/$workspaceId/geosets/new': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsNewRoute;
  '/_authenticated/workspaces/$workspaceId/home/add-people': typeof AuthenticatedWorkspacesWorkspaceIdHomeAddPeopleRoute;
  '/_authenticated/workspaces/$workspaceId/home/workspace-setup': typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/imports/new': typeof AuthenticatedWorkspacesWorkspaceIdImportsNewRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/$type': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsTypeRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/all': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/integrations/cdp_in': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_inRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/cdp_out': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_outRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/customerio': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsCustomerioRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/mparticle_out': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsMparticle_outRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/segment_in': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_inRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/segment_out': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_outRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSplatRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/assets': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAssetsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/collections': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/journeys/deliveries': typeof AuthenticatedWorkspacesWorkspaceIdJourneysDeliveriesRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/drafts': typeof AuthenticatedWorkspacesWorkspaceIdJourneysDraftsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/exports': typeof AuthenticatedWorkspacesWorkspaceIdJourneysExportsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/geofences': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/journeys/message-library': typeof AuthenticatedWorkspacesWorkspaceIdJourneysMessageLibraryRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/settings': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/journeys/snippets': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/journeys/tasks': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTasksRoute;
  '/_authenticated/workspaces/$workspaceId/outcomes/$goalId': typeof AuthenticatedWorkspacesWorkspaceIdOutcomesGoalIdRoute;
  '/_authenticated/workspaces/$workspaceId/parcel/$': typeof AuthenticatedWorkspacesWorkspaceIdParcelSplatRoute;
  '/_authenticated/workspaces/$workspaceId/people/create': typeof AuthenticatedWorkspacesWorkspaceIdPeopleCreateRoute;
  '/_authenticated/workspaces/$workspaceId/people/merge': typeof AuthenticatedWorkspacesWorkspaceIdPeopleMergeRoute;
  '/_authenticated/workspaces/$workspaceId/people/new': typeof AuthenticatedWorkspacesWorkspaceIdPeopleNewRoute;
  '/_authenticated/workspaces/$workspaceId/people/welcome': typeof AuthenticatedWorkspacesWorkspaceIdPeopleWelcomeRoute;
  '/_authenticated/workspaces/$workspaceId/profiles/create': typeof AuthenticatedWorkspacesWorkspaceIdProfilesCreateRoute;
  '/_authenticated/workspaces/$workspaceId/profiles/merge': typeof AuthenticatedWorkspacesWorkspaceIdProfilesMergeRoute;
  '/_authenticated/workspaces/$workspaceId/profiles/new': typeof AuthenticatedWorkspacesWorkspaceIdProfilesNewRoute;
  '/_authenticated/workspaces/$workspaceId/profiles/welcome': typeof AuthenticatedWorkspacesWorkspaceIdProfilesWelcomeRoute;
  '/_authenticated/workspaces/$workspaceId/reports/deliverability': typeof AuthenticatedWorkspacesWorkspaceIdReportsDeliverabilityRoute;
  '/_authenticated/workspaces/$workspaceId/reports/email-clients': typeof AuthenticatedWorkspacesWorkspaceIdReportsEmailClientsRoute;
  '/_authenticated/workspaces/$workspaceId/settings/$': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSplatRoute;
  '/_authenticated/workspaces/$workspaceId/settings/ai-business-profile': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAiBusinessProfileRoute;
  '/_authenticated/workspaces/$workspaceId/settings/anonymous_events': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAnonymous_eventsRoute;
  '/_authenticated/workspaces/$workspaceId/settings/api-keys': typeof AuthenticatedWorkspacesWorkspaceIdSettingsApiKeysRoute;
  '/_authenticated/workspaces/$workspaceId/settings/audit-logs': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAuditLogsRoute;
  '/_authenticated/workspaces/$workspaceId/settings/auto_archive': typeof AuthenticatedWorkspacesWorkspaceIdSettingsAuto_archiveRoute;
  '/_authenticated/workspaces/$workspaceId/settings/confirm_delete': typeof AuthenticatedWorkspacesWorkspaceIdSettingsConfirm_deleteRoute;
  '/_authenticated/workspaces/$workspaceId/settings/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsEditRoute;
  '/_authenticated/workspaces/$workspaceId/settings/geofences': typeof AuthenticatedWorkspacesWorkspaceIdSettingsGeofencesRoute;
  '/_authenticated/workspaces/$workspaceId/settings/language': typeof AuthenticatedWorkspacesWorkspaceIdSettingsLanguageRoute;
  '/_authenticated/workspaces/$workspaceId/settings/llm_configuration': typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/settings/merge_options': typeof AuthenticatedWorkspacesWorkspaceIdSettingsMerge_optionsRoute;
  '/_authenticated/workspaces/$workspaceId/settings/subscription_center': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/settings/suppressions': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSuppressionsRoute;
  '/_authenticated/workspaces/$workspaceId/snippets/$snippetId': typeof AuthenticatedWorkspacesWorkspaceIdSnippetsSnippetIdRoute;
  '/_authenticated/workspaces/$workspaceId/snippets/new': typeof AuthenticatedWorkspacesWorkspaceIdSnippetsNewRoute;
  '/_authenticated/workspaces/$workspaceId/template/$templateId': typeof AuthenticatedWorkspacesWorkspaceIdTemplateTemplateIdRoute;
  '/_authenticated/settings/billing/available-plans/': typeof AuthenticatedSettingsBillingAvailablePlansIndexRoute;
  '/_authenticated/workspaces/$workspaceId/agent/': typeof AuthenticatedWorkspacesWorkspaceIdAgentIndexRoute;
  '/_authenticated/workspaces/$workspaceId/boards/': typeof AuthenticatedWorkspacesWorkspaceIdBoardsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/design-studio/': typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioIndexRoute;
  '/_authenticated/workspaces/$workspaceId/experiments/': typeof AuthenticatedWorkspacesWorkspaceIdExperimentsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/geosets/': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/home/': typeof AuthenticatedWorkspacesWorkspaceIdHomeIndexRoute;
  '/_authenticated/workspaces/$workspaceId/imports/': typeof AuthenticatedWorkspacesWorkspaceIdImportsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/objects/': typeof AuthenticatedWorkspacesWorkspaceIdObjectsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/outcomes/': typeof AuthenticatedWorkspacesWorkspaceIdOutcomesIndexRoute;
  '/_authenticated/workspaces/$workspaceId/parcel/': typeof AuthenticatedWorkspacesWorkspaceIdParcelIndexRoute;
  '/_authenticated/workspaces/$workspaceId/people/': typeof AuthenticatedWorkspacesWorkspaceIdPeopleIndexRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesIndexRoute;
  '/_authenticated/workspaces/$workspaceId/profiles/': typeof AuthenticatedWorkspacesWorkspaceIdProfilesIndexRoute;
  '/_authenticated/workspaces/$workspaceId/settings/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/snippets/': typeof AuthenticatedWorkspacesWorkspaceIdSnippetsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/template/': typeof AuthenticatedWorkspacesWorkspaceIdTemplateIndexRoute;
  '/_authenticated/settings/team/members/$userId/edit': typeof AuthenticatedSettingsTeamMembersUserIdEditRoute;
  '/_authenticated/workspaces/$workspaceId/agent/skills/$skillPath': typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsSkillPathRoute;
  '/_authenticated/workspaces/$workspaceId/agent/skills/new': typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsNewRoute;
  '/_authenticated/workspaces/$workspaceId/automations/$campaignId/workflow': typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdWorkflowRoute;
  '/_authenticated/workspaces/$workspaceId/dev/db/campaigns': typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/edit': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdEditRoute;
  '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/home/workspace-setup/add-people': typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupAddPeopleRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/all/developers': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDevelopersRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/all/directory': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDirectoryRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/all/overview': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllOverviewRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/all/webhooks': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllWebhooksRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/data_out/$type': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsData_outTypeRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/reporting-webhooks/$webhookId': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksWebhookIdRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/reporting-webhooks/new': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksNewRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/integrations/warehouse/$type': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/warehouse/bigquery': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseBigqueryRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/warehouse/redshift': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseRedshiftRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/warehouse/snowflake': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseSnowflakeRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/activity_logs/$tab': typeof AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsTabRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/analysis/deliverability': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisDeliverabilityRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/journeys/geofences/$geofenceId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesGeofenceIdRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/geofences/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesNewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/imports/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsNewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/$type': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsTypeRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/all': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/cdp_in': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_inRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/cdp_out': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_outRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/customerio': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCustomerioRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/mparticle_out': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsMparticle_outRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/segment_in': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_inRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/segment_out': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_outRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/layouts/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsNewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/layouts/starters': typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsStartersRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/message_activity/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysMessage_activitySplatRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/outbox/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysOutboxSplatRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/people/create': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleCreateRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/people/merge': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleMergeRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/people/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleNewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/people/welcome': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleWelcomeRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/profile_activity/$tab': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityTabRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/profiles/create': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesCreateRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/profiles/merge': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesMergeRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/profiles/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesNewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/profiles/welcome': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesWelcomeRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/settings/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSettingsSplatRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/setup-guide/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSetupGuideSplatRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/snippets/$snippetId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsSnippetIdRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/snippets/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsNewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/template/$templateId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTemplateTemplateIdRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/triggered/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredNewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/v2/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysV2SplatRoute;
  '/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/objects/$slug/guide': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugGuideRoute;
  '/_authenticated/workspaces/$workspaceId/objects/$slug/new': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugNewRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/journeys': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsJourneysRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/journeys': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesJourneysRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/email': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/settings/actions/line': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsLineRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/message_frequency_limits': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessage_frequency_limitsRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/messaging_limit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessaging_limitRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/slack': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSlackRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/sms-providers': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/settings/actions/time_zone_match': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsTime_zone_matchRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/urban_airship': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrban_airshipRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/url_params': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/settings/llm_configuration/new': typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationNewRoute;
  '/_authenticated/workspaces/$workspaceId/settings/objects/new': typeof AuthenticatedWorkspacesWorkspaceIdSettingsObjectsNewRoute;
  '/_authenticated/workspaces/$workspaceId/settings/subscription_center/settings': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerSettingsRoute;
  '/_authenticated/workspaces/$workspaceId/settings/webhook_configuration/new': typeof AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationNewRoute;
  '/_authenticated/workspaces/$workspaceId/agent/skills/': typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/home/workspace-setup/': typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupIndexRoute;
  '/_authenticated/workspaces/$workspaceId/imports/$importId/': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/all/': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllIndexRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/reporting-webhooks/': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/activity_logs/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/collections/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/geofences/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/imports/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/layouts/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/objects/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/people/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/profile_activity/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/profiles/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/snippets/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/template/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTemplateIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/triggered/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredIndexRoute;
  '/_authenticated/workspaces/$workspaceId/objects/$slug/': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugIndexRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesIndexRoute;
  '/_authenticated/workspaces/$workspaceId/settings/api_credentials/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/settings/llm_configuration/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationIndexRoute;
  '/_authenticated/workspaces/$workspaceId/settings/objects/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsObjectsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/settings/subscription_center/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerIndexRoute;
  '/_authenticated/workspaces/$workspaceId/settings/webhook_configuration/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationIndexRoute;
  '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences/$geofenceId': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesGeofenceIdRoute;
  '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences/import': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesImportRoute;
  '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences/new': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesNewRoute;
  '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/fields': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupFieldsRoute;
  '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/importing': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupImportingRoute;
  '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/preprocessing': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreprocessingRoute;
  '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/preview': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreviewRoute;
  '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/review': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupReviewRoute;
  '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/validating': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupValidatingRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/new': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeNewRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/warehouse/$type_/sync': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeSyncRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/$': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdSplatRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/data': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdDataRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/importing': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdImportingRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/usage': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdUsageRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/developers': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDevelopersRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/directory': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDirectoryRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/overview': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllOverviewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/webhooks': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllWebhooksRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/data_out/$type': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsData_outTypeRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/$webhookId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksWebhookIdRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksNewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/$type': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/bigquery': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseBigqueryRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/redshift': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseRedshiftRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/snowflake': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseSnowflakeRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/layouts/$layoutId/edit': typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdEditRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/guide': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugGuideRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugNewRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/data-out': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdDataOutRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/exports': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdExportsRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/settings': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSettingsRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteWithChildren;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/tester': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdTesterRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/add_/$destinationOptionId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddDestinationOptionIdRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/data-in': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDataInRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/databases': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDatabasesRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/imports': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdImportsRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/settings': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSettingsRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/add_/$sourceOptionId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddSourceOptionIdRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/email/defaults': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDefaultsRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/email/deliverability': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDeliverabilityRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/email/dynamic_addresses': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDynamic_addressesRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/email/from_addresses': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailFrom_addressesRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/email/smtp': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSmtpRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/email/suppression_list': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSuppression_listRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/url_params/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsEditRoute;
  '/_authenticated/workspaces/$workspaceId/settings/api_credentials/service_accounts/$serviceAccountId': typeof AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsService_accountsServiceAccountIdRoute;
  '/_authenticated/workspaces/$workspaceId/settings/llm_configuration/$configurationId/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationConfigurationIdEditRoute;
  '/_authenticated/workspaces/$workspaceId/settings/objects/edit/$objectType': typeof AuthenticatedWorkspacesWorkspaceIdSettingsObjectsEditObjectTypeRoute;
  '/_authenticated/workspaces/$workspaceId/settings/subscription_center/branding/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerBrandingEditRoute;
  '/_authenticated/workspaces/$workspaceId/settings/subscription_center/localization/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerLocalizationEditRoute;
  '/_authenticated/workspaces/$workspaceId/settings/subscription_center/topics/set_preferences': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsSet_preferencesRoute;
  '/_authenticated/workspaces/$workspaceId/settings/webhook_configuration/$webhookId/edit': typeof AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationWebhookIdEditRoute;
  '/_authenticated/workspaces/$workspaceId/dev/db/campaigns/': typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences/': typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesIndexRoute;
  '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/': typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupIndexRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/layouts/$layoutId/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugIndexRoute;
  '/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId/': typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/email/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailIndexRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/sms-providers/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersIndexRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/url_params/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/settings/subscription_center/topics/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/dev/db/campaigns/actions/$actionId': typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsActionsActionIdRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/query': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdQueryRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/relationships-query': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/settings': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdSettingsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/fields': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupFieldsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/importing': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupImportingRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/preprocessing': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreprocessingRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/preview': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreviewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/review': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupReviewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/validating': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupValidatingRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/new': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeNewRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/$type_/sync': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeSyncRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/$subscriptionId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsSubscriptionIdRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsAddRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId_/syncs/$syncId': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsSyncIdRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId_/syncs/add': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsAddRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/email/sending_domains/$domainId': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsDomainIdRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/sms-providers/credentials/$credentialId': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersCredentialsCredentialIdRoute;
  '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/': typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/$objectId/': typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdIndexRoute;
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/': typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/settings/actions/email/sending_domains/': typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsIndexRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/workflow/actions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewWorkflowActionsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/setup/workflow/actions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdSetupWorkflowActionsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/workflow/actions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewWorkflowActionsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/setup/workflow/actions': typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdSetupWorkflowActionsRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId_/query': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdQueryRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId_/relationships-query': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRoute;
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId_/settings': typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdSettingsRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/academy-login'
    | '/accept-guest-invitation'
    | '/checkout'
    | '/cli'
    | '/design-studio-embed'
    | '/join-request'
    | '/onboarding'
    | '/2fa_setup/$'
    | '/$'
    | '/workspaces'
    | '/account/$'
    | '/account_canceled/$'
    | '/account_cancelled/$'
    | '/cli/dns-setup'
    | '/confirm_account/$'
    | '/confirm_account_notice/$'
    | '/env/$'
    | '/har-sanitizer/$'
    | '/integrations/$'
    | '/journeys/$'
    | '/login/$'
    | '/logout/$'
    | '/no_accessible_workspaces/$'
    | '/oauth/$'
    | '/oauth2/$'
    | '/onboarding/get-started'
    | '/onboarding/verification'
    | '/onboarding/wizard'
    | '/post_cancel/$'
    | '/post_registration/$'
    | '/reset_password/$'
    | '/signup/$'
    | '/users/$'
    | '/vwb-demo/$'
    | '/cli/'
    | '/onboarding/'
    | '/internal-tools/$'
    | '/sample-workspace/$'
    | '/settings/$'
    | '/settings/ai'
    | '/settings/api-keys'
    | '/settings/audit-logs'
    | '/settings/billing'
    | '/settings/experimental-features'
    | '/settings/partner'
    | '/settings/privacy'
    | '/settings/receipts'
    | '/settings/slack-agent'
    | '/settings/subscription'
    | '/trial-expired/journeys'
    | '/workspaces/$workspaceId'
    | '/account/cancelled/$'
    | '/design-studio-embed/cio/$'
    | '/internal-tools/'
    | '/sample-workspace/'
    | '/settings/'
    | '/workspaces/'
    | '/design-studio-embed/cio/'
    | '/settings/account/edit'
    | '/settings/billing/$'
    | '/settings/billing/billing-details'
    | '/settings/billing/billing-history'
    | '/settings/billing/checkout'
    | '/settings/billing/inbox-preview-usage'
    | '/settings/billing/llm-usage'
    | '/settings/billing/overview'
    | '/settings/billing/payment-methods'
    | '/settings/billing/profile-growth'
    | '/settings/billing/usage'
    | '/settings/billing/your-plan'
    | '/settings/partner/create'
    | '/settings/personal/google-identities'
    | '/settings/roles/$roleId'
    | '/settings/roles/new'
    | '/settings/security/sso'
    | '/settings/slack-agent/link'
    | '/settings/team/add'
    | '/settings/team/invite-guest'
    | '/settings/workspaces/new'
    | '/workspaces/$workspaceId/$'
    | '/workspaces/$workspaceId/agent'
    | '/workspaces/$workspaceId/assets'
    | '/workspaces/$workspaceId/design-studio'
    | '/workspaces/$workspaceId/experiments'
    | '/workspaces/$workspaceId/exports'
    | '/workspaces/$workspaceId/geosets'
    | '/workspaces/$workspaceId/health'
    | '/workspaces/$workspaceId/home'
    | '/workspaces/$workspaceId/journeys'
    | '/workspaces/$workspaceId/message-library'
    | '/workspaces/$workspaceId/outcomes'
    | '/workspaces/$workspaceId/snippets'
    | '/workspaces/$workspaceId/tasks'
    | '/pipelines/workspaces/$workspaceId/$'
    | '/settings/account/'
    | '/settings/api_credentials/'
    | '/settings/billing/'
    | '/settings/partner/'
    | '/settings/personal/'
    | '/settings/roles/'
    | '/settings/security/'
    | '/settings/team/'
    | '/settings/workspaces/'
    | '/workspaces/$workspaceId/'
    | '/pipelines/workspaces/$workspaceId/'
    | '/settings/api_credentials/service_accounts/$serviceAccountId'
    | '/settings/billing/available-plans/journeys'
    | '/settings/team/join-requests/$requestId'
    | '/workspaces/$workspaceId/agent/routines'
    | '/workspaces/$workspaceId/agent/skills'
    | '/workspaces/$workspaceId/analysis/deliverability'
    | '/workspaces/$workspaceId/analysis/email-clients'
    | '/workspaces/$workspaceId/boards/$boardId'
    | '/workspaces/$workspaceId/design-studio/$'
    | '/workspaces/$workspaceId/design-studio/dashboard'
    | '/workspaces/$workspaceId/design-studio/global-styles'
    | '/workspaces/$workspaceId/dev/condition-viewer'
    | '/workspaces/$workspaceId/experiments/$experimentId'
    | '/workspaces/$workspaceId/experiments/new'
    | '/workspaces/$workspaceId/geosets/$geosetId'
    | '/workspaces/$workspaceId/geosets/import'
    | '/workspaces/$workspaceId/geosets/new'
    | '/workspaces/$workspaceId/home/add-people'
    | '/workspaces/$workspaceId/home/workspace-setup'
    | '/workspaces/$workspaceId/imports/new'
    | '/workspaces/$workspaceId/integrations/$type'
    | '/workspaces/$workspaceId/integrations/all'
    | '/workspaces/$workspaceId/integrations/cdp_in'
    | '/workspaces/$workspaceId/integrations/cdp_out'
    | '/workspaces/$workspaceId/integrations/customerio'
    | '/workspaces/$workspaceId/integrations/mparticle_out'
    | '/workspaces/$workspaceId/integrations/segment_in'
    | '/workspaces/$workspaceId/integrations/segment_out'
    | '/workspaces/$workspaceId/journeys/$'
    | '/workspaces/$workspaceId/journeys/assets'
    | '/workspaces/$workspaceId/journeys/collections'
    | '/workspaces/$workspaceId/journeys/deliveries'
    | '/workspaces/$workspaceId/journeys/drafts'
    | '/workspaces/$workspaceId/journeys/exports'
    | '/workspaces/$workspaceId/journeys/geofences'
    | '/workspaces/$workspaceId/journeys/message-library'
    | '/workspaces/$workspaceId/journeys/settings'
    | '/workspaces/$workspaceId/journeys/snippets'
    | '/workspaces/$workspaceId/journeys/tasks'
    | '/workspaces/$workspaceId/outcomes/$goalId'
    | '/workspaces/$workspaceId/parcel/$'
    | '/workspaces/$workspaceId/people/create'
    | '/workspaces/$workspaceId/people/merge'
    | '/workspaces/$workspaceId/people/new'
    | '/workspaces/$workspaceId/people/welcome'
    | '/workspaces/$workspaceId/profiles/create'
    | '/workspaces/$workspaceId/profiles/merge'
    | '/workspaces/$workspaceId/profiles/new'
    | '/workspaces/$workspaceId/profiles/welcome'
    | '/workspaces/$workspaceId/reports/deliverability'
    | '/workspaces/$workspaceId/reports/email-clients'
    | '/workspaces/$workspaceId/settings/$'
    | '/workspaces/$workspaceId/settings/ai-business-profile'
    | '/workspaces/$workspaceId/settings/anonymous_events'
    | '/workspaces/$workspaceId/settings/api-keys'
    | '/workspaces/$workspaceId/settings/audit-logs'
    | '/workspaces/$workspaceId/settings/auto_archive'
    | '/workspaces/$workspaceId/settings/confirm_delete'
    | '/workspaces/$workspaceId/settings/edit'
    | '/workspaces/$workspaceId/settings/geofences'
    | '/workspaces/$workspaceId/settings/language'
    | '/workspaces/$workspaceId/settings/llm_configuration'
    | '/workspaces/$workspaceId/settings/merge_options'
    | '/workspaces/$workspaceId/settings/subscription_center'
    | '/workspaces/$workspaceId/settings/suppressions'
    | '/workspaces/$workspaceId/snippets/$snippetId'
    | '/workspaces/$workspaceId/snippets/new'
    | '/workspaces/$workspaceId/template/$templateId'
    | '/settings/billing/available-plans/'
    | '/workspaces/$workspaceId/agent/'
    | '/workspaces/$workspaceId/boards/'
    | '/workspaces/$workspaceId/design-studio/'
    | '/workspaces/$workspaceId/experiments/'
    | '/workspaces/$workspaceId/geosets/'
    | '/workspaces/$workspaceId/home/'
    | '/workspaces/$workspaceId/imports/'
    | '/workspaces/$workspaceId/integrations/'
    | '/workspaces/$workspaceId/objects/'
    | '/workspaces/$workspaceId/outcomes/'
    | '/workspaces/$workspaceId/parcel/'
    | '/workspaces/$workspaceId/people/'
    | '/workspaces/$workspaceId/pipelines/'
    | '/workspaces/$workspaceId/profiles/'
    | '/workspaces/$workspaceId/settings/'
    | '/workspaces/$workspaceId/snippets/'
    | '/workspaces/$workspaceId/template/'
    | '/settings/team/members/$userId/edit'
    | '/workspaces/$workspaceId/agent/skills/$skillPath'
    | '/workspaces/$workspaceId/agent/skills/new'
    | '/workspaces/$workspaceId/automations/$campaignId/workflow'
    | '/workspaces/$workspaceId/dev/db/campaigns'
    | '/workspaces/$workspaceId/geosets/$geosetId/edit'
    | '/workspaces/$workspaceId/geosets/$geosetId/geofences'
    | '/workspaces/$workspaceId/home/workspace-setup/add-people'
    | '/workspaces/$workspaceId/integrations/all/developers'
    | '/workspaces/$workspaceId/integrations/all/directory'
    | '/workspaces/$workspaceId/integrations/all/overview'
    | '/workspaces/$workspaceId/integrations/all/webhooks'
    | '/workspaces/$workspaceId/integrations/data_out/$type'
    | '/workspaces/$workspaceId/integrations/reporting-webhooks/$webhookId'
    | '/workspaces/$workspaceId/integrations/reporting-webhooks/new'
    | '/workspaces/$workspaceId/integrations/sql-sync/$type'
    | '/workspaces/$workspaceId/integrations/warehouse/$type'
    | '/workspaces/$workspaceId/integrations/warehouse/bigquery'
    | '/workspaces/$workspaceId/integrations/warehouse/redshift'
    | '/workspaces/$workspaceId/integrations/warehouse/snowflake'
    | '/workspaces/$workspaceId/journeys/activity_logs/$tab'
    | '/workspaces/$workspaceId/journeys/analysis/deliverability'
    | '/workspaces/$workspaceId/journeys/collections/$collectionId'
    | '/workspaces/$workspaceId/journeys/geofences/$geofenceId'
    | '/workspaces/$workspaceId/journeys/geofences/new'
    | '/workspaces/$workspaceId/journeys/imports/new'
    | '/workspaces/$workspaceId/journeys/integrations/$type'
    | '/workspaces/$workspaceId/journeys/integrations/all'
    | '/workspaces/$workspaceId/journeys/integrations/cdp_in'
    | '/workspaces/$workspaceId/journeys/integrations/cdp_out'
    | '/workspaces/$workspaceId/journeys/integrations/customerio'
    | '/workspaces/$workspaceId/journeys/integrations/mparticle_out'
    | '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks'
    | '/workspaces/$workspaceId/journeys/integrations/segment_in'
    | '/workspaces/$workspaceId/journeys/integrations/segment_out'
    | '/workspaces/$workspaceId/journeys/layouts/new'
    | '/workspaces/$workspaceId/journeys/layouts/starters'
    | '/workspaces/$workspaceId/journeys/message_activity/$'
    | '/workspaces/$workspaceId/journeys/outbox/$'
    | '/workspaces/$workspaceId/journeys/people/create'
    | '/workspaces/$workspaceId/journeys/people/merge'
    | '/workspaces/$workspaceId/journeys/people/new'
    | '/workspaces/$workspaceId/journeys/people/welcome'
    | '/workspaces/$workspaceId/journeys/profile_activity/$tab'
    | '/workspaces/$workspaceId/journeys/profiles/create'
    | '/workspaces/$workspaceId/journeys/profiles/merge'
    | '/workspaces/$workspaceId/journeys/profiles/new'
    | '/workspaces/$workspaceId/journeys/profiles/welcome'
    | '/workspaces/$workspaceId/journeys/settings/$'
    | '/workspaces/$workspaceId/journeys/setup-guide/$'
    | '/workspaces/$workspaceId/journeys/snippets/$snippetId'
    | '/workspaces/$workspaceId/journeys/snippets/new'
    | '/workspaces/$workspaceId/journeys/template/$templateId'
    | '/workspaces/$workspaceId/journeys/triggered/new'
    | '/workspaces/$workspaceId/journeys/v2/$'
    | '/workspaces/$workspaceId/objects/$slug/$objectId'
    | '/workspaces/$workspaceId/objects/$slug/guide'
    | '/workspaces/$workspaceId/objects/$slug/new'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId'
    | '/workspaces/$workspaceId/pipelines/destinations/add'
    | '/workspaces/$workspaceId/pipelines/destinations/journeys'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId'
    | '/workspaces/$workspaceId/pipelines/sources/add'
    | '/workspaces/$workspaceId/pipelines/sources/journeys'
    | '/workspaces/$workspaceId/settings/actions/email'
    | '/workspaces/$workspaceId/settings/actions/line'
    | '/workspaces/$workspaceId/settings/actions/message_frequency_limits'
    | '/workspaces/$workspaceId/settings/actions/messaging_limit'
    | '/workspaces/$workspaceId/settings/actions/slack'
    | '/workspaces/$workspaceId/settings/actions/sms-providers'
    | '/workspaces/$workspaceId/settings/actions/time_zone_match'
    | '/workspaces/$workspaceId/settings/actions/urban_airship'
    | '/workspaces/$workspaceId/settings/actions/url_params'
    | '/workspaces/$workspaceId/settings/llm_configuration/new'
    | '/workspaces/$workspaceId/settings/objects/new'
    | '/workspaces/$workspaceId/settings/subscription_center/settings'
    | '/workspaces/$workspaceId/settings/webhook_configuration/new'
    | '/workspaces/$workspaceId/agent/skills/'
    | '/workspaces/$workspaceId/geosets/$geosetId/'
    | '/workspaces/$workspaceId/home/workspace-setup/'
    | '/workspaces/$workspaceId/imports/$importId/'
    | '/workspaces/$workspaceId/integrations/all/'
    | '/workspaces/$workspaceId/integrations/reporting-webhooks/'
    | '/workspaces/$workspaceId/journeys/activity_logs/'
    | '/workspaces/$workspaceId/journeys/collections/'
    | '/workspaces/$workspaceId/journeys/geofences/'
    | '/workspaces/$workspaceId/journeys/imports/'
    | '/workspaces/$workspaceId/journeys/integrations/'
    | '/workspaces/$workspaceId/journeys/layouts/'
    | '/workspaces/$workspaceId/journeys/objects/'
    | '/workspaces/$workspaceId/journeys/people/'
    | '/workspaces/$workspaceId/journeys/profile_activity/'
    | '/workspaces/$workspaceId/journeys/profiles/'
    | '/workspaces/$workspaceId/journeys/snippets/'
    | '/workspaces/$workspaceId/journeys/template/'
    | '/workspaces/$workspaceId/journeys/triggered/'
    | '/workspaces/$workspaceId/objects/$slug/'
    | '/workspaces/$workspaceId/pipelines/destinations/'
    | '/workspaces/$workspaceId/pipelines/sources/'
    | '/workspaces/$workspaceId/settings/api_credentials/'
    | '/workspaces/$workspaceId/settings/llm_configuration/'
    | '/workspaces/$workspaceId/settings/objects/'
    | '/workspaces/$workspaceId/settings/subscription_center/'
    | '/workspaces/$workspaceId/settings/webhook_configuration/'
    | '/workspaces/$workspaceId/geosets/$geosetId/geofences/$geofenceId'
    | '/workspaces/$workspaceId/geosets/$geosetId/geofences/import'
    | '/workspaces/$workspaceId/geosets/$geosetId/geofences/new'
    | '/workspaces/$workspaceId/imports/$importId/setup/fields'
    | '/workspaces/$workspaceId/imports/$importId/setup/importing'
    | '/workspaces/$workspaceId/imports/$importId/setup/preprocessing'
    | '/workspaces/$workspaceId/imports/$importId/setup/preview'
    | '/workspaces/$workspaceId/imports/$importId/setup/review'
    | '/workspaces/$workspaceId/imports/$importId/setup/validating'
    | '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId'
    | '/workspaces/$workspaceId/integrations/sql-sync/$type/new'
    | '/workspaces/$workspaceId/integrations/warehouse/$type/sync'
    | '/workspaces/$workspaceId/journeys/collections/$collectionId/$'
    | '/workspaces/$workspaceId/journeys/collections/$collectionId/data'
    | '/workspaces/$workspaceId/journeys/collections/$collectionId/importing'
    | '/workspaces/$workspaceId/journeys/collections/$collectionId/usage'
    | '/workspaces/$workspaceId/journeys/integrations/all/developers'
    | '/workspaces/$workspaceId/journeys/integrations/all/directory'
    | '/workspaces/$workspaceId/journeys/integrations/all/overview'
    | '/workspaces/$workspaceId/journeys/integrations/all/webhooks'
    | '/workspaces/$workspaceId/journeys/integrations/data_out/$type'
    | '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/$webhookId'
    | '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/new'
    | '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type'
    | '/workspaces/$workspaceId/journeys/integrations/warehouse/$type'
    | '/workspaces/$workspaceId/journeys/integrations/warehouse/bigquery'
    | '/workspaces/$workspaceId/journeys/integrations/warehouse/redshift'
    | '/workspaces/$workspaceId/journeys/integrations/warehouse/snowflake'
    | '/workspaces/$workspaceId/journeys/layouts/$layoutId/edit'
    | '/workspaces/$workspaceId/journeys/objects/$slug/guide'
    | '/workspaces/$workspaceId/journeys/objects/$slug/new'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/data-out'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/exports'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/settings'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/tester'
    | '/workspaces/$workspaceId/pipelines/destinations/add/$destinationOptionId'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/data-in'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/databases'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/imports'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/settings'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs'
    | '/workspaces/$workspaceId/pipelines/sources/add/$sourceOptionId'
    | '/workspaces/$workspaceId/settings/actions/email/defaults'
    | '/workspaces/$workspaceId/settings/actions/email/deliverability'
    | '/workspaces/$workspaceId/settings/actions/email/dynamic_addresses'
    | '/workspaces/$workspaceId/settings/actions/email/from_addresses'
    | '/workspaces/$workspaceId/settings/actions/email/smtp'
    | '/workspaces/$workspaceId/settings/actions/email/suppression_list'
    | '/workspaces/$workspaceId/settings/actions/url_params/edit'
    | '/workspaces/$workspaceId/settings/api_credentials/service_accounts/$serviceAccountId'
    | '/workspaces/$workspaceId/settings/llm_configuration/$configurationId/edit'
    | '/workspaces/$workspaceId/settings/objects/edit/$objectType'
    | '/workspaces/$workspaceId/settings/subscription_center/branding/edit'
    | '/workspaces/$workspaceId/settings/subscription_center/localization/edit'
    | '/workspaces/$workspaceId/settings/subscription_center/topics/set_preferences'
    | '/workspaces/$workspaceId/settings/webhook_configuration/$webhookId/edit'
    | '/workspaces/$workspaceId/dev/db/campaigns/'
    | '/workspaces/$workspaceId/geosets/$geosetId/geofences/'
    | '/workspaces/$workspaceId/imports/$importId/setup/'
    | '/workspaces/$workspaceId/integrations/sql-sync/$type/'
    | '/workspaces/$workspaceId/journeys/collections/$collectionId/'
    | '/workspaces/$workspaceId/journeys/imports/$importId/'
    | '/workspaces/$workspaceId/journeys/integrations/all/'
    | '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/'
    | '/workspaces/$workspaceId/journeys/layouts/$layoutId/'
    | '/workspaces/$workspaceId/journeys/objects/$slug/'
    | '/workspaces/$workspaceId/objects/$slug/$objectId/'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/'
    | '/workspaces/$workspaceId/settings/actions/email/'
    | '/workspaces/$workspaceId/settings/actions/sms-providers/'
    | '/workspaces/$workspaceId/settings/actions/url_params/'
    | '/workspaces/$workspaceId/settings/subscription_center/topics/'
    | '/workspaces/$workspaceId/dev/db/campaigns/actions/$actionId'
    | '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/query'
    | '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/relationships-query'
    | '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/settings'
    | '/workspaces/$workspaceId/journeys/imports/$importId/setup/fields'
    | '/workspaces/$workspaceId/journeys/imports/$importId/setup/importing'
    | '/workspaces/$workspaceId/journeys/imports/$importId/setup/preprocessing'
    | '/workspaces/$workspaceId/journeys/imports/$importId/setup/preview'
    | '/workspaces/$workspaceId/journeys/imports/$importId/setup/review'
    | '/workspaces/$workspaceId/journeys/imports/$importId/setup/validating'
    | '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId'
    | '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/new'
    | '/workspaces/$workspaceId/journeys/integrations/warehouse/$type/sync'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/$subscriptionId'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/add'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs/$syncId'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs/add'
    | '/workspaces/$workspaceId/settings/actions/email/sending_domains/$domainId'
    | '/workspaces/$workspaceId/settings/actions/sms-providers/credentials/$credentialId'
    | '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/'
    | '/workspaces/$workspaceId/journeys/imports/$importId/setup/'
    | '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/'
    | '/workspaces/$workspaceId/journeys/objects/$slug/$objectId/'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/'
    | '/workspaces/$workspaceId/settings/actions/email/sending_domains/'
    | '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/workflow/actions'
    | '/workspaces/$workspaceId/journeys/automations/$campaignId/setup/workflow/actions'
    | '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/workflow/actions'
    | '/workspaces/$workspaceId/journeys/campaigns/$campaignId/setup/workflow/actions'
    | '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId/query'
    | '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId/relationships-query'
    | '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId/settings';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/academy-login'
    | '/accept-guest-invitation'
    | '/checkout'
    | '/design-studio-embed'
    | '/join-request'
    | '/2fa_setup/$'
    | '/$'
    | '/account/$'
    | '/account_canceled/$'
    | '/account_cancelled/$'
    | '/cli/dns-setup'
    | '/confirm_account/$'
    | '/confirm_account_notice/$'
    | '/env/$'
    | '/har-sanitizer/$'
    | '/integrations/$'
    | '/journeys/$'
    | '/login/$'
    | '/logout/$'
    | '/no_accessible_workspaces/$'
    | '/oauth/$'
    | '/oauth2/$'
    | '/onboarding/get-started'
    | '/onboarding/verification'
    | '/onboarding/wizard'
    | '/post_cancel/$'
    | '/post_registration/$'
    | '/reset_password/$'
    | '/signup/$'
    | '/users/$'
    | '/vwb-demo/$'
    | '/'
    | '/cli'
    | '/onboarding'
    | '/internal-tools/$'
    | '/sample-workspace/$'
    | '/settings/$'
    | '/settings/ai'
    | '/settings/api-keys'
    | '/settings/audit-logs'
    | '/settings/experimental-features'
    | '/settings/privacy'
    | '/settings/receipts'
    | '/settings/slack-agent'
    | '/settings/subscription'
    | '/trial-expired/journeys'
    | '/account/cancelled/$'
    | '/design-studio-embed/cio/$'
    | '/internal-tools'
    | '/sample-workspace'
    | '/settings'
    | '/workspaces'
    | '/design-studio-embed/cio'
    | '/settings/account/edit'
    | '/settings/billing/$'
    | '/settings/billing/billing-details'
    | '/settings/billing/billing-history'
    | '/settings/billing/checkout'
    | '/settings/billing/inbox-preview-usage'
    | '/settings/billing/llm-usage'
    | '/settings/billing/overview'
    | '/settings/billing/payment-methods'
    | '/settings/billing/profile-growth'
    | '/settings/billing/usage'
    | '/settings/billing/your-plan'
    | '/settings/partner/create'
    | '/settings/personal/google-identities'
    | '/settings/roles/$roleId'
    | '/settings/roles/new'
    | '/settings/security/sso'
    | '/settings/slack-agent/link'
    | '/settings/team/add'
    | '/settings/team/invite-guest'
    | '/settings/workspaces/new'
    | '/workspaces/$workspaceId/$'
    | '/workspaces/$workspaceId/assets'
    | '/workspaces/$workspaceId/exports'
    | '/workspaces/$workspaceId/health'
    | '/workspaces/$workspaceId/journeys'
    | '/workspaces/$workspaceId/message-library'
    | '/workspaces/$workspaceId/tasks'
    | '/pipelines/workspaces/$workspaceId/$'
    | '/settings/account'
    | '/settings/api_credentials'
    | '/settings/billing'
    | '/settings/partner'
    | '/settings/personal'
    | '/settings/roles'
    | '/settings/security'
    | '/settings/team'
    | '/settings/workspaces'
    | '/workspaces/$workspaceId'
    | '/pipelines/workspaces/$workspaceId'
    | '/settings/api_credentials/service_accounts/$serviceAccountId'
    | '/settings/billing/available-plans/journeys'
    | '/settings/team/join-requests/$requestId'
    | '/workspaces/$workspaceId/agent/routines'
    | '/workspaces/$workspaceId/analysis/deliverability'
    | '/workspaces/$workspaceId/analysis/email-clients'
    | '/workspaces/$workspaceId/boards/$boardId'
    | '/workspaces/$workspaceId/design-studio/$'
    | '/workspaces/$workspaceId/design-studio/dashboard'
    | '/workspaces/$workspaceId/design-studio/global-styles'
    | '/workspaces/$workspaceId/dev/condition-viewer'
    | '/workspaces/$workspaceId/experiments/$experimentId'
    | '/workspaces/$workspaceId/experiments/new'
    | '/workspaces/$workspaceId/geosets/import'
    | '/workspaces/$workspaceId/geosets/new'
    | '/workspaces/$workspaceId/home/add-people'
    | '/workspaces/$workspaceId/imports/new'
    | '/workspaces/$workspaceId/integrations/$type'
    | '/workspaces/$workspaceId/integrations/cdp_in'
    | '/workspaces/$workspaceId/integrations/cdp_out'
    | '/workspaces/$workspaceId/integrations/customerio'
    | '/workspaces/$workspaceId/integrations/mparticle_out'
    | '/workspaces/$workspaceId/integrations/segment_in'
    | '/workspaces/$workspaceId/integrations/segment_out'
    | '/workspaces/$workspaceId/journeys/$'
    | '/workspaces/$workspaceId/journeys/assets'
    | '/workspaces/$workspaceId/journeys/deliveries'
    | '/workspaces/$workspaceId/journeys/drafts'
    | '/workspaces/$workspaceId/journeys/exports'
    | '/workspaces/$workspaceId/journeys/message-library'
    | '/workspaces/$workspaceId/journeys/settings'
    | '/workspaces/$workspaceId/journeys/tasks'
    | '/workspaces/$workspaceId/outcomes/$goalId'
    | '/workspaces/$workspaceId/parcel/$'
    | '/workspaces/$workspaceId/people/create'
    | '/workspaces/$workspaceId/people/merge'
    | '/workspaces/$workspaceId/people/new'
    | '/workspaces/$workspaceId/people/welcome'
    | '/workspaces/$workspaceId/profiles/create'
    | '/workspaces/$workspaceId/profiles/merge'
    | '/workspaces/$workspaceId/profiles/new'
    | '/workspaces/$workspaceId/profiles/welcome'
    | '/workspaces/$workspaceId/reports/deliverability'
    | '/workspaces/$workspaceId/reports/email-clients'
    | '/workspaces/$workspaceId/settings/$'
    | '/workspaces/$workspaceId/settings/ai-business-profile'
    | '/workspaces/$workspaceId/settings/anonymous_events'
    | '/workspaces/$workspaceId/settings/api-keys'
    | '/workspaces/$workspaceId/settings/audit-logs'
    | '/workspaces/$workspaceId/settings/auto_archive'
    | '/workspaces/$workspaceId/settings/confirm_delete'
    | '/workspaces/$workspaceId/settings/edit'
    | '/workspaces/$workspaceId/settings/geofences'
    | '/workspaces/$workspaceId/settings/language'
    | '/workspaces/$workspaceId/settings/merge_options'
    | '/workspaces/$workspaceId/settings/suppressions'
    | '/workspaces/$workspaceId/snippets/$snippetId'
    | '/workspaces/$workspaceId/snippets/new'
    | '/workspaces/$workspaceId/template/$templateId'
    | '/settings/billing/available-plans'
    | '/workspaces/$workspaceId/agent'
    | '/workspaces/$workspaceId/boards'
    | '/workspaces/$workspaceId/design-studio'
    | '/workspaces/$workspaceId/experiments'
    | '/workspaces/$workspaceId/geosets'
    | '/workspaces/$workspaceId/home'
    | '/workspaces/$workspaceId/imports'
    | '/workspaces/$workspaceId/integrations'
    | '/workspaces/$workspaceId/objects'
    | '/workspaces/$workspaceId/outcomes'
    | '/workspaces/$workspaceId/parcel'
    | '/workspaces/$workspaceId/people'
    | '/workspaces/$workspaceId/pipelines'
    | '/workspaces/$workspaceId/profiles'
    | '/workspaces/$workspaceId/settings'
    | '/workspaces/$workspaceId/snippets'
    | '/workspaces/$workspaceId/template'
    | '/settings/team/members/$userId/edit'
    | '/workspaces/$workspaceId/agent/skills/$skillPath'
    | '/workspaces/$workspaceId/agent/skills/new'
    | '/workspaces/$workspaceId/automations/$campaignId/workflow'
    | '/workspaces/$workspaceId/geosets/$geosetId/edit'
    | '/workspaces/$workspaceId/home/workspace-setup/add-people'
    | '/workspaces/$workspaceId/integrations/all/developers'
    | '/workspaces/$workspaceId/integrations/all/directory'
    | '/workspaces/$workspaceId/integrations/all/overview'
    | '/workspaces/$workspaceId/integrations/all/webhooks'
    | '/workspaces/$workspaceId/integrations/data_out/$type'
    | '/workspaces/$workspaceId/integrations/reporting-webhooks/$webhookId'
    | '/workspaces/$workspaceId/integrations/reporting-webhooks/new'
    | '/workspaces/$workspaceId/integrations/warehouse/$type'
    | '/workspaces/$workspaceId/integrations/warehouse/bigquery'
    | '/workspaces/$workspaceId/integrations/warehouse/redshift'
    | '/workspaces/$workspaceId/integrations/warehouse/snowflake'
    | '/workspaces/$workspaceId/journeys/activity_logs/$tab'
    | '/workspaces/$workspaceId/journeys/analysis/deliverability'
    | '/workspaces/$workspaceId/journeys/geofences/$geofenceId'
    | '/workspaces/$workspaceId/journeys/geofences/new'
    | '/workspaces/$workspaceId/journeys/imports/new'
    | '/workspaces/$workspaceId/journeys/integrations/$type'
    | '/workspaces/$workspaceId/journeys/integrations/cdp_in'
    | '/workspaces/$workspaceId/journeys/integrations/cdp_out'
    | '/workspaces/$workspaceId/journeys/integrations/customerio'
    | '/workspaces/$workspaceId/journeys/integrations/mparticle_out'
    | '/workspaces/$workspaceId/journeys/integrations/segment_in'
    | '/workspaces/$workspaceId/journeys/integrations/segment_out'
    | '/workspaces/$workspaceId/journeys/layouts/new'
    | '/workspaces/$workspaceId/journeys/layouts/starters'
    | '/workspaces/$workspaceId/journeys/message_activity/$'
    | '/workspaces/$workspaceId/journeys/outbox/$'
    | '/workspaces/$workspaceId/journeys/people/create'
    | '/workspaces/$workspaceId/journeys/people/merge'
    | '/workspaces/$workspaceId/journeys/people/new'
    | '/workspaces/$workspaceId/journeys/people/welcome'
    | '/workspaces/$workspaceId/journeys/profile_activity/$tab'
    | '/workspaces/$workspaceId/journeys/profiles/create'
    | '/workspaces/$workspaceId/journeys/profiles/merge'
    | '/workspaces/$workspaceId/journeys/profiles/new'
    | '/workspaces/$workspaceId/journeys/profiles/welcome'
    | '/workspaces/$workspaceId/journeys/settings/$'
    | '/workspaces/$workspaceId/journeys/setup-guide/$'
    | '/workspaces/$workspaceId/journeys/snippets/$snippetId'
    | '/workspaces/$workspaceId/journeys/snippets/new'
    | '/workspaces/$workspaceId/journeys/template/$templateId'
    | '/workspaces/$workspaceId/journeys/triggered/new'
    | '/workspaces/$workspaceId/journeys/v2/$'
    | '/workspaces/$workspaceId/objects/$slug/guide'
    | '/workspaces/$workspaceId/objects/$slug/new'
    | '/workspaces/$workspaceId/pipelines/destinations/add'
    | '/workspaces/$workspaceId/pipelines/destinations/journeys'
    | '/workspaces/$workspaceId/pipelines/sources/add'
    | '/workspaces/$workspaceId/pipelines/sources/journeys'
    | '/workspaces/$workspaceId/settings/actions/line'
    | '/workspaces/$workspaceId/settings/actions/message_frequency_limits'
    | '/workspaces/$workspaceId/settings/actions/messaging_limit'
    | '/workspaces/$workspaceId/settings/actions/slack'
    | '/workspaces/$workspaceId/settings/actions/time_zone_match'
    | '/workspaces/$workspaceId/settings/actions/urban_airship'
    | '/workspaces/$workspaceId/settings/llm_configuration/new'
    | '/workspaces/$workspaceId/settings/objects/new'
    | '/workspaces/$workspaceId/settings/subscription_center/settings'
    | '/workspaces/$workspaceId/settings/webhook_configuration/new'
    | '/workspaces/$workspaceId/agent/skills'
    | '/workspaces/$workspaceId/geosets/$geosetId'
    | '/workspaces/$workspaceId/home/workspace-setup'
    | '/workspaces/$workspaceId/imports/$importId'
    | '/workspaces/$workspaceId/integrations/all'
    | '/workspaces/$workspaceId/integrations/reporting-webhooks'
    | '/workspaces/$workspaceId/journeys/activity_logs'
    | '/workspaces/$workspaceId/journeys/collections'
    | '/workspaces/$workspaceId/journeys/geofences'
    | '/workspaces/$workspaceId/journeys/imports'
    | '/workspaces/$workspaceId/journeys/integrations'
    | '/workspaces/$workspaceId/journeys/layouts'
    | '/workspaces/$workspaceId/journeys/objects'
    | '/workspaces/$workspaceId/journeys/people'
    | '/workspaces/$workspaceId/journeys/profile_activity'
    | '/workspaces/$workspaceId/journeys/profiles'
    | '/workspaces/$workspaceId/journeys/snippets'
    | '/workspaces/$workspaceId/journeys/template'
    | '/workspaces/$workspaceId/journeys/triggered'
    | '/workspaces/$workspaceId/objects/$slug'
    | '/workspaces/$workspaceId/pipelines/destinations'
    | '/workspaces/$workspaceId/pipelines/sources'
    | '/workspaces/$workspaceId/settings/api_credentials'
    | '/workspaces/$workspaceId/settings/llm_configuration'
    | '/workspaces/$workspaceId/settings/objects'
    | '/workspaces/$workspaceId/settings/subscription_center'
    | '/workspaces/$workspaceId/settings/webhook_configuration'
    | '/workspaces/$workspaceId/geosets/$geosetId/geofences/$geofenceId'
    | '/workspaces/$workspaceId/geosets/$geosetId/geofences/import'
    | '/workspaces/$workspaceId/geosets/$geosetId/geofences/new'
    | '/workspaces/$workspaceId/imports/$importId/setup/fields'
    | '/workspaces/$workspaceId/imports/$importId/setup/importing'
    | '/workspaces/$workspaceId/imports/$importId/setup/preprocessing'
    | '/workspaces/$workspaceId/imports/$importId/setup/preview'
    | '/workspaces/$workspaceId/imports/$importId/setup/review'
    | '/workspaces/$workspaceId/imports/$importId/setup/validating'
    | '/workspaces/$workspaceId/integrations/sql-sync/$type/new'
    | '/workspaces/$workspaceId/integrations/warehouse/$type/sync'
    | '/workspaces/$workspaceId/journeys/collections/$collectionId/$'
    | '/workspaces/$workspaceId/journeys/collections/$collectionId/data'
    | '/workspaces/$workspaceId/journeys/collections/$collectionId/importing'
    | '/workspaces/$workspaceId/journeys/collections/$collectionId/usage'
    | '/workspaces/$workspaceId/journeys/integrations/all/developers'
    | '/workspaces/$workspaceId/journeys/integrations/all/directory'
    | '/workspaces/$workspaceId/journeys/integrations/all/overview'
    | '/workspaces/$workspaceId/journeys/integrations/all/webhooks'
    | '/workspaces/$workspaceId/journeys/integrations/data_out/$type'
    | '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/$webhookId'
    | '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/new'
    | '/workspaces/$workspaceId/journeys/integrations/warehouse/$type'
    | '/workspaces/$workspaceId/journeys/integrations/warehouse/bigquery'
    | '/workspaces/$workspaceId/journeys/integrations/warehouse/redshift'
    | '/workspaces/$workspaceId/journeys/integrations/warehouse/snowflake'
    | '/workspaces/$workspaceId/journeys/layouts/$layoutId/edit'
    | '/workspaces/$workspaceId/journeys/objects/$slug/guide'
    | '/workspaces/$workspaceId/journeys/objects/$slug/new'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/data-out'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/exports'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/settings'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/tester'
    | '/workspaces/$workspaceId/pipelines/destinations/add/$destinationOptionId'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/data-in'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/databases'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/imports'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/settings'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs'
    | '/workspaces/$workspaceId/pipelines/sources/add/$sourceOptionId'
    | '/workspaces/$workspaceId/settings/actions/email/defaults'
    | '/workspaces/$workspaceId/settings/actions/email/deliverability'
    | '/workspaces/$workspaceId/settings/actions/email/dynamic_addresses'
    | '/workspaces/$workspaceId/settings/actions/email/from_addresses'
    | '/workspaces/$workspaceId/settings/actions/email/smtp'
    | '/workspaces/$workspaceId/settings/actions/email/suppression_list'
    | '/workspaces/$workspaceId/settings/actions/url_params/edit'
    | '/workspaces/$workspaceId/settings/api_credentials/service_accounts/$serviceAccountId'
    | '/workspaces/$workspaceId/settings/llm_configuration/$configurationId/edit'
    | '/workspaces/$workspaceId/settings/objects/edit/$objectType'
    | '/workspaces/$workspaceId/settings/subscription_center/branding/edit'
    | '/workspaces/$workspaceId/settings/subscription_center/localization/edit'
    | '/workspaces/$workspaceId/settings/subscription_center/topics/set_preferences'
    | '/workspaces/$workspaceId/settings/webhook_configuration/$webhookId/edit'
    | '/workspaces/$workspaceId/dev/db/campaigns'
    | '/workspaces/$workspaceId/geosets/$geosetId/geofences'
    | '/workspaces/$workspaceId/imports/$importId/setup'
    | '/workspaces/$workspaceId/integrations/sql-sync/$type'
    | '/workspaces/$workspaceId/journeys/collections/$collectionId'
    | '/workspaces/$workspaceId/journeys/imports/$importId'
    | '/workspaces/$workspaceId/journeys/integrations/all'
    | '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks'
    | '/workspaces/$workspaceId/journeys/layouts/$layoutId'
    | '/workspaces/$workspaceId/journeys/objects/$slug'
    | '/workspaces/$workspaceId/objects/$slug/$objectId'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId'
    | '/workspaces/$workspaceId/settings/actions/email'
    | '/workspaces/$workspaceId/settings/actions/sms-providers'
    | '/workspaces/$workspaceId/settings/actions/url_params'
    | '/workspaces/$workspaceId/settings/subscription_center/topics'
    | '/workspaces/$workspaceId/dev/db/campaigns/actions/$actionId'
    | '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/query'
    | '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/relationships-query'
    | '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/settings'
    | '/workspaces/$workspaceId/journeys/imports/$importId/setup/fields'
    | '/workspaces/$workspaceId/journeys/imports/$importId/setup/importing'
    | '/workspaces/$workspaceId/journeys/imports/$importId/setup/preprocessing'
    | '/workspaces/$workspaceId/journeys/imports/$importId/setup/preview'
    | '/workspaces/$workspaceId/journeys/imports/$importId/setup/review'
    | '/workspaces/$workspaceId/journeys/imports/$importId/setup/validating'
    | '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId'
    | '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/new'
    | '/workspaces/$workspaceId/journeys/integrations/warehouse/$type/sync'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/$subscriptionId'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/add'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs/$syncId'
    | '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs/add'
    | '/workspaces/$workspaceId/settings/actions/email/sending_domains/$domainId'
    | '/workspaces/$workspaceId/settings/actions/sms-providers/credentials/$credentialId'
    | '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId'
    | '/workspaces/$workspaceId/journeys/imports/$importId/setup'
    | '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type'
    | '/workspaces/$workspaceId/journeys/objects/$slug/$objectId'
    | '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions'
    | '/workspaces/$workspaceId/settings/actions/email/sending_domains'
    | '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/workflow/actions'
    | '/workspaces/$workspaceId/journeys/automations/$campaignId/setup/workflow/actions'
    | '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/workflow/actions'
    | '/workspaces/$workspaceId/journeys/campaigns/$campaignId/setup/workflow/actions'
    | '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId/query'
    | '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId/relationships-query'
    | '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId/settings';
  id:
    | '__root__'
    | '/_authenticated'
    | '/academy-login'
    | '/accept-guest-invitation'
    | '/checkout'
    | '/cli'
    | '/design-studio-embed'
    | '/join-request'
    | '/onboarding'
    | '/2fa_setup/$'
    | '/_authenticated/$'
    | '/_authenticated/workspaces'
    | '/account/$'
    | '/account_canceled/$'
    | '/account_cancelled/$'
    | '/cli/dns-setup'
    | '/confirm_account/$'
    | '/confirm_account_notice/$'
    | '/env/$'
    | '/har-sanitizer/$'
    | '/integrations/$'
    | '/journeys/$'
    | '/login/$'
    | '/logout/$'
    | '/no_accessible_workspaces/$'
    | '/oauth/$'
    | '/oauth2/$'
    | '/onboarding/get-started'
    | '/onboarding/verification'
    | '/onboarding/wizard'
    | '/post_cancel/$'
    | '/post_registration/$'
    | '/reset_password/$'
    | '/signup/$'
    | '/users/$'
    | '/vwb-demo/$'
    | '/_authenticated/'
    | '/cli/'
    | '/onboarding/'
    | '/_authenticated/internal-tools/$'
    | '/_authenticated/sample-workspace/$'
    | '/_authenticated/settings/$'
    | '/_authenticated/settings/ai'
    | '/_authenticated/settings/api-keys'
    | '/_authenticated/settings/audit-logs'
    | '/_authenticated/settings/billing'
    | '/_authenticated/settings/experimental-features'
    | '/_authenticated/settings/partner'
    | '/_authenticated/settings/privacy'
    | '/_authenticated/settings/receipts'
    | '/_authenticated/settings/slack-agent'
    | '/_authenticated/settings/subscription'
    | '/_authenticated/trial-expired/journeys'
    | '/_authenticated/workspaces/$workspaceId'
    | '/account/cancelled/$'
    | '/design-studio-embed/cio/$'
    | '/_authenticated/internal-tools/'
    | '/_authenticated/sample-workspace/'
    | '/_authenticated/settings/'
    | '/_authenticated/workspaces/'
    | '/design-studio-embed/cio/'
    | '/_authenticated/settings/account/edit'
    | '/_authenticated/settings/billing/$'
    | '/_authenticated/settings/billing/billing-details'
    | '/_authenticated/settings/billing/billing-history'
    | '/_authenticated/settings/billing/checkout'
    | '/_authenticated/settings/billing/inbox-preview-usage'
    | '/_authenticated/settings/billing/llm-usage'
    | '/_authenticated/settings/billing/overview'
    | '/_authenticated/settings/billing/payment-methods'
    | '/_authenticated/settings/billing/profile-growth'
    | '/_authenticated/settings/billing/usage'
    | '/_authenticated/settings/billing/your-plan'
    | '/_authenticated/settings/partner/create'
    | '/_authenticated/settings/personal/google-identities'
    | '/_authenticated/settings/roles/$roleId'
    | '/_authenticated/settings/roles/new'
    | '/_authenticated/settings/security/sso'
    | '/_authenticated/settings/slack-agent_/link'
    | '/_authenticated/settings/team/add'
    | '/_authenticated/settings/team/invite-guest'
    | '/_authenticated/settings/workspaces/new'
    | '/_authenticated/workspaces/$workspaceId/$'
    | '/_authenticated/workspaces/$workspaceId/agent'
    | '/_authenticated/workspaces/$workspaceId/assets'
    | '/_authenticated/workspaces/$workspaceId/design-studio'
    | '/_authenticated/workspaces/$workspaceId/experiments'
    | '/_authenticated/workspaces/$workspaceId/exports'
    | '/_authenticated/workspaces/$workspaceId/geosets'
    | '/_authenticated/workspaces/$workspaceId/health'
    | '/_authenticated/workspaces/$workspaceId/home'
    | '/_authenticated/workspaces/$workspaceId/journeys_'
    | '/_authenticated/workspaces/$workspaceId/message-library'
    | '/_authenticated/workspaces/$workspaceId/outcomes'
    | '/_authenticated/workspaces/$workspaceId/snippets'
    | '/_authenticated/workspaces/$workspaceId/tasks'
    | '/pipelines/workspaces/$workspaceId/$'
    | '/_authenticated/settings/account/'
    | '/_authenticated/settings/api_credentials/'
    | '/_authenticated/settings/billing/'
    | '/_authenticated/settings/partner/'
    | '/_authenticated/settings/personal/'
    | '/_authenticated/settings/roles/'
    | '/_authenticated/settings/security/'
    | '/_authenticated/settings/team/'
    | '/_authenticated/settings/workspaces/'
    | '/_authenticated/workspaces/$workspaceId/'
    | '/pipelines/workspaces/$workspaceId/'
    | '/_authenticated/settings/api_credentials/service_accounts/$serviceAccountId'
    | '/_authenticated/settings/billing/available-plans/journeys'
    | '/_authenticated/settings/team/join-requests/$requestId'
    | '/_authenticated/workspaces/$workspaceId/agent/routines'
    | '/_authenticated/workspaces/$workspaceId/agent/skills'
    | '/_authenticated/workspaces/$workspaceId/analysis/deliverability'
    | '/_authenticated/workspaces/$workspaceId/analysis/email-clients'
    | '/_authenticated/workspaces/$workspaceId/boards/$boardId'
    | '/_authenticated/workspaces/$workspaceId/design-studio/$'
    | '/_authenticated/workspaces/$workspaceId/design-studio_/dashboard'
    | '/_authenticated/workspaces/$workspaceId/design-studio_/global-styles'
    | '/_authenticated/workspaces/$workspaceId/dev/condition-viewer'
    | '/_authenticated/workspaces/$workspaceId/experiments/$experimentId'
    | '/_authenticated/workspaces/$workspaceId/experiments/new'
    | '/_authenticated/workspaces/$workspaceId/geosets/$geosetId'
    | '/_authenticated/workspaces/$workspaceId/geosets/import'
    | '/_authenticated/workspaces/$workspaceId/geosets/new'
    | '/_authenticated/workspaces/$workspaceId/home/add-people'
    | '/_authenticated/workspaces/$workspaceId/home/workspace-setup'
    | '/_authenticated/workspaces/$workspaceId/imports/new'
    | '/_authenticated/workspaces/$workspaceId/integrations/$type'
    | '/_authenticated/workspaces/$workspaceId/integrations/all'
    | '/_authenticated/workspaces/$workspaceId/integrations/cdp_in'
    | '/_authenticated/workspaces/$workspaceId/integrations/cdp_out'
    | '/_authenticated/workspaces/$workspaceId/integrations/customerio'
    | '/_authenticated/workspaces/$workspaceId/integrations/mparticle_out'
    | '/_authenticated/workspaces/$workspaceId/integrations/segment_in'
    | '/_authenticated/workspaces/$workspaceId/integrations/segment_out'
    | '/_authenticated/workspaces/$workspaceId/journeys/$'
    | '/_authenticated/workspaces/$workspaceId/journeys/assets'
    | '/_authenticated/workspaces/$workspaceId/journeys/collections'
    | '/_authenticated/workspaces/$workspaceId/journeys/deliveries'
    | '/_authenticated/workspaces/$workspaceId/journeys/drafts'
    | '/_authenticated/workspaces/$workspaceId/journeys/exports'
    | '/_authenticated/workspaces/$workspaceId/journeys/geofences'
    | '/_authenticated/workspaces/$workspaceId/journeys/message-library'
    | '/_authenticated/workspaces/$workspaceId/journeys/settings'
    | '/_authenticated/workspaces/$workspaceId/journeys/snippets'
    | '/_authenticated/workspaces/$workspaceId/journeys/tasks'
    | '/_authenticated/workspaces/$workspaceId/outcomes/$goalId'
    | '/_authenticated/workspaces/$workspaceId/parcel/$'
    | '/_authenticated/workspaces/$workspaceId/people/create'
    | '/_authenticated/workspaces/$workspaceId/people/merge'
    | '/_authenticated/workspaces/$workspaceId/people/new'
    | '/_authenticated/workspaces/$workspaceId/people/welcome'
    | '/_authenticated/workspaces/$workspaceId/profiles/create'
    | '/_authenticated/workspaces/$workspaceId/profiles/merge'
    | '/_authenticated/workspaces/$workspaceId/profiles/new'
    | '/_authenticated/workspaces/$workspaceId/profiles/welcome'
    | '/_authenticated/workspaces/$workspaceId/reports/deliverability'
    | '/_authenticated/workspaces/$workspaceId/reports/email-clients'
    | '/_authenticated/workspaces/$workspaceId/settings/$'
    | '/_authenticated/workspaces/$workspaceId/settings/ai-business-profile'
    | '/_authenticated/workspaces/$workspaceId/settings/anonymous_events'
    | '/_authenticated/workspaces/$workspaceId/settings/api-keys'
    | '/_authenticated/workspaces/$workspaceId/settings/audit-logs'
    | '/_authenticated/workspaces/$workspaceId/settings/auto_archive'
    | '/_authenticated/workspaces/$workspaceId/settings/confirm_delete'
    | '/_authenticated/workspaces/$workspaceId/settings/edit'
    | '/_authenticated/workspaces/$workspaceId/settings/geofences'
    | '/_authenticated/workspaces/$workspaceId/settings/language'
    | '/_authenticated/workspaces/$workspaceId/settings/llm_configuration'
    | '/_authenticated/workspaces/$workspaceId/settings/merge_options'
    | '/_authenticated/workspaces/$workspaceId/settings/subscription_center'
    | '/_authenticated/workspaces/$workspaceId/settings/suppressions'
    | '/_authenticated/workspaces/$workspaceId/snippets/$snippetId'
    | '/_authenticated/workspaces/$workspaceId/snippets/new'
    | '/_authenticated/workspaces/$workspaceId/template/$templateId'
    | '/_authenticated/settings/billing/available-plans/'
    | '/_authenticated/workspaces/$workspaceId/agent/'
    | '/_authenticated/workspaces/$workspaceId/boards/'
    | '/_authenticated/workspaces/$workspaceId/design-studio/'
    | '/_authenticated/workspaces/$workspaceId/experiments/'
    | '/_authenticated/workspaces/$workspaceId/geosets/'
    | '/_authenticated/workspaces/$workspaceId/home/'
    | '/_authenticated/workspaces/$workspaceId/imports/'
    | '/_authenticated/workspaces/$workspaceId/integrations/'
    | '/_authenticated/workspaces/$workspaceId/objects/'
    | '/_authenticated/workspaces/$workspaceId/outcomes/'
    | '/_authenticated/workspaces/$workspaceId/parcel/'
    | '/_authenticated/workspaces/$workspaceId/people/'
    | '/_authenticated/workspaces/$workspaceId/pipelines/'
    | '/_authenticated/workspaces/$workspaceId/profiles/'
    | '/_authenticated/workspaces/$workspaceId/settings/'
    | '/_authenticated/workspaces/$workspaceId/snippets/'
    | '/_authenticated/workspaces/$workspaceId/template/'
    | '/_authenticated/settings/team/members/$userId/edit'
    | '/_authenticated/workspaces/$workspaceId/agent/skills/$skillPath'
    | '/_authenticated/workspaces/$workspaceId/agent/skills/new'
    | '/_authenticated/workspaces/$workspaceId/automations/$campaignId/workflow'
    | '/_authenticated/workspaces/$workspaceId/dev/db/campaigns'
    | '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/edit'
    | '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences'
    | '/_authenticated/workspaces/$workspaceId/home/workspace-setup/add-people'
    | '/_authenticated/workspaces/$workspaceId/integrations/all/developers'
    | '/_authenticated/workspaces/$workspaceId/integrations/all/directory'
    | '/_authenticated/workspaces/$workspaceId/integrations/all/overview'
    | '/_authenticated/workspaces/$workspaceId/integrations/all/webhooks'
    | '/_authenticated/workspaces/$workspaceId/integrations/data_out/$type'
    | '/_authenticated/workspaces/$workspaceId/integrations/reporting-webhooks/$webhookId'
    | '/_authenticated/workspaces/$workspaceId/integrations/reporting-webhooks/new'
    | '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type'
    | '/_authenticated/workspaces/$workspaceId/integrations/warehouse/$type'
    | '/_authenticated/workspaces/$workspaceId/integrations/warehouse/bigquery'
    | '/_authenticated/workspaces/$workspaceId/integrations/warehouse/redshift'
    | '/_authenticated/workspaces/$workspaceId/integrations/warehouse/snowflake'
    | '/_authenticated/workspaces/$workspaceId/journeys/activity_logs/$tab'
    | '/_authenticated/workspaces/$workspaceId/journeys/analysis/deliverability'
    | '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId'
    | '/_authenticated/workspaces/$workspaceId/journeys/geofences/$geofenceId'
    | '/_authenticated/workspaces/$workspaceId/journeys/geofences/new'
    | '/_authenticated/workspaces/$workspaceId/journeys/imports/new'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/$type'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/all'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/cdp_in'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/cdp_out'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/customerio'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/mparticle_out'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/segment_in'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/segment_out'
    | '/_authenticated/workspaces/$workspaceId/journeys/layouts/new'
    | '/_authenticated/workspaces/$workspaceId/journeys/layouts/starters'
    | '/_authenticated/workspaces/$workspaceId/journeys/message_activity/$'
    | '/_authenticated/workspaces/$workspaceId/journeys/outbox/$'
    | '/_authenticated/workspaces/$workspaceId/journeys/people/create'
    | '/_authenticated/workspaces/$workspaceId/journeys/people/merge'
    | '/_authenticated/workspaces/$workspaceId/journeys/people/new'
    | '/_authenticated/workspaces/$workspaceId/journeys/people/welcome'
    | '/_authenticated/workspaces/$workspaceId/journeys/profile_activity/$tab'
    | '/_authenticated/workspaces/$workspaceId/journeys/profiles/create'
    | '/_authenticated/workspaces/$workspaceId/journeys/profiles/merge'
    | '/_authenticated/workspaces/$workspaceId/journeys/profiles/new'
    | '/_authenticated/workspaces/$workspaceId/journeys/profiles/welcome'
    | '/_authenticated/workspaces/$workspaceId/journeys/settings/$'
    | '/_authenticated/workspaces/$workspaceId/journeys/setup-guide/$'
    | '/_authenticated/workspaces/$workspaceId/journeys/snippets/$snippetId'
    | '/_authenticated/workspaces/$workspaceId/journeys/snippets/new'
    | '/_authenticated/workspaces/$workspaceId/journeys/template/$templateId'
    | '/_authenticated/workspaces/$workspaceId/journeys/triggered/new'
    | '/_authenticated/workspaces/$workspaceId/journeys/v2/$'
    | '/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId'
    | '/_authenticated/workspaces/$workspaceId/objects/$slug/guide'
    | '/_authenticated/workspaces/$workspaceId/objects/$slug/new'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/add'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/journeys'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/add'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/journeys'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/email'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/line'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/message_frequency_limits'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/messaging_limit'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/slack'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/sms-providers'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/time_zone_match'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/urban_airship'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/url_params'
    | '/_authenticated/workspaces/$workspaceId/settings/llm_configuration/new'
    | '/_authenticated/workspaces/$workspaceId/settings/objects/new'
    | '/_authenticated/workspaces/$workspaceId/settings/subscription_center/settings'
    | '/_authenticated/workspaces/$workspaceId/settings/webhook_configuration/new'
    | '/_authenticated/workspaces/$workspaceId/agent/skills/'
    | '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/'
    | '/_authenticated/workspaces/$workspaceId/home/workspace-setup/'
    | '/_authenticated/workspaces/$workspaceId/imports/$importId/'
    | '/_authenticated/workspaces/$workspaceId/integrations/all/'
    | '/_authenticated/workspaces/$workspaceId/integrations/reporting-webhooks/'
    | '/_authenticated/workspaces/$workspaceId/journeys/activity_logs/'
    | '/_authenticated/workspaces/$workspaceId/journeys/collections/'
    | '/_authenticated/workspaces/$workspaceId/journeys/geofences/'
    | '/_authenticated/workspaces/$workspaceId/journeys/imports/'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/'
    | '/_authenticated/workspaces/$workspaceId/journeys/layouts/'
    | '/_authenticated/workspaces/$workspaceId/journeys/objects/'
    | '/_authenticated/workspaces/$workspaceId/journeys/people/'
    | '/_authenticated/workspaces/$workspaceId/journeys/profile_activity/'
    | '/_authenticated/workspaces/$workspaceId/journeys/profiles/'
    | '/_authenticated/workspaces/$workspaceId/journeys/snippets/'
    | '/_authenticated/workspaces/$workspaceId/journeys/template/'
    | '/_authenticated/workspaces/$workspaceId/journeys/triggered/'
    | '/_authenticated/workspaces/$workspaceId/objects/$slug/'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/'
    | '/_authenticated/workspaces/$workspaceId/settings/api_credentials/'
    | '/_authenticated/workspaces/$workspaceId/settings/llm_configuration/'
    | '/_authenticated/workspaces/$workspaceId/settings/objects/'
    | '/_authenticated/workspaces/$workspaceId/settings/subscription_center/'
    | '/_authenticated/workspaces/$workspaceId/settings/webhook_configuration/'
    | '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences/$geofenceId'
    | '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences/import'
    | '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences/new'
    | '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/fields'
    | '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/importing'
    | '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/preprocessing'
    | '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/preview'
    | '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/review'
    | '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/validating'
    | '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId'
    | '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/new'
    | '/_authenticated/workspaces/$workspaceId/integrations/warehouse/$type_/sync'
    | '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/$'
    | '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/data'
    | '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/importing'
    | '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/usage'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/developers'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/directory'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/overview'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/webhooks'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/data_out/$type'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/$webhookId'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/new'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/$type'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/bigquery'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/redshift'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/snowflake'
    | '/_authenticated/workspaces/$workspaceId/journeys/layouts/$layoutId/edit'
    | '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/guide'
    | '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/new'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/data-out'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/exports'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/settings'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/tester'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/add_/$destinationOptionId'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/data-in'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/databases'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/imports'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/settings'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/add_/$sourceOptionId'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/email/defaults'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/email/deliverability'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/email/dynamic_addresses'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/email/from_addresses'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/email/smtp'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/email/suppression_list'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/url_params/edit'
    | '/_authenticated/workspaces/$workspaceId/settings/api_credentials/service_accounts/$serviceAccountId'
    | '/_authenticated/workspaces/$workspaceId/settings/llm_configuration/$configurationId/edit'
    | '/_authenticated/workspaces/$workspaceId/settings/objects/edit/$objectType'
    | '/_authenticated/workspaces/$workspaceId/settings/subscription_center/branding/edit'
    | '/_authenticated/workspaces/$workspaceId/settings/subscription_center/localization/edit'
    | '/_authenticated/workspaces/$workspaceId/settings/subscription_center/topics/set_preferences'
    | '/_authenticated/workspaces/$workspaceId/settings/webhook_configuration/$webhookId/edit'
    | '/_authenticated/workspaces/$workspaceId/dev/db/campaigns/'
    | '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences/'
    | '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/'
    | '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/'
    | '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/'
    | '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/'
    | '/_authenticated/workspaces/$workspaceId/journeys/layouts/$layoutId/'
    | '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/'
    | '/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId/'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/email/'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/sms-providers/'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/url_params/'
    | '/_authenticated/workspaces/$workspaceId/settings/subscription_center/topics/'
    | '/_authenticated/workspaces/$workspaceId/dev/db/campaigns/actions/$actionId'
    | '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/query'
    | '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/relationships-query'
    | '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/settings'
    | '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/fields'
    | '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/importing'
    | '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/preprocessing'
    | '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/preview'
    | '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/review'
    | '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/validating'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/new'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/$type_/sync'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/$subscriptionId'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/add'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId_/syncs/$syncId'
    | '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId_/syncs/add'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/email/sending_domains/$domainId'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/sms-providers/credentials/$credentialId'
    | '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/'
    | '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/'
    | '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/$objectId/'
    | '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/'
    | '/_authenticated/workspaces/$workspaceId/settings/actions/email/sending_domains/'
    | '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/workflow/actions'
    | '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/setup/workflow/actions'
    | '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/workflow/actions'
    | '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/setup/workflow/actions'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId_/query'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId_/relationships-query'
    | '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId_/settings';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren;
  AcademyLoginRoute: typeof AcademyLoginRoute;
  AcceptGuestInvitationRoute: typeof AcceptGuestInvitationRoute;
  CheckoutRoute: typeof CheckoutRoute;
  CliRoute: typeof CliRouteWithChildren;
  DesignStudioEmbedRoute: typeof DesignStudioEmbedRouteWithChildren;
  JoinRequestRoute: typeof JoinRequestRoute;
  OnboardingRoute: typeof OnboardingRouteWithChildren;
  R2fa_setupSplatRoute: typeof R2fa_setupSplatRoute;
  AccountSplatRoute: typeof AccountSplatRoute;
  Account_canceledSplatRoute: typeof Account_canceledSplatRoute;
  Account_cancelledSplatRoute: typeof Account_cancelledSplatRoute;
  Confirm_accountSplatRoute: typeof Confirm_accountSplatRoute;
  Confirm_account_noticeSplatRoute: typeof Confirm_account_noticeSplatRoute;
  EnvSplatRoute: typeof EnvSplatRoute;
  HarSanitizerSplatRoute: typeof HarSanitizerSplatRoute;
  IntegrationsSplatRoute: typeof IntegrationsSplatRoute;
  JourneysSplatRoute: typeof JourneysSplatRoute;
  LoginSplatRoute: typeof LoginSplatRoute;
  LogoutSplatRoute: typeof LogoutSplatRoute;
  No_accessible_workspacesSplatRoute: typeof No_accessible_workspacesSplatRoute;
  OauthSplatRoute: typeof OauthSplatRoute;
  Oauth2SplatRoute: typeof Oauth2SplatRoute;
  Post_cancelSplatRoute: typeof Post_cancelSplatRoute;
  Post_registrationSplatRoute: typeof Post_registrationSplatRoute;
  Reset_passwordSplatRoute: typeof Reset_passwordSplatRoute;
  SignupSplatRoute: typeof SignupSplatRoute;
  UsersSplatRoute: typeof UsersSplatRoute;
  VwbDemoSplatRoute: typeof VwbDemoSplatRoute;
  AccountCancelledSplatRoute: typeof AccountCancelledSplatRoute;
  PipelinesWorkspacesWorkspaceIdSplatRoute: typeof PipelinesWorkspacesWorkspaceIdSplatRoute;
  PipelinesWorkspacesWorkspaceIdIndexRoute: typeof PipelinesWorkspacesWorkspaceIdIndexRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/onboarding': {
      id: '/onboarding';
      path: '/onboarding';
      fullPath: '/onboarding';
      preLoaderRoute: typeof OnboardingRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/join-request': {
      id: '/join-request';
      path: '/join-request';
      fullPath: '/join-request';
      preLoaderRoute: typeof JoinRequestRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/design-studio-embed': {
      id: '/design-studio-embed';
      path: '/design-studio-embed';
      fullPath: '/design-studio-embed';
      preLoaderRoute: typeof DesignStudioEmbedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/cli': {
      id: '/cli';
      path: '/cli';
      fullPath: '/cli';
      preLoaderRoute: typeof CliRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/checkout': {
      id: '/checkout';
      path: '/checkout';
      fullPath: '/checkout';
      preLoaderRoute: typeof CheckoutRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/accept-guest-invitation': {
      id: '/accept-guest-invitation';
      path: '/accept-guest-invitation';
      fullPath: '/accept-guest-invitation';
      preLoaderRoute: typeof AcceptGuestInvitationRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/academy-login': {
      id: '/academy-login';
      path: '/academy-login';
      fullPath: '/academy-login';
      preLoaderRoute: typeof AcademyLoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authenticated': {
      id: '/_authenticated';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof AuthenticatedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/onboarding/': {
      id: '/onboarding/';
      path: '/';
      fullPath: '/onboarding/';
      preLoaderRoute: typeof OnboardingIndexRouteImport;
      parentRoute: typeof OnboardingRoute;
    };
    '/cli/': {
      id: '/cli/';
      path: '/';
      fullPath: '/cli/';
      preLoaderRoute: typeof CliIndexRouteImport;
      parentRoute: typeof CliRoute;
    };
    '/_authenticated/': {
      id: '/_authenticated/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof AuthenticatedIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/vwb-demo/$': {
      id: '/vwb-demo/$';
      path: '/vwb-demo/$';
      fullPath: '/vwb-demo/$';
      preLoaderRoute: typeof VwbDemoSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/users/$': {
      id: '/users/$';
      path: '/users/$';
      fullPath: '/users/$';
      preLoaderRoute: typeof UsersSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/signup/$': {
      id: '/signup/$';
      path: '/signup/$';
      fullPath: '/signup/$';
      preLoaderRoute: typeof SignupSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/reset_password/$': {
      id: '/reset_password/$';
      path: '/reset_password/$';
      fullPath: '/reset_password/$';
      preLoaderRoute: typeof Reset_passwordSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/post_registration/$': {
      id: '/post_registration/$';
      path: '/post_registration/$';
      fullPath: '/post_registration/$';
      preLoaderRoute: typeof Post_registrationSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/post_cancel/$': {
      id: '/post_cancel/$';
      path: '/post_cancel/$';
      fullPath: '/post_cancel/$';
      preLoaderRoute: typeof Post_cancelSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/onboarding/wizard': {
      id: '/onboarding/wizard';
      path: '/wizard';
      fullPath: '/onboarding/wizard';
      preLoaderRoute: typeof OnboardingWizardRouteImport;
      parentRoute: typeof OnboardingRoute;
    };
    '/onboarding/verification': {
      id: '/onboarding/verification';
      path: '/verification';
      fullPath: '/onboarding/verification';
      preLoaderRoute: typeof OnboardingVerificationRouteImport;
      parentRoute: typeof OnboardingRoute;
    };
    '/onboarding/get-started': {
      id: '/onboarding/get-started';
      path: '/get-started';
      fullPath: '/onboarding/get-started';
      preLoaderRoute: typeof OnboardingGetStartedRouteImport;
      parentRoute: typeof OnboardingRoute;
    };
    '/oauth2/$': {
      id: '/oauth2/$';
      path: '/oauth2/$';
      fullPath: '/oauth2/$';
      preLoaderRoute: typeof Oauth2SplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/oauth/$': {
      id: '/oauth/$';
      path: '/oauth/$';
      fullPath: '/oauth/$';
      preLoaderRoute: typeof OauthSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/no_accessible_workspaces/$': {
      id: '/no_accessible_workspaces/$';
      path: '/no_accessible_workspaces/$';
      fullPath: '/no_accessible_workspaces/$';
      preLoaderRoute: typeof No_accessible_workspacesSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/logout/$': {
      id: '/logout/$';
      path: '/logout/$';
      fullPath: '/logout/$';
      preLoaderRoute: typeof LogoutSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/login/$': {
      id: '/login/$';
      path: '/login/$';
      fullPath: '/login/$';
      preLoaderRoute: typeof LoginSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/journeys/$': {
      id: '/journeys/$';
      path: '/journeys/$';
      fullPath: '/journeys/$';
      preLoaderRoute: typeof JourneysSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/integrations/$': {
      id: '/integrations/$';
      path: '/integrations/$';
      fullPath: '/integrations/$';
      preLoaderRoute: typeof IntegrationsSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/har-sanitizer/$': {
      id: '/har-sanitizer/$';
      path: '/har-sanitizer/$';
      fullPath: '/har-sanitizer/$';
      preLoaderRoute: typeof HarSanitizerSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/env/$': {
      id: '/env/$';
      path: '/env/$';
      fullPath: '/env/$';
      preLoaderRoute: typeof EnvSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/confirm_account_notice/$': {
      id: '/confirm_account_notice/$';
      path: '/confirm_account_notice/$';
      fullPath: '/confirm_account_notice/$';
      preLoaderRoute: typeof Confirm_account_noticeSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/confirm_account/$': {
      id: '/confirm_account/$';
      path: '/confirm_account/$';
      fullPath: '/confirm_account/$';
      preLoaderRoute: typeof Confirm_accountSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/cli/dns-setup': {
      id: '/cli/dns-setup';
      path: '/dns-setup';
      fullPath: '/cli/dns-setup';
      preLoaderRoute: typeof CliDnsSetupRouteImport;
      parentRoute: typeof CliRoute;
    };
    '/account_cancelled/$': {
      id: '/account_cancelled/$';
      path: '/account_cancelled/$';
      fullPath: '/account_cancelled/$';
      preLoaderRoute: typeof Account_cancelledSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/account_canceled/$': {
      id: '/account_canceled/$';
      path: '/account_canceled/$';
      fullPath: '/account_canceled/$';
      preLoaderRoute: typeof Account_canceledSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/account/$': {
      id: '/account/$';
      path: '/account/$';
      fullPath: '/account/$';
      preLoaderRoute: typeof AccountSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authenticated/workspaces': {
      id: '/_authenticated/workspaces';
      path: '/workspaces';
      fullPath: '/workspaces';
      preLoaderRoute: typeof AuthenticatedWorkspacesRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/$': {
      id: '/_authenticated/$';
      path: '/$';
      fullPath: '/$';
      preLoaderRoute: typeof AuthenticatedSplatRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/2fa_setup/$': {
      id: '/2fa_setup/$';
      path: '/2fa_setup/$';
      fullPath: '/2fa_setup/$';
      preLoaderRoute: typeof R2fa_setupSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/design-studio-embed/cio/': {
      id: '/design-studio-embed/cio/';
      path: '/cio';
      fullPath: '/design-studio-embed/cio/';
      preLoaderRoute: typeof DesignStudioEmbedCioIndexRouteImport;
      parentRoute: typeof DesignStudioEmbedRoute;
    };
    '/_authenticated/workspaces/': {
      id: '/_authenticated/workspaces/';
      path: '/';
      fullPath: '/workspaces/';
      preLoaderRoute: typeof AuthenticatedWorkspacesIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesRoute;
    };
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/';
      path: '/settings';
      fullPath: '/settings/';
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/sample-workspace/': {
      id: '/_authenticated/sample-workspace/';
      path: '/sample-workspace';
      fullPath: '/sample-workspace/';
      preLoaderRoute: typeof AuthenticatedSampleWorkspaceIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/internal-tools/': {
      id: '/_authenticated/internal-tools/';
      path: '/internal-tools';
      fullPath: '/internal-tools/';
      preLoaderRoute: typeof AuthenticatedInternalToolsIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/design-studio-embed/cio/$': {
      id: '/design-studio-embed/cio/$';
      path: '/cio/$';
      fullPath: '/design-studio-embed/cio/$';
      preLoaderRoute: typeof DesignStudioEmbedCioSplatRouteImport;
      parentRoute: typeof DesignStudioEmbedRoute;
    };
    '/account/cancelled/$': {
      id: '/account/cancelled/$';
      path: '/account/cancelled/$';
      fullPath: '/account/cancelled/$';
      preLoaderRoute: typeof AccountCancelledSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authenticated/workspaces/$workspaceId': {
      id: '/_authenticated/workspaces/$workspaceId';
      path: '/$workspaceId';
      fullPath: '/workspaces/$workspaceId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesRoute;
    };
    '/_authenticated/trial-expired/journeys': {
      id: '/_authenticated/trial-expired/journeys';
      path: '/trial-expired/journeys';
      fullPath: '/trial-expired/journeys';
      preLoaderRoute: typeof AuthenticatedTrialExpiredJourneysRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/subscription': {
      id: '/_authenticated/settings/subscription';
      path: '/settings/subscription';
      fullPath: '/settings/subscription';
      preLoaderRoute: typeof AuthenticatedSettingsSubscriptionRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/slack-agent': {
      id: '/_authenticated/settings/slack-agent';
      path: '/settings/slack-agent';
      fullPath: '/settings/slack-agent';
      preLoaderRoute: typeof AuthenticatedSettingsSlackAgentRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/receipts': {
      id: '/_authenticated/settings/receipts';
      path: '/settings/receipts';
      fullPath: '/settings/receipts';
      preLoaderRoute: typeof AuthenticatedSettingsReceiptsRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/privacy': {
      id: '/_authenticated/settings/privacy';
      path: '/settings/privacy';
      fullPath: '/settings/privacy';
      preLoaderRoute: typeof AuthenticatedSettingsPrivacyRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/partner': {
      id: '/_authenticated/settings/partner';
      path: '/settings/partner';
      fullPath: '/settings/partner';
      preLoaderRoute: typeof AuthenticatedSettingsPartnerRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/experimental-features': {
      id: '/_authenticated/settings/experimental-features';
      path: '/settings/experimental-features';
      fullPath: '/settings/experimental-features';
      preLoaderRoute: typeof AuthenticatedSettingsExperimentalFeaturesRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/billing': {
      id: '/_authenticated/settings/billing';
      path: '/settings/billing';
      fullPath: '/settings/billing';
      preLoaderRoute: typeof AuthenticatedSettingsBillingRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/audit-logs': {
      id: '/_authenticated/settings/audit-logs';
      path: '/settings/audit-logs';
      fullPath: '/settings/audit-logs';
      preLoaderRoute: typeof AuthenticatedSettingsAuditLogsRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/api-keys': {
      id: '/_authenticated/settings/api-keys';
      path: '/settings/api-keys';
      fullPath: '/settings/api-keys';
      preLoaderRoute: typeof AuthenticatedSettingsApiKeysRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/ai': {
      id: '/_authenticated/settings/ai';
      path: '/settings/ai';
      fullPath: '/settings/ai';
      preLoaderRoute: typeof AuthenticatedSettingsAiRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/$': {
      id: '/_authenticated/settings/$';
      path: '/settings/$';
      fullPath: '/settings/$';
      preLoaderRoute: typeof AuthenticatedSettingsSplatRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/sample-workspace/$': {
      id: '/_authenticated/sample-workspace/$';
      path: '/sample-workspace/$';
      fullPath: '/sample-workspace/$';
      preLoaderRoute: typeof AuthenticatedSampleWorkspaceSplatRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/internal-tools/$': {
      id: '/_authenticated/internal-tools/$';
      path: '/internal-tools/$';
      fullPath: '/internal-tools/$';
      preLoaderRoute: typeof AuthenticatedInternalToolsSplatRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/pipelines/workspaces/$workspaceId/': {
      id: '/pipelines/workspaces/$workspaceId/';
      path: '/pipelines/workspaces/$workspaceId';
      fullPath: '/pipelines/workspaces/$workspaceId/';
      preLoaderRoute: typeof PipelinesWorkspacesWorkspaceIdIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authenticated/workspaces/$workspaceId/': {
      id: '/_authenticated/workspaces/$workspaceId/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/settings/workspaces/': {
      id: '/_authenticated/settings/workspaces/';
      path: '/settings/workspaces';
      fullPath: '/settings/workspaces/';
      preLoaderRoute: typeof AuthenticatedSettingsWorkspacesIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/team/': {
      id: '/_authenticated/settings/team/';
      path: '/settings/team';
      fullPath: '/settings/team/';
      preLoaderRoute: typeof AuthenticatedSettingsTeamIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/security/': {
      id: '/_authenticated/settings/security/';
      path: '/settings/security';
      fullPath: '/settings/security/';
      preLoaderRoute: typeof AuthenticatedSettingsSecurityIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/roles/': {
      id: '/_authenticated/settings/roles/';
      path: '/settings/roles';
      fullPath: '/settings/roles/';
      preLoaderRoute: typeof AuthenticatedSettingsRolesIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/personal/': {
      id: '/_authenticated/settings/personal/';
      path: '/settings/personal';
      fullPath: '/settings/personal/';
      preLoaderRoute: typeof AuthenticatedSettingsPersonalIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/partner/': {
      id: '/_authenticated/settings/partner/';
      path: '/';
      fullPath: '/settings/partner/';
      preLoaderRoute: typeof AuthenticatedSettingsPartnerIndexRouteImport;
      parentRoute: typeof AuthenticatedSettingsPartnerRoute;
    };
    '/_authenticated/settings/billing/': {
      id: '/_authenticated/settings/billing/';
      path: '/';
      fullPath: '/settings/billing/';
      preLoaderRoute: typeof AuthenticatedSettingsBillingIndexRouteImport;
      parentRoute: typeof AuthenticatedSettingsBillingRoute;
    };
    '/_authenticated/settings/api_credentials/': {
      id: '/_authenticated/settings/api_credentials/';
      path: '/settings/api_credentials';
      fullPath: '/settings/api_credentials/';
      preLoaderRoute: typeof AuthenticatedSettingsApi_credentialsIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/account/': {
      id: '/_authenticated/settings/account/';
      path: '/settings/account';
      fullPath: '/settings/account/';
      preLoaderRoute: typeof AuthenticatedSettingsAccountIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/pipelines/workspaces/$workspaceId/$': {
      id: '/pipelines/workspaces/$workspaceId/$';
      path: '/pipelines/workspaces/$workspaceId/$';
      fullPath: '/pipelines/workspaces/$workspaceId/$';
      preLoaderRoute: typeof PipelinesWorkspacesWorkspaceIdSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authenticated/workspaces/$workspaceId/tasks': {
      id: '/_authenticated/workspaces/$workspaceId/tasks';
      path: '/tasks';
      fullPath: '/workspaces/$workspaceId/tasks';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdTasksRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/snippets': {
      id: '/_authenticated/workspaces/$workspaceId/snippets';
      path: '/snippets';
      fullPath: '/workspaces/$workspaceId/snippets';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSnippetsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/outcomes': {
      id: '/_authenticated/workspaces/$workspaceId/outcomes';
      path: '/outcomes';
      fullPath: '/workspaces/$workspaceId/outcomes';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdOutcomesRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/message-library': {
      id: '/_authenticated/workspaces/$workspaceId/message-library';
      path: '/message-library';
      fullPath: '/workspaces/$workspaceId/message-library';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdMessageLibraryRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys_': {
      id: '/_authenticated/workspaces/$workspaceId/journeys_';
      path: '/journeys';
      fullPath: '/workspaces/$workspaceId/journeys';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/home': {
      id: '/_authenticated/workspaces/$workspaceId/home';
      path: '/home';
      fullPath: '/workspaces/$workspaceId/home';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/health': {
      id: '/_authenticated/workspaces/$workspaceId/health';
      path: '/health';
      fullPath: '/workspaces/$workspaceId/health';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdHealthRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/geosets': {
      id: '/_authenticated/workspaces/$workspaceId/geosets';
      path: '/geosets';
      fullPath: '/workspaces/$workspaceId/geosets';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/exports': {
      id: '/_authenticated/workspaces/$workspaceId/exports';
      path: '/exports';
      fullPath: '/workspaces/$workspaceId/exports';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdExportsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/experiments': {
      id: '/_authenticated/workspaces/$workspaceId/experiments';
      path: '/experiments';
      fullPath: '/workspaces/$workspaceId/experiments';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdExperimentsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/design-studio': {
      id: '/_authenticated/workspaces/$workspaceId/design-studio';
      path: '/design-studio';
      fullPath: '/workspaces/$workspaceId/design-studio';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/assets': {
      id: '/_authenticated/workspaces/$workspaceId/assets';
      path: '/assets';
      fullPath: '/workspaces/$workspaceId/assets';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAssetsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/agent': {
      id: '/_authenticated/workspaces/$workspaceId/agent';
      path: '/agent';
      fullPath: '/workspaces/$workspaceId/agent';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/$': {
      id: '/_authenticated/workspaces/$workspaceId/$';
      path: '/$';
      fullPath: '/workspaces/$workspaceId/$';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSplatRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/settings/workspaces/new': {
      id: '/_authenticated/settings/workspaces/new';
      path: '/settings/workspaces/new';
      fullPath: '/settings/workspaces/new';
      preLoaderRoute: typeof AuthenticatedSettingsWorkspacesNewRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/team/invite-guest': {
      id: '/_authenticated/settings/team/invite-guest';
      path: '/settings/team/invite-guest';
      fullPath: '/settings/team/invite-guest';
      preLoaderRoute: typeof AuthenticatedSettingsTeamInviteGuestRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/team/add': {
      id: '/_authenticated/settings/team/add';
      path: '/settings/team/add';
      fullPath: '/settings/team/add';
      preLoaderRoute: typeof AuthenticatedSettingsTeamAddRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/slack-agent_/link': {
      id: '/_authenticated/settings/slack-agent_/link';
      path: '/settings/slack-agent/link';
      fullPath: '/settings/slack-agent/link';
      preLoaderRoute: typeof AuthenticatedSettingsSlackAgentLinkRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/security/sso': {
      id: '/_authenticated/settings/security/sso';
      path: '/settings/security/sso';
      fullPath: '/settings/security/sso';
      preLoaderRoute: typeof AuthenticatedSettingsSecuritySsoRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/roles/new': {
      id: '/_authenticated/settings/roles/new';
      path: '/settings/roles/new';
      fullPath: '/settings/roles/new';
      preLoaderRoute: typeof AuthenticatedSettingsRolesNewRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/roles/$roleId': {
      id: '/_authenticated/settings/roles/$roleId';
      path: '/settings/roles/$roleId';
      fullPath: '/settings/roles/$roleId';
      preLoaderRoute: typeof AuthenticatedSettingsRolesRoleIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/personal/google-identities': {
      id: '/_authenticated/settings/personal/google-identities';
      path: '/settings/personal/google-identities';
      fullPath: '/settings/personal/google-identities';
      preLoaderRoute: typeof AuthenticatedSettingsPersonalGoogleIdentitiesRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/partner/create': {
      id: '/_authenticated/settings/partner/create';
      path: '/create';
      fullPath: '/settings/partner/create';
      preLoaderRoute: typeof AuthenticatedSettingsPartnerCreateRouteImport;
      parentRoute: typeof AuthenticatedSettingsPartnerRoute;
    };
    '/_authenticated/settings/billing/your-plan': {
      id: '/_authenticated/settings/billing/your-plan';
      path: '/your-plan';
      fullPath: '/settings/billing/your-plan';
      preLoaderRoute: typeof AuthenticatedSettingsBillingYourPlanRouteImport;
      parentRoute: typeof AuthenticatedSettingsBillingRoute;
    };
    '/_authenticated/settings/billing/usage': {
      id: '/_authenticated/settings/billing/usage';
      path: '/usage';
      fullPath: '/settings/billing/usage';
      preLoaderRoute: typeof AuthenticatedSettingsBillingUsageRouteImport;
      parentRoute: typeof AuthenticatedSettingsBillingRoute;
    };
    '/_authenticated/settings/billing/profile-growth': {
      id: '/_authenticated/settings/billing/profile-growth';
      path: '/profile-growth';
      fullPath: '/settings/billing/profile-growth';
      preLoaderRoute: typeof AuthenticatedSettingsBillingProfileGrowthRouteImport;
      parentRoute: typeof AuthenticatedSettingsBillingRoute;
    };
    '/_authenticated/settings/billing/payment-methods': {
      id: '/_authenticated/settings/billing/payment-methods';
      path: '/payment-methods';
      fullPath: '/settings/billing/payment-methods';
      preLoaderRoute: typeof AuthenticatedSettingsBillingPaymentMethodsRouteImport;
      parentRoute: typeof AuthenticatedSettingsBillingRoute;
    };
    '/_authenticated/settings/billing/overview': {
      id: '/_authenticated/settings/billing/overview';
      path: '/overview';
      fullPath: '/settings/billing/overview';
      preLoaderRoute: typeof AuthenticatedSettingsBillingOverviewRouteImport;
      parentRoute: typeof AuthenticatedSettingsBillingRoute;
    };
    '/_authenticated/settings/billing/llm-usage': {
      id: '/_authenticated/settings/billing/llm-usage';
      path: '/llm-usage';
      fullPath: '/settings/billing/llm-usage';
      preLoaderRoute: typeof AuthenticatedSettingsBillingLlmUsageRouteImport;
      parentRoute: typeof AuthenticatedSettingsBillingRoute;
    };
    '/_authenticated/settings/billing/inbox-preview-usage': {
      id: '/_authenticated/settings/billing/inbox-preview-usage';
      path: '/inbox-preview-usage';
      fullPath: '/settings/billing/inbox-preview-usage';
      preLoaderRoute: typeof AuthenticatedSettingsBillingInboxPreviewUsageRouteImport;
      parentRoute: typeof AuthenticatedSettingsBillingRoute;
    };
    '/_authenticated/settings/billing/checkout': {
      id: '/_authenticated/settings/billing/checkout';
      path: '/checkout';
      fullPath: '/settings/billing/checkout';
      preLoaderRoute: typeof AuthenticatedSettingsBillingCheckoutRouteImport;
      parentRoute: typeof AuthenticatedSettingsBillingRoute;
    };
    '/_authenticated/settings/billing/billing-history': {
      id: '/_authenticated/settings/billing/billing-history';
      path: '/billing-history';
      fullPath: '/settings/billing/billing-history';
      preLoaderRoute: typeof AuthenticatedSettingsBillingBillingHistoryRouteImport;
      parentRoute: typeof AuthenticatedSettingsBillingRoute;
    };
    '/_authenticated/settings/billing/billing-details': {
      id: '/_authenticated/settings/billing/billing-details';
      path: '/billing-details';
      fullPath: '/settings/billing/billing-details';
      preLoaderRoute: typeof AuthenticatedSettingsBillingBillingDetailsRouteImport;
      parentRoute: typeof AuthenticatedSettingsBillingRoute;
    };
    '/_authenticated/settings/billing/$': {
      id: '/_authenticated/settings/billing/$';
      path: '/$';
      fullPath: '/settings/billing/$';
      preLoaderRoute: typeof AuthenticatedSettingsBillingSplatRouteImport;
      parentRoute: typeof AuthenticatedSettingsBillingRoute;
    };
    '/_authenticated/settings/account/edit': {
      id: '/_authenticated/settings/account/edit';
      path: '/settings/account/edit';
      fullPath: '/settings/account/edit';
      preLoaderRoute: typeof AuthenticatedSettingsAccountEditRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/workspaces/$workspaceId/template/': {
      id: '/_authenticated/workspaces/$workspaceId/template/';
      path: '/template';
      fullPath: '/workspaces/$workspaceId/template/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdTemplateIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/snippets/': {
      id: '/_authenticated/workspaces/$workspaceId/snippets/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/snippets/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSnippetsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSnippetsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/': {
      id: '/_authenticated/workspaces/$workspaceId/settings/';
      path: '/settings';
      fullPath: '/workspaces/$workspaceId/settings/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/profiles/': {
      id: '/_authenticated/workspaces/$workspaceId/profiles/';
      path: '/profiles';
      fullPath: '/workspaces/$workspaceId/profiles/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdProfilesIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/';
      path: '/pipelines';
      fullPath: '/workspaces/$workspaceId/pipelines/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/people/': {
      id: '/_authenticated/workspaces/$workspaceId/people/';
      path: '/people';
      fullPath: '/workspaces/$workspaceId/people/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeopleIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/parcel/': {
      id: '/_authenticated/workspaces/$workspaceId/parcel/';
      path: '/parcel';
      fullPath: '/workspaces/$workspaceId/parcel/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdParcelIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/outcomes/': {
      id: '/_authenticated/workspaces/$workspaceId/outcomes/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/outcomes/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdOutcomesIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdOutcomesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/objects/': {
      id: '/_authenticated/workspaces/$workspaceId/objects/';
      path: '/objects';
      fullPath: '/workspaces/$workspaceId/objects/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/';
      path: '/integrations';
      fullPath: '/workspaces/$workspaceId/integrations/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/imports/': {
      id: '/_authenticated/workspaces/$workspaceId/imports/';
      path: '/imports';
      fullPath: '/workspaces/$workspaceId/imports/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/home/': {
      id: '/_authenticated/workspaces/$workspaceId/home/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/home/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeRoute;
    };
    '/_authenticated/workspaces/$workspaceId/geosets/': {
      id: '/_authenticated/workspaces/$workspaceId/geosets/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/geosets/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/experiments/': {
      id: '/_authenticated/workspaces/$workspaceId/experiments/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/experiments/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdExperimentsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdExperimentsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/design-studio/': {
      id: '/_authenticated/workspaces/$workspaceId/design-studio/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/design-studio/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioRoute;
    };
    '/_authenticated/workspaces/$workspaceId/boards/': {
      id: '/_authenticated/workspaces/$workspaceId/boards/';
      path: '/boards';
      fullPath: '/workspaces/$workspaceId/boards/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBoardsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/agent/': {
      id: '/_authenticated/workspaces/$workspaceId/agent/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/agent/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentRoute;
    };
    '/_authenticated/settings/billing/available-plans/': {
      id: '/_authenticated/settings/billing/available-plans/';
      path: '/available-plans';
      fullPath: '/settings/billing/available-plans/';
      preLoaderRoute: typeof AuthenticatedSettingsBillingAvailablePlansIndexRouteImport;
      parentRoute: typeof AuthenticatedSettingsBillingRoute;
    };
    '/_authenticated/workspaces/$workspaceId/template/$templateId': {
      id: '/_authenticated/workspaces/$workspaceId/template/$templateId';
      path: '/template/$templateId';
      fullPath: '/workspaces/$workspaceId/template/$templateId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdTemplateTemplateIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/snippets/new': {
      id: '/_authenticated/workspaces/$workspaceId/snippets/new';
      path: '/new';
      fullPath: '/workspaces/$workspaceId/snippets/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSnippetsNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSnippetsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/snippets/$snippetId': {
      id: '/_authenticated/workspaces/$workspaceId/snippets/$snippetId';
      path: '/$snippetId';
      fullPath: '/workspaces/$workspaceId/snippets/$snippetId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSnippetsSnippetIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSnippetsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/suppressions': {
      id: '/_authenticated/workspaces/$workspaceId/settings/suppressions';
      path: '/settings/suppressions';
      fullPath: '/workspaces/$workspaceId/settings/suppressions';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSuppressionsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/subscription_center': {
      id: '/_authenticated/workspaces/$workspaceId/settings/subscription_center';
      path: '/settings/subscription_center';
      fullPath: '/workspaces/$workspaceId/settings/subscription_center';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/merge_options': {
      id: '/_authenticated/workspaces/$workspaceId/settings/merge_options';
      path: '/settings/merge_options';
      fullPath: '/workspaces/$workspaceId/settings/merge_options';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsMerge_optionsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/llm_configuration': {
      id: '/_authenticated/workspaces/$workspaceId/settings/llm_configuration';
      path: '/settings/llm_configuration';
      fullPath: '/workspaces/$workspaceId/settings/llm_configuration';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/language': {
      id: '/_authenticated/workspaces/$workspaceId/settings/language';
      path: '/settings/language';
      fullPath: '/workspaces/$workspaceId/settings/language';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsLanguageRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/geofences': {
      id: '/_authenticated/workspaces/$workspaceId/settings/geofences';
      path: '/settings/geofences';
      fullPath: '/workspaces/$workspaceId/settings/geofences';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsGeofencesRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/edit': {
      id: '/_authenticated/workspaces/$workspaceId/settings/edit';
      path: '/settings/edit';
      fullPath: '/workspaces/$workspaceId/settings/edit';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsEditRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/confirm_delete': {
      id: '/_authenticated/workspaces/$workspaceId/settings/confirm_delete';
      path: '/settings/confirm_delete';
      fullPath: '/workspaces/$workspaceId/settings/confirm_delete';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsConfirm_deleteRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/auto_archive': {
      id: '/_authenticated/workspaces/$workspaceId/settings/auto_archive';
      path: '/settings/auto_archive';
      fullPath: '/workspaces/$workspaceId/settings/auto_archive';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsAuto_archiveRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/audit-logs': {
      id: '/_authenticated/workspaces/$workspaceId/settings/audit-logs';
      path: '/settings/audit-logs';
      fullPath: '/workspaces/$workspaceId/settings/audit-logs';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsAuditLogsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/api-keys': {
      id: '/_authenticated/workspaces/$workspaceId/settings/api-keys';
      path: '/settings/api-keys';
      fullPath: '/workspaces/$workspaceId/settings/api-keys';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsApiKeysRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/anonymous_events': {
      id: '/_authenticated/workspaces/$workspaceId/settings/anonymous_events';
      path: '/settings/anonymous_events';
      fullPath: '/workspaces/$workspaceId/settings/anonymous_events';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsAnonymous_eventsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/ai-business-profile': {
      id: '/_authenticated/workspaces/$workspaceId/settings/ai-business-profile';
      path: '/settings/ai-business-profile';
      fullPath: '/workspaces/$workspaceId/settings/ai-business-profile';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsAiBusinessProfileRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/$': {
      id: '/_authenticated/workspaces/$workspaceId/settings/$';
      path: '/settings/$';
      fullPath: '/workspaces/$workspaceId/settings/$';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSplatRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/reports/email-clients': {
      id: '/_authenticated/workspaces/$workspaceId/reports/email-clients';
      path: '/reports/email-clients';
      fullPath: '/workspaces/$workspaceId/reports/email-clients';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdReportsEmailClientsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/reports/deliverability': {
      id: '/_authenticated/workspaces/$workspaceId/reports/deliverability';
      path: '/reports/deliverability';
      fullPath: '/workspaces/$workspaceId/reports/deliverability';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdReportsDeliverabilityRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/profiles/welcome': {
      id: '/_authenticated/workspaces/$workspaceId/profiles/welcome';
      path: '/profiles/welcome';
      fullPath: '/workspaces/$workspaceId/profiles/welcome';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdProfilesWelcomeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/profiles/new': {
      id: '/_authenticated/workspaces/$workspaceId/profiles/new';
      path: '/profiles/new';
      fullPath: '/workspaces/$workspaceId/profiles/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdProfilesNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/profiles/merge': {
      id: '/_authenticated/workspaces/$workspaceId/profiles/merge';
      path: '/profiles/merge';
      fullPath: '/workspaces/$workspaceId/profiles/merge';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdProfilesMergeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/profiles/create': {
      id: '/_authenticated/workspaces/$workspaceId/profiles/create';
      path: '/profiles/create';
      fullPath: '/workspaces/$workspaceId/profiles/create';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdProfilesCreateRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/people/welcome': {
      id: '/_authenticated/workspaces/$workspaceId/people/welcome';
      path: '/people/welcome';
      fullPath: '/workspaces/$workspaceId/people/welcome';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeopleWelcomeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/people/new': {
      id: '/_authenticated/workspaces/$workspaceId/people/new';
      path: '/people/new';
      fullPath: '/workspaces/$workspaceId/people/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeopleNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/people/merge': {
      id: '/_authenticated/workspaces/$workspaceId/people/merge';
      path: '/people/merge';
      fullPath: '/workspaces/$workspaceId/people/merge';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeopleMergeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/people/create': {
      id: '/_authenticated/workspaces/$workspaceId/people/create';
      path: '/people/create';
      fullPath: '/workspaces/$workspaceId/people/create';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeopleCreateRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/parcel/$': {
      id: '/_authenticated/workspaces/$workspaceId/parcel/$';
      path: '/parcel/$';
      fullPath: '/workspaces/$workspaceId/parcel/$';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdParcelSplatRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/outcomes/$goalId': {
      id: '/_authenticated/workspaces/$workspaceId/outcomes/$goalId';
      path: '/$goalId';
      fullPath: '/workspaces/$workspaceId/outcomes/$goalId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdOutcomesGoalIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdOutcomesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/tasks': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/tasks';
      path: '/journeys/tasks';
      fullPath: '/workspaces/$workspaceId/journeys/tasks';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTasksRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/snippets': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/snippets';
      path: '/journeys/snippets';
      fullPath: '/workspaces/$workspaceId/journeys/snippets';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/settings': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/settings';
      path: '/journeys/settings';
      fullPath: '/workspaces/$workspaceId/journeys/settings';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/message-library': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/message-library';
      path: '/journeys/message-library';
      fullPath: '/workspaces/$workspaceId/journeys/message-library';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysMessageLibraryRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/geofences': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/geofences';
      path: '/journeys/geofences';
      fullPath: '/workspaces/$workspaceId/journeys/geofences';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/exports': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/exports';
      path: '/journeys/exports';
      fullPath: '/workspaces/$workspaceId/journeys/exports';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysExportsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/drafts': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/drafts';
      path: '/journeys/drafts';
      fullPath: '/workspaces/$workspaceId/journeys/drafts';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysDraftsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/deliveries': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/deliveries';
      path: '/journeys/deliveries';
      fullPath: '/workspaces/$workspaceId/journeys/deliveries';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysDeliveriesRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/collections': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/collections';
      path: '/journeys/collections';
      fullPath: '/workspaces/$workspaceId/journeys/collections';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/assets': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/assets';
      path: '/journeys/assets';
      fullPath: '/workspaces/$workspaceId/journeys/assets';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAssetsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/$': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/$';
      path: '/journeys/$';
      fullPath: '/workspaces/$workspaceId/journeys/$';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSplatRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/segment_out': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/segment_out';
      path: '/integrations/segment_out';
      fullPath: '/workspaces/$workspaceId/integrations/segment_out';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_outRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/segment_in': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/segment_in';
      path: '/integrations/segment_in';
      fullPath: '/workspaces/$workspaceId/integrations/segment_in';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_inRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/mparticle_out': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/mparticle_out';
      path: '/integrations/mparticle_out';
      fullPath: '/workspaces/$workspaceId/integrations/mparticle_out';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsMparticle_outRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/customerio': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/customerio';
      path: '/integrations/customerio';
      fullPath: '/workspaces/$workspaceId/integrations/customerio';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsCustomerioRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/cdp_out': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/cdp_out';
      path: '/integrations/cdp_out';
      fullPath: '/workspaces/$workspaceId/integrations/cdp_out';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_outRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/cdp_in': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/cdp_in';
      path: '/integrations/cdp_in';
      fullPath: '/workspaces/$workspaceId/integrations/cdp_in';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_inRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/all': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/all';
      path: '/integrations/all';
      fullPath: '/workspaces/$workspaceId/integrations/all';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/$type': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/$type';
      path: '/integrations/$type';
      fullPath: '/workspaces/$workspaceId/integrations/$type';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsTypeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/imports/new': {
      id: '/_authenticated/workspaces/$workspaceId/imports/new';
      path: '/imports/new';
      fullPath: '/workspaces/$workspaceId/imports/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/home/workspace-setup': {
      id: '/_authenticated/workspaces/$workspaceId/home/workspace-setup';
      path: '/workspace-setup';
      fullPath: '/workspaces/$workspaceId/home/workspace-setup';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeRoute;
    };
    '/_authenticated/workspaces/$workspaceId/home/add-people': {
      id: '/_authenticated/workspaces/$workspaceId/home/add-people';
      path: '/add-people';
      fullPath: '/workspaces/$workspaceId/home/add-people';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeAddPeopleRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeRoute;
    };
    '/_authenticated/workspaces/$workspaceId/geosets/new': {
      id: '/_authenticated/workspaces/$workspaceId/geosets/new';
      path: '/new';
      fullPath: '/workspaces/$workspaceId/geosets/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/geosets/import': {
      id: '/_authenticated/workspaces/$workspaceId/geosets/import';
      path: '/import';
      fullPath: '/workspaces/$workspaceId/geosets/import';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsImportRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/geosets/$geosetId': {
      id: '/_authenticated/workspaces/$workspaceId/geosets/$geosetId';
      path: '/$geosetId';
      fullPath: '/workspaces/$workspaceId/geosets/$geosetId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/experiments/new': {
      id: '/_authenticated/workspaces/$workspaceId/experiments/new';
      path: '/new';
      fullPath: '/workspaces/$workspaceId/experiments/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdExperimentsNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdExperimentsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/experiments/$experimentId': {
      id: '/_authenticated/workspaces/$workspaceId/experiments/$experimentId';
      path: '/$experimentId';
      fullPath: '/workspaces/$workspaceId/experiments/$experimentId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdExperimentsExperimentIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdExperimentsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/dev/condition-viewer': {
      id: '/_authenticated/workspaces/$workspaceId/dev/condition-viewer';
      path: '/dev/condition-viewer';
      fullPath: '/workspaces/$workspaceId/dev/condition-viewer';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDevConditionViewerRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/design-studio_/global-styles': {
      id: '/_authenticated/workspaces/$workspaceId/design-studio_/global-styles';
      path: '/design-studio/global-styles';
      fullPath: '/workspaces/$workspaceId/design-studio/global-styles';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioGlobalStylesRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/design-studio_/dashboard': {
      id: '/_authenticated/workspaces/$workspaceId/design-studio_/dashboard';
      path: '/design-studio/dashboard';
      fullPath: '/workspaces/$workspaceId/design-studio/dashboard';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioDashboardRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/design-studio/$': {
      id: '/_authenticated/workspaces/$workspaceId/design-studio/$';
      path: '/$';
      fullPath: '/workspaces/$workspaceId/design-studio/$';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioSplatRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioRoute;
    };
    '/_authenticated/workspaces/$workspaceId/boards/$boardId': {
      id: '/_authenticated/workspaces/$workspaceId/boards/$boardId';
      path: '/boards/$boardId';
      fullPath: '/workspaces/$workspaceId/boards/$boardId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdBoardsBoardIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/analysis/email-clients': {
      id: '/_authenticated/workspaces/$workspaceId/analysis/email-clients';
      path: '/analysis/email-clients';
      fullPath: '/workspaces/$workspaceId/analysis/email-clients';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAnalysisEmailClientsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/analysis/deliverability': {
      id: '/_authenticated/workspaces/$workspaceId/analysis/deliverability';
      path: '/analysis/deliverability';
      fullPath: '/workspaces/$workspaceId/analysis/deliverability';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAnalysisDeliverabilityRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/agent/skills': {
      id: '/_authenticated/workspaces/$workspaceId/agent/skills';
      path: '/skills';
      fullPath: '/workspaces/$workspaceId/agent/skills';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentRoute;
    };
    '/_authenticated/workspaces/$workspaceId/agent/routines': {
      id: '/_authenticated/workspaces/$workspaceId/agent/routines';
      path: '/routines';
      fullPath: '/workspaces/$workspaceId/agent/routines';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentRoutinesRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentRoute;
    };
    '/_authenticated/settings/team/join-requests/$requestId': {
      id: '/_authenticated/settings/team/join-requests/$requestId';
      path: '/settings/team/join-requests/$requestId';
      fullPath: '/settings/team/join-requests/$requestId';
      preLoaderRoute: typeof AuthenticatedSettingsTeamJoinRequestsRequestIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/settings/billing/available-plans/journeys': {
      id: '/_authenticated/settings/billing/available-plans/journeys';
      path: '/available-plans/journeys';
      fullPath: '/settings/billing/available-plans/journeys';
      preLoaderRoute: typeof AuthenticatedSettingsBillingAvailablePlansJourneysRouteImport;
      parentRoute: typeof AuthenticatedSettingsBillingRoute;
    };
    '/_authenticated/settings/api_credentials/service_accounts/$serviceAccountId': {
      id: '/_authenticated/settings/api_credentials/service_accounts/$serviceAccountId';
      path: '/settings/api_credentials/service_accounts/$serviceAccountId';
      fullPath: '/settings/api_credentials/service_accounts/$serviceAccountId';
      preLoaderRoute: typeof AuthenticatedSettingsApi_credentialsService_accountsServiceAccountIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/webhook_configuration/': {
      id: '/_authenticated/workspaces/$workspaceId/settings/webhook_configuration/';
      path: '/settings/webhook_configuration';
      fullPath: '/workspaces/$workspaceId/settings/webhook_configuration/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/subscription_center/': {
      id: '/_authenticated/workspaces/$workspaceId/settings/subscription_center/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/settings/subscription_center/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/objects/': {
      id: '/_authenticated/workspaces/$workspaceId/settings/objects/';
      path: '/settings/objects';
      fullPath: '/workspaces/$workspaceId/settings/objects/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsObjectsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/llm_configuration/': {
      id: '/_authenticated/workspaces/$workspaceId/settings/llm_configuration/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/settings/llm_configuration/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/api_credentials/': {
      id: '/_authenticated/workspaces/$workspaceId/settings/api_credentials/';
      path: '/settings/api_credentials';
      fullPath: '/workspaces/$workspaceId/settings/api_credentials/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/';
      path: '/pipelines/sources';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/';
      path: '/pipelines/destinations';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/objects/$slug/': {
      id: '/_authenticated/workspaces/$workspaceId/objects/$slug/';
      path: '/objects/$slug';
      fullPath: '/workspaces/$workspaceId/objects/$slug/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/triggered/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/triggered/';
      path: '/journeys/triggered';
      fullPath: '/workspaces/$workspaceId/journeys/triggered/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/template/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/template/';
      path: '/journeys/template';
      fullPath: '/workspaces/$workspaceId/journeys/template/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTemplateIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/snippets/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/snippets/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/journeys/snippets/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/profiles/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/profiles/';
      path: '/journeys/profiles';
      fullPath: '/workspaces/$workspaceId/journeys/profiles/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/profile_activity/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/profile_activity/';
      path: '/journeys/profile_activity';
      fullPath: '/workspaces/$workspaceId/journeys/profile_activity/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/people/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/people/';
      path: '/journeys/people';
      fullPath: '/workspaces/$workspaceId/journeys/people/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/objects/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/objects/';
      path: '/journeys/objects';
      fullPath: '/workspaces/$workspaceId/journeys/objects/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/layouts/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/layouts/';
      path: '/journeys/layouts';
      fullPath: '/workspaces/$workspaceId/journeys/layouts/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/';
      path: '/journeys/integrations';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/imports/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/imports/';
      path: '/journeys/imports';
      fullPath: '/workspaces/$workspaceId/journeys/imports/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/geofences/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/geofences/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/journeys/geofences/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/collections/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/collections/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/journeys/collections/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/activity_logs/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/activity_logs/';
      path: '/journeys/activity_logs';
      fullPath: '/workspaces/$workspaceId/journeys/activity_logs/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/reporting-webhooks/': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/reporting-webhooks/';
      path: '/integrations/reporting-webhooks';
      fullPath: '/workspaces/$workspaceId/integrations/reporting-webhooks/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/all/': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/all/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/integrations/all/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRoute;
    };
    '/_authenticated/workspaces/$workspaceId/imports/$importId/': {
      id: '/_authenticated/workspaces/$workspaceId/imports/$importId/';
      path: '/imports/$importId';
      fullPath: '/workspaces/$workspaceId/imports/$importId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/home/workspace-setup/': {
      id: '/_authenticated/workspaces/$workspaceId/home/workspace-setup/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/home/workspace-setup/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRoute;
    };
    '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/': {
      id: '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/geosets/$geosetId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/agent/skills/': {
      id: '/_authenticated/workspaces/$workspaceId/agent/skills/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/agent/skills/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/webhook_configuration/new': {
      id: '/_authenticated/workspaces/$workspaceId/settings/webhook_configuration/new';
      path: '/settings/webhook_configuration/new';
      fullPath: '/workspaces/$workspaceId/settings/webhook_configuration/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/subscription_center/settings': {
      id: '/_authenticated/workspaces/$workspaceId/settings/subscription_center/settings';
      path: '/settings';
      fullPath: '/workspaces/$workspaceId/settings/subscription_center/settings';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerSettingsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/objects/new': {
      id: '/_authenticated/workspaces/$workspaceId/settings/objects/new';
      path: '/settings/objects/new';
      fullPath: '/workspaces/$workspaceId/settings/objects/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsObjectsNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/llm_configuration/new': {
      id: '/_authenticated/workspaces/$workspaceId/settings/llm_configuration/new';
      path: '/new';
      fullPath: '/workspaces/$workspaceId/settings/llm_configuration/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/url_params': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/url_params';
      path: '/settings/actions/url_params';
      fullPath: '/workspaces/$workspaceId/settings/actions/url_params';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/urban_airship': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/urban_airship';
      path: '/settings/actions/urban_airship';
      fullPath: '/workspaces/$workspaceId/settings/actions/urban_airship';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrban_airshipRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/time_zone_match': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/time_zone_match';
      path: '/settings/actions/time_zone_match';
      fullPath: '/workspaces/$workspaceId/settings/actions/time_zone_match';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsTime_zone_matchRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/sms-providers': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/sms-providers';
      path: '/settings/actions/sms-providers';
      fullPath: '/workspaces/$workspaceId/settings/actions/sms-providers';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/slack': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/slack';
      path: '/settings/actions/slack';
      fullPath: '/workspaces/$workspaceId/settings/actions/slack';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSlackRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/messaging_limit': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/messaging_limit';
      path: '/settings/actions/messaging_limit';
      fullPath: '/workspaces/$workspaceId/settings/actions/messaging_limit';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessaging_limitRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/message_frequency_limits': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/message_frequency_limits';
      path: '/settings/actions/message_frequency_limits';
      fullPath: '/workspaces/$workspaceId/settings/actions/message_frequency_limits';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessage_frequency_limitsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/line': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/line';
      path: '/settings/actions/line';
      fullPath: '/workspaces/$workspaceId/settings/actions/line';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsLineRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/email': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/email';
      path: '/settings/actions/email';
      fullPath: '/workspaces/$workspaceId/settings/actions/email';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/journeys': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/journeys';
      path: '/pipelines/sources/journeys';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/journeys';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesJourneysRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/add': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/add';
      path: '/pipelines/sources/add';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/add';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId';
      path: '/pipelines/sources/$sourceId';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/$sourceId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/journeys': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/journeys';
      path: '/pipelines/destinations/journeys';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/journeys';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsJourneysRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/add': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/add';
      path: '/pipelines/destinations/add';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/add';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId';
      path: '/pipelines/destinations/$destinationId';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/$destinationId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/objects/$slug/new': {
      id: '/_authenticated/workspaces/$workspaceId/objects/$slug/new';
      path: '/objects/$slug/new';
      fullPath: '/workspaces/$workspaceId/objects/$slug/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/objects/$slug/guide': {
      id: '/_authenticated/workspaces/$workspaceId/objects/$slug/guide';
      path: '/objects/$slug/guide';
      fullPath: '/workspaces/$workspaceId/objects/$slug/guide';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugGuideRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId': {
      id: '/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId';
      path: '/objects/$slug/$objectId';
      fullPath: '/workspaces/$workspaceId/objects/$slug/$objectId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/v2/$': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/v2/$';
      path: '/journeys/v2/$';
      fullPath: '/workspaces/$workspaceId/journeys/v2/$';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysV2SplatRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/triggered/new': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/triggered/new';
      path: '/journeys/triggered/new';
      fullPath: '/workspaces/$workspaceId/journeys/triggered/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/template/$templateId': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/template/$templateId';
      path: '/journeys/template/$templateId';
      fullPath: '/workspaces/$workspaceId/journeys/template/$templateId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTemplateTemplateIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/snippets/new': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/snippets/new';
      path: '/new';
      fullPath: '/workspaces/$workspaceId/journeys/snippets/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/snippets/$snippetId': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/snippets/$snippetId';
      path: '/$snippetId';
      fullPath: '/workspaces/$workspaceId/journeys/snippets/$snippetId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsSnippetIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/setup-guide/$': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/setup-guide/$';
      path: '/journeys/setup-guide/$';
      fullPath: '/workspaces/$workspaceId/journeys/setup-guide/$';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSetupGuideSplatRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/settings/$': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/settings/$';
      path: '/$';
      fullPath: '/workspaces/$workspaceId/journeys/settings/$';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSettingsSplatRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/profiles/welcome': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/profiles/welcome';
      path: '/journeys/profiles/welcome';
      fullPath: '/workspaces/$workspaceId/journeys/profiles/welcome';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesWelcomeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/profiles/new': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/profiles/new';
      path: '/journeys/profiles/new';
      fullPath: '/workspaces/$workspaceId/journeys/profiles/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/profiles/merge': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/profiles/merge';
      path: '/journeys/profiles/merge';
      fullPath: '/workspaces/$workspaceId/journeys/profiles/merge';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesMergeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/profiles/create': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/profiles/create';
      path: '/journeys/profiles/create';
      fullPath: '/workspaces/$workspaceId/journeys/profiles/create';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesCreateRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/profile_activity/$tab': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/profile_activity/$tab';
      path: '/journeys/profile_activity/$tab';
      fullPath: '/workspaces/$workspaceId/journeys/profile_activity/$tab';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityTabRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/people/welcome': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/people/welcome';
      path: '/journeys/people/welcome';
      fullPath: '/workspaces/$workspaceId/journeys/people/welcome';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleWelcomeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/people/new': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/people/new';
      path: '/journeys/people/new';
      fullPath: '/workspaces/$workspaceId/journeys/people/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/people/merge': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/people/merge';
      path: '/journeys/people/merge';
      fullPath: '/workspaces/$workspaceId/journeys/people/merge';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleMergeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/people/create': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/people/create';
      path: '/journeys/people/create';
      fullPath: '/workspaces/$workspaceId/journeys/people/create';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleCreateRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/outbox/$': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/outbox/$';
      path: '/journeys/outbox/$';
      fullPath: '/workspaces/$workspaceId/journeys/outbox/$';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysOutboxSplatRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/message_activity/$': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/message_activity/$';
      path: '/journeys/message_activity/$';
      fullPath: '/workspaces/$workspaceId/journeys/message_activity/$';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysMessage_activitySplatRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/layouts/starters': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/layouts/starters';
      path: '/journeys/layouts/starters';
      fullPath: '/workspaces/$workspaceId/journeys/layouts/starters';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsStartersRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/layouts/new': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/layouts/new';
      path: '/journeys/layouts/new';
      fullPath: '/workspaces/$workspaceId/journeys/layouts/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/segment_out': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/segment_out';
      path: '/journeys/integrations/segment_out';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/segment_out';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_outRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/segment_in': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/segment_in';
      path: '/journeys/integrations/segment_in';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/segment_in';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_inRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks';
      path: '/journeys/integrations/reporting-webhooks';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/mparticle_out': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/mparticle_out';
      path: '/journeys/integrations/mparticle_out';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/mparticle_out';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsMparticle_outRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/customerio': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/customerio';
      path: '/journeys/integrations/customerio';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/customerio';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCustomerioRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/cdp_out': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/cdp_out';
      path: '/journeys/integrations/cdp_out';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/cdp_out';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_outRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/cdp_in': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/cdp_in';
      path: '/journeys/integrations/cdp_in';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/cdp_in';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_inRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/all': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/all';
      path: '/journeys/integrations/all';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/all';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/$type': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/$type';
      path: '/journeys/integrations/$type';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/$type';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsTypeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/imports/new': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/imports/new';
      path: '/journeys/imports/new';
      fullPath: '/workspaces/$workspaceId/journeys/imports/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/geofences/new': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/geofences/new';
      path: '/new';
      fullPath: '/workspaces/$workspaceId/journeys/geofences/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/geofences/$geofenceId': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/geofences/$geofenceId';
      path: '/$geofenceId';
      fullPath: '/workspaces/$workspaceId/journeys/geofences/$geofenceId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesGeofenceIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId';
      path: '/$collectionId';
      fullPath: '/workspaces/$workspaceId/journeys/collections/$collectionId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/analysis/deliverability': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/analysis/deliverability';
      path: '/journeys/analysis/deliverability';
      fullPath: '/workspaces/$workspaceId/journeys/analysis/deliverability';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisDeliverabilityRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/activity_logs/$tab': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/activity_logs/$tab';
      path: '/journeys/activity_logs/$tab';
      fullPath: '/workspaces/$workspaceId/journeys/activity_logs/$tab';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsTabRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/warehouse/snowflake': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/warehouse/snowflake';
      path: '/integrations/warehouse/snowflake';
      fullPath: '/workspaces/$workspaceId/integrations/warehouse/snowflake';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseSnowflakeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/warehouse/redshift': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/warehouse/redshift';
      path: '/integrations/warehouse/redshift';
      fullPath: '/workspaces/$workspaceId/integrations/warehouse/redshift';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseRedshiftRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/warehouse/bigquery': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/warehouse/bigquery';
      path: '/integrations/warehouse/bigquery';
      fullPath: '/workspaces/$workspaceId/integrations/warehouse/bigquery';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseBigqueryRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/warehouse/$type': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/warehouse/$type';
      path: '/integrations/warehouse/$type';
      fullPath: '/workspaces/$workspaceId/integrations/warehouse/$type';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type';
      path: '/integrations/sql-sync/$type';
      fullPath: '/workspaces/$workspaceId/integrations/sql-sync/$type';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/reporting-webhooks/new': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/reporting-webhooks/new';
      path: '/integrations/reporting-webhooks/new';
      fullPath: '/workspaces/$workspaceId/integrations/reporting-webhooks/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/reporting-webhooks/$webhookId': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/reporting-webhooks/$webhookId';
      path: '/integrations/reporting-webhooks/$webhookId';
      fullPath: '/workspaces/$workspaceId/integrations/reporting-webhooks/$webhookId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksWebhookIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/data_out/$type': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/data_out/$type';
      path: '/integrations/data_out/$type';
      fullPath: '/workspaces/$workspaceId/integrations/data_out/$type';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsData_outTypeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/all/webhooks': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/all/webhooks';
      path: '/webhooks';
      fullPath: '/workspaces/$workspaceId/integrations/all/webhooks';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllWebhooksRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/all/overview': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/all/overview';
      path: '/overview';
      fullPath: '/workspaces/$workspaceId/integrations/all/overview';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllOverviewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/all/directory': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/all/directory';
      path: '/directory';
      fullPath: '/workspaces/$workspaceId/integrations/all/directory';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDirectoryRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/all/developers': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/all/developers';
      path: '/developers';
      fullPath: '/workspaces/$workspaceId/integrations/all/developers';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDevelopersRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRoute;
    };
    '/_authenticated/workspaces/$workspaceId/home/workspace-setup/add-people': {
      id: '/_authenticated/workspaces/$workspaceId/home/workspace-setup/add-people';
      path: '/add-people';
      fullPath: '/workspaces/$workspaceId/home/workspace-setup/add-people';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupAddPeopleRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRoute;
    };
    '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences': {
      id: '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences';
      path: '/geofences';
      fullPath: '/workspaces/$workspaceId/geosets/$geosetId/geofences';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/edit': {
      id: '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/edit';
      path: '/edit';
      fullPath: '/workspaces/$workspaceId/geosets/$geosetId/edit';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdEditRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/dev/db/campaigns': {
      id: '/_authenticated/workspaces/$workspaceId/dev/db/campaigns';
      path: '/dev/db/campaigns';
      fullPath: '/workspaces/$workspaceId/dev/db/campaigns';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/automations/$campaignId/workflow': {
      id: '/_authenticated/workspaces/$workspaceId/automations/$campaignId/workflow';
      path: '/automations/$campaignId/workflow';
      fullPath: '/workspaces/$workspaceId/automations/$campaignId/workflow';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdWorkflowRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/agent/skills/new': {
      id: '/_authenticated/workspaces/$workspaceId/agent/skills/new';
      path: '/new';
      fullPath: '/workspaces/$workspaceId/agent/skills/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/agent/skills/$skillPath': {
      id: '/_authenticated/workspaces/$workspaceId/agent/skills/$skillPath';
      path: '/$skillPath';
      fullPath: '/workspaces/$workspaceId/agent/skills/$skillPath';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsSkillPathRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsRoute;
    };
    '/_authenticated/settings/team/members/$userId/edit': {
      id: '/_authenticated/settings/team/members/$userId/edit';
      path: '/settings/team/members/$userId/edit';
      fullPath: '/settings/team/members/$userId/edit';
      preLoaderRoute: typeof AuthenticatedSettingsTeamMembersUserIdEditRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/subscription_center/topics/': {
      id: '/_authenticated/workspaces/$workspaceId/settings/subscription_center/topics/';
      path: '/topics';
      fullPath: '/workspaces/$workspaceId/settings/subscription_center/topics/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/url_params/': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/url_params/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/settings/actions/url_params/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/sms-providers/': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/sms-providers/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/settings/actions/sms-providers/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/email/': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/email/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/settings/actions/email/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/$sourceId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/$destinationId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId/': {
      id: '/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/objects/$slug/$objectId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/';
      path: '/journeys/objects/$slug';
      fullPath: '/workspaces/$workspaceId/journeys/objects/$slug/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/layouts/$layoutId/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/layouts/$layoutId/';
      path: '/journeys/layouts/$layoutId';
      fullPath: '/workspaces/$workspaceId/journeys/layouts/$layoutId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/all/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/';
      path: '/journeys/imports/$importId';
      fullPath: '/workspaces/$workspaceId/journeys/imports/$importId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/journeys/collections/$collectionId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/integrations/sql-sync/$type/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRoute;
    };
    '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/': {
      id: '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/';
      path: '/imports/$importId/setup';
      fullPath: '/workspaces/$workspaceId/imports/$importId/setup/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences/': {
      id: '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/geosets/$geosetId/geofences/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/dev/db/campaigns/': {
      id: '/_authenticated/workspaces/$workspaceId/dev/db/campaigns/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/dev/db/campaigns/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/webhook_configuration/$webhookId/edit': {
      id: '/_authenticated/workspaces/$workspaceId/settings/webhook_configuration/$webhookId/edit';
      path: '/settings/webhook_configuration/$webhookId/edit';
      fullPath: '/workspaces/$workspaceId/settings/webhook_configuration/$webhookId/edit';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationWebhookIdEditRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/subscription_center/topics/set_preferences': {
      id: '/_authenticated/workspaces/$workspaceId/settings/subscription_center/topics/set_preferences';
      path: '/topics/set_preferences';
      fullPath: '/workspaces/$workspaceId/settings/subscription_center/topics/set_preferences';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsSet_preferencesRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/subscription_center/localization/edit': {
      id: '/_authenticated/workspaces/$workspaceId/settings/subscription_center/localization/edit';
      path: '/localization/edit';
      fullPath: '/workspaces/$workspaceId/settings/subscription_center/localization/edit';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerLocalizationEditRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/subscription_center/branding/edit': {
      id: '/_authenticated/workspaces/$workspaceId/settings/subscription_center/branding/edit';
      path: '/branding/edit';
      fullPath: '/workspaces/$workspaceId/settings/subscription_center/branding/edit';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerBrandingEditRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/objects/edit/$objectType': {
      id: '/_authenticated/workspaces/$workspaceId/settings/objects/edit/$objectType';
      path: '/settings/objects/edit/$objectType';
      fullPath: '/workspaces/$workspaceId/settings/objects/edit/$objectType';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsObjectsEditObjectTypeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/llm_configuration/$configurationId/edit': {
      id: '/_authenticated/workspaces/$workspaceId/settings/llm_configuration/$configurationId/edit';
      path: '/$configurationId/edit';
      fullPath: '/workspaces/$workspaceId/settings/llm_configuration/$configurationId/edit';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationConfigurationIdEditRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/api_credentials/service_accounts/$serviceAccountId': {
      id: '/_authenticated/workspaces/$workspaceId/settings/api_credentials/service_accounts/$serviceAccountId';
      path: '/settings/api_credentials/service_accounts/$serviceAccountId';
      fullPath: '/workspaces/$workspaceId/settings/api_credentials/service_accounts/$serviceAccountId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsService_accountsServiceAccountIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/url_params/edit': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/url_params/edit';
      path: '/edit';
      fullPath: '/workspaces/$workspaceId/settings/actions/url_params/edit';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsEditRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/email/suppression_list': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/email/suppression_list';
      path: '/suppression_list';
      fullPath: '/workspaces/$workspaceId/settings/actions/email/suppression_list';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSuppression_listRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/email/smtp': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/email/smtp';
      path: '/smtp';
      fullPath: '/workspaces/$workspaceId/settings/actions/email/smtp';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSmtpRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/email/from_addresses': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/email/from_addresses';
      path: '/from_addresses';
      fullPath: '/workspaces/$workspaceId/settings/actions/email/from_addresses';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailFrom_addressesRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/email/dynamic_addresses': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/email/dynamic_addresses';
      path: '/dynamic_addresses';
      fullPath: '/workspaces/$workspaceId/settings/actions/email/dynamic_addresses';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDynamic_addressesRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/email/deliverability': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/email/deliverability';
      path: '/deliverability';
      fullPath: '/workspaces/$workspaceId/settings/actions/email/deliverability';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDeliverabilityRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/email/defaults': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/email/defaults';
      path: '/defaults';
      fullPath: '/workspaces/$workspaceId/settings/actions/email/defaults';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDefaultsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/add_/$sourceOptionId': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/add_/$sourceOptionId';
      path: '/pipelines/sources/add/$sourceOptionId';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/add/$sourceOptionId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddSourceOptionIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs';
      path: '/syncs';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/settings': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/settings';
      path: '/settings';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/$sourceId/settings';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSettingsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/imports': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/imports';
      path: '/imports';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/$sourceId/imports';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdImportsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/databases': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/databases';
      path: '/databases';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/$sourceId/databases';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDatabasesRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/data-in': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/data-in';
      path: '/data-in';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/$sourceId/data-in';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDataInRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/add_/$destinationOptionId': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/add_/$destinationOptionId';
      path: '/pipelines/destinations/add/$destinationOptionId';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/add/$destinationOptionId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddDestinationOptionIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/tester': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/tester';
      path: '/tester';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/$destinationId/tester';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdTesterRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions';
      path: '/subscriptions';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/settings': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/settings';
      path: '/settings';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/$destinationId/settings';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSettingsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/exports': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/exports';
      path: '/exports';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/$destinationId/exports';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdExportsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/data-out': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/data-out';
      path: '/data-out';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/$destinationId/data-out';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdDataOutRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/new': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/new';
      path: '/journeys/objects/$slug/new';
      fullPath: '/workspaces/$workspaceId/journeys/objects/$slug/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/guide': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/guide';
      path: '/journeys/objects/$slug/guide';
      fullPath: '/workspaces/$workspaceId/journeys/objects/$slug/guide';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugGuideRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/layouts/$layoutId/edit': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/layouts/$layoutId/edit';
      path: '/journeys/layouts/$layoutId/edit';
      fullPath: '/workspaces/$workspaceId/journeys/layouts/$layoutId/edit';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdEditRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/snowflake': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/snowflake';
      path: '/journeys/integrations/warehouse/snowflake';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/warehouse/snowflake';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseSnowflakeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/redshift': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/redshift';
      path: '/journeys/integrations/warehouse/redshift';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/warehouse/redshift';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseRedshiftRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/bigquery': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/bigquery';
      path: '/journeys/integrations/warehouse/bigquery';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/warehouse/bigquery';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseBigqueryRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/$type': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/$type';
      path: '/journeys/integrations/warehouse/$type';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/warehouse/$type';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type';
      path: '/journeys/integrations/sql-sync/$type';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/new': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/new';
      path: '/new';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/$webhookId': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/$webhookId';
      path: '/$webhookId';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/$webhookId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksWebhookIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/data_out/$type': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/data_out/$type';
      path: '/journeys/integrations/data_out/$type';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/data_out/$type';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsData_outTypeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/webhooks': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/webhooks';
      path: '/webhooks';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/all/webhooks';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllWebhooksRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/overview': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/overview';
      path: '/overview';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/all/overview';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllOverviewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/directory': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/directory';
      path: '/directory';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/all/directory';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDirectoryRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/developers': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/all/developers';
      path: '/developers';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/all/developers';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDevelopersRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/usage': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/usage';
      path: '/usage';
      fullPath: '/workspaces/$workspaceId/journeys/collections/$collectionId/usage';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdUsageRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/importing': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/importing';
      path: '/importing';
      fullPath: '/workspaces/$workspaceId/journeys/collections/$collectionId/importing';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdImportingRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/data': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/data';
      path: '/data';
      fullPath: '/workspaces/$workspaceId/journeys/collections/$collectionId/data';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdDataRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/$': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/collections/$collectionId/$';
      path: '/$';
      fullPath: '/workspaces/$workspaceId/journeys/collections/$collectionId/$';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdSplatRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/warehouse/$type_/sync': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/warehouse/$type_/sync';
      path: '/integrations/warehouse/$type/sync';
      fullPath: '/workspaces/$workspaceId/integrations/warehouse/$type/sync';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeSyncRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/new': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/new';
      path: '/new';
      fullPath: '/workspaces/$workspaceId/integrations/sql-sync/$type/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId';
      path: '/$sqlImportId';
      fullPath: '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRoute;
    };
    '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/validating': {
      id: '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/validating';
      path: '/imports/$importId/setup/validating';
      fullPath: '/workspaces/$workspaceId/imports/$importId/setup/validating';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupValidatingRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/review': {
      id: '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/review';
      path: '/imports/$importId/setup/review';
      fullPath: '/workspaces/$workspaceId/imports/$importId/setup/review';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupReviewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/preview': {
      id: '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/preview';
      path: '/imports/$importId/setup/preview';
      fullPath: '/workspaces/$workspaceId/imports/$importId/setup/preview';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreviewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/preprocessing': {
      id: '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/preprocessing';
      path: '/imports/$importId/setup/preprocessing';
      fullPath: '/workspaces/$workspaceId/imports/$importId/setup/preprocessing';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreprocessingRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/importing': {
      id: '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/importing';
      path: '/imports/$importId/setup/importing';
      fullPath: '/workspaces/$workspaceId/imports/$importId/setup/importing';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupImportingRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/fields': {
      id: '/_authenticated/workspaces/$workspaceId/imports/$importId/setup/fields';
      path: '/imports/$importId/setup/fields';
      fullPath: '/workspaces/$workspaceId/imports/$importId/setup/fields';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupFieldsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences/new': {
      id: '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences/new';
      path: '/new';
      fullPath: '/workspaces/$workspaceId/geosets/$geosetId/geofences/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences/import': {
      id: '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences/import';
      path: '/import';
      fullPath: '/workspaces/$workspaceId/geosets/$geosetId/geofences/import';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesImportRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences/$geofenceId': {
      id: '/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences/$geofenceId';
      path: '/$geofenceId';
      fullPath: '/workspaces/$workspaceId/geosets/$geosetId/geofences/$geofenceId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesGeofenceIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/email/sending_domains/': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/email/sending_domains/';
      path: '/sending_domains';
      fullPath: '/workspaces/$workspaceId/settings/actions/email/sending_domains/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/$objectId/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/objects/$slug/$objectId/';
      path: '/journeys/objects/$slug/$objectId';
      fullPath: '/workspaces/$workspaceId/journeys/objects/$slug/$objectId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/';
      path: '/journeys/imports/$importId/setup';
      fullPath: '/workspaces/$workspaceId/journeys/imports/$importId/setup/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/';
      path: '/';
      fullPath: '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/sms-providers/credentials/$credentialId': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/sms-providers/credentials/$credentialId';
      path: '/credentials/$credentialId';
      fullPath: '/workspaces/$workspaceId/settings/actions/sms-providers/credentials/$credentialId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersCredentialsCredentialIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRoute;
    };
    '/_authenticated/workspaces/$workspaceId/settings/actions/email/sending_domains/$domainId': {
      id: '/_authenticated/workspaces/$workspaceId/settings/actions/email/sending_domains/$domainId';
      path: '/sending_domains/$domainId';
      fullPath: '/workspaces/$workspaceId/settings/actions/email/sending_domains/$domainId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsDomainIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId_/syncs/add': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId_/syncs/add';
      path: '/pipelines/sources/$sourceId/syncs/add';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs/add';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsAddRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId_/syncs/$syncId': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId_/syncs/$syncId';
      path: '/pipelines/sources/$sourceId/syncs/$syncId';
      fullPath: '/workspaces/$workspaceId/pipelines/sources/$sourceId/syncs/$syncId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsSyncIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/add': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/add';
      path: '/add';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/add';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsAddRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/$subscriptionId': {
      id: '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/$subscriptionId';
      path: '/$subscriptionId';
      fullPath: '/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/$subscriptionId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsSubscriptionIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/$type_/sync': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/warehouse/$type_/sync';
      path: '/journeys/integrations/warehouse/$type/sync';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/warehouse/$type/sync';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeSyncRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/new': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/new';
      path: '/new';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/new';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId';
      path: '/$sqlImportId';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/validating': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/validating';
      path: '/journeys/imports/$importId/setup/validating';
      fullPath: '/workspaces/$workspaceId/journeys/imports/$importId/setup/validating';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupValidatingRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/review': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/review';
      path: '/journeys/imports/$importId/setup/review';
      fullPath: '/workspaces/$workspaceId/journeys/imports/$importId/setup/review';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupReviewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/preview': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/preview';
      path: '/journeys/imports/$importId/setup/preview';
      fullPath: '/workspaces/$workspaceId/journeys/imports/$importId/setup/preview';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreviewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/preprocessing': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/preprocessing';
      path: '/journeys/imports/$importId/setup/preprocessing';
      fullPath: '/workspaces/$workspaceId/journeys/imports/$importId/setup/preprocessing';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreprocessingRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/importing': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/importing';
      path: '/journeys/imports/$importId/setup/importing';
      fullPath: '/workspaces/$workspaceId/journeys/imports/$importId/setup/importing';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupImportingRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/fields': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/fields';
      path: '/journeys/imports/$importId/setup/fields';
      fullPath: '/workspaces/$workspaceId/journeys/imports/$importId/setup/fields';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupFieldsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/settings': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/settings';
      path: '/settings';
      fullPath: '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/settings';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdSettingsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/relationships-query': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/relationships-query';
      path: '/relationships-query';
      fullPath: '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/relationships-query';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/query': {
      id: '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/query';
      path: '/query';
      fullPath: '/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/query';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdQueryRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/dev/db/campaigns/actions/$actionId': {
      id: '/_authenticated/workspaces/$workspaceId/dev/db/campaigns/actions/$actionId';
      path: '/actions/$actionId';
      fullPath: '/workspaces/$workspaceId/dev/db/campaigns/actions/$actionId';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsActionsActionIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId_/settings': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId_/settings';
      path: '/$sqlImportId/settings';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId/settings';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdSettingsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId_/relationships-query': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId_/relationships-query';
      path: '/$sqlImportId/relationships-query';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId/relationships-query';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId_/query': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId_/query';
      path: '/$sqlImportId/query';
      fullPath: '/workspaces/$workspaceId/journeys/integrations/sql-sync/$type/$sqlImportId/query';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdQueryRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/setup/workflow/actions': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/setup/workflow/actions';
      path: '/journeys/campaigns/$campaignId/setup/workflow/actions';
      fullPath: '/workspaces/$workspaceId/journeys/campaigns/$campaignId/setup/workflow/actions';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdSetupWorkflowActionsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/workflow/actions': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/workflow/actions';
      path: '/journeys/campaigns/$campaignId/overview/workflow/actions';
      fullPath: '/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/workflow/actions';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewWorkflowActionsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/setup/workflow/actions': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/setup/workflow/actions';
      path: '/journeys/automations/$campaignId/setup/workflow/actions';
      fullPath: '/workspaces/$workspaceId/journeys/automations/$campaignId/setup/workflow/actions';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdSetupWorkflowActionsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
    '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/workflow/actions': {
      id: '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/workflow/actions';
      path: '/journeys/automations/$campaignId/overview/workflow/actions';
      fullPath: '/workspaces/$workspaceId/journeys/automations/$campaignId/overview/workflow/actions';
      preLoaderRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewWorkflowActionsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesWorkspaceIdRoute;
    };
  }
}

interface AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdAgentSkillsSkillPathRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsSkillPathRoute;
  AuthenticatedWorkspacesWorkspaceIdAgentSkillsNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsNewRoute;
  AuthenticatedWorkspacesWorkspaceIdAgentSkillsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteChildren: AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdAgentSkillsSkillPathRoute:
      AuthenticatedWorkspacesWorkspaceIdAgentSkillsSkillPathRoute,
    AuthenticatedWorkspacesWorkspaceIdAgentSkillsNewRoute:
      AuthenticatedWorkspacesWorkspaceIdAgentSkillsNewRoute,
    AuthenticatedWorkspacesWorkspaceIdAgentSkillsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdAgentSkillsIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdAgentSkillsRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdAgentRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdAgentRoutinesRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentRoutinesRoute;
  AuthenticatedWorkspacesWorkspaceIdAgentSkillsRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdAgentIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdAgentRouteChildren: AuthenticatedWorkspacesWorkspaceIdAgentRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdAgentRoutinesRoute:
      AuthenticatedWorkspacesWorkspaceIdAgentRoutinesRoute,
    AuthenticatedWorkspacesWorkspaceIdAgentSkillsRoute:
      AuthenticatedWorkspacesWorkspaceIdAgentSkillsRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdAgentIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdAgentIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdAgentRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdAgentRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdAgentRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdDesignStudioSplatRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioSplatRoute;
  AuthenticatedWorkspacesWorkspaceIdDesignStudioIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteChildren: AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdDesignStudioSplatRoute:
      AuthenticatedWorkspacesWorkspaceIdDesignStudioSplatRoute,
    AuthenticatedWorkspacesWorkspaceIdDesignStudioIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdDesignStudioIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdDesignStudioRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdExperimentsRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdExperimentsExperimentIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdExperimentsExperimentIdRoute;
  AuthenticatedWorkspacesWorkspaceIdExperimentsNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdExperimentsNewRoute;
  AuthenticatedWorkspacesWorkspaceIdExperimentsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdExperimentsIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdExperimentsRouteChildren: AuthenticatedWorkspacesWorkspaceIdExperimentsRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdExperimentsExperimentIdRoute:
      AuthenticatedWorkspacesWorkspaceIdExperimentsExperimentIdRoute,
    AuthenticatedWorkspacesWorkspaceIdExperimentsNewRoute:
      AuthenticatedWorkspacesWorkspaceIdExperimentsNewRoute,
    AuthenticatedWorkspacesWorkspaceIdExperimentsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdExperimentsIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdExperimentsRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdExperimentsRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdExperimentsRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesGeofenceIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesGeofenceIdRoute;
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesImportRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesImportRoute;
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesNewRoute;
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRouteChildren: AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesGeofenceIdRoute:
      AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesGeofenceIdRoute,
    AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesImportRoute:
      AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesImportRoute,
    AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesNewRoute:
      AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesNewRoute,
    AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdEditRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdEditRoute;
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRouteChildren: AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdEditRoute:
      AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdEditRoute,
    AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRoute:
      AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdGeofencesRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdGeosetsRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdGeosetsImportRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsImportRoute;
  AuthenticatedWorkspacesWorkspaceIdGeosetsNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsNewRoute;
  AuthenticatedWorkspacesWorkspaceIdGeosetsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdGeosetsRouteChildren: AuthenticatedWorkspacesWorkspaceIdGeosetsRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRoute:
      AuthenticatedWorkspacesWorkspaceIdGeosetsGeosetIdRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdGeosetsImportRoute:
      AuthenticatedWorkspacesWorkspaceIdGeosetsImportRoute,
    AuthenticatedWorkspacesWorkspaceIdGeosetsNewRoute:
      AuthenticatedWorkspacesWorkspaceIdGeosetsNewRoute,
    AuthenticatedWorkspacesWorkspaceIdGeosetsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdGeosetsIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdGeosetsRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdGeosetsRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdGeosetsRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupAddPeopleRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupAddPeopleRoute;
  AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteChildren: AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupAddPeopleRoute:
      AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupAddPeopleRoute,
    AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdHomeRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdHomeAddPeopleRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeAddPeopleRoute;
  AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdHomeIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdHomeRouteChildren: AuthenticatedWorkspacesWorkspaceIdHomeRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdHomeAddPeopleRoute:
      AuthenticatedWorkspacesWorkspaceIdHomeAddPeopleRoute,
    AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRoute:
      AuthenticatedWorkspacesWorkspaceIdHomeWorkspaceSetupRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdHomeIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdHomeIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdHomeRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdHomeRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdHomeRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdOutcomesRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdOutcomesGoalIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdOutcomesGoalIdRoute;
  AuthenticatedWorkspacesWorkspaceIdOutcomesIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdOutcomesIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdOutcomesRouteChildren: AuthenticatedWorkspacesWorkspaceIdOutcomesRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdOutcomesGoalIdRoute:
      AuthenticatedWorkspacesWorkspaceIdOutcomesGoalIdRoute,
    AuthenticatedWorkspacesWorkspaceIdOutcomesIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdOutcomesIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdOutcomesRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdOutcomesRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdOutcomesRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdSnippetsRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdSnippetsSnippetIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdSnippetsSnippetIdRoute;
  AuthenticatedWorkspacesWorkspaceIdSnippetsNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdSnippetsNewRoute;
  AuthenticatedWorkspacesWorkspaceIdSnippetsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdSnippetsIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdSnippetsRouteChildren: AuthenticatedWorkspacesWorkspaceIdSnippetsRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdSnippetsSnippetIdRoute:
      AuthenticatedWorkspacesWorkspaceIdSnippetsSnippetIdRoute,
    AuthenticatedWorkspacesWorkspaceIdSnippetsNewRoute:
      AuthenticatedWorkspacesWorkspaceIdSnippetsNewRoute,
    AuthenticatedWorkspacesWorkspaceIdSnippetsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdSnippetsIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdSnippetsRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdSnippetsRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdSnippetsRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDevelopersRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDevelopersRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDirectoryRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDirectoryRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsAllOverviewRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllOverviewRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsAllWebhooksRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllWebhooksRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsAllIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRouteChildren: AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDevelopersRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDevelopersRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDirectoryRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsAllDirectoryRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsAllOverviewRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsAllOverviewRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsAllWebhooksRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsAllWebhooksRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsAllIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsAllIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdSplatRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdSplatRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdDataRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdDataRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdImportingRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdImportingRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdUsageRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdUsageRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdRouteChildren: AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdSplatRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdSplatRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdDataRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdDataRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdImportingRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdImportingRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdUsageRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdUsageRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRouteChildren: AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsCollectionIdRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesGeofenceIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesGeofenceIdRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesNewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteChildren: AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesGeofenceIdRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesGeofenceIdRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesNewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesNewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdJourneysSettingsSplatRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSettingsSplatRoute;
}

const AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteChildren: AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdJourneysSettingsSplatRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysSettingsSplatRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsSnippetIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsSnippetIdRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsNewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteChildren: AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsSnippetIdRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsSnippetIdRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsNewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsNewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationNewRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationConfigurationIdEditRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationConfigurationIdEditRoute;
}

const AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRouteChildren: AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationNewRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationNewRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationConfigurationIdEditRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationConfigurationIdEditRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerSettingsRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerSettingsRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerBrandingEditRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerBrandingEditRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerLocalizationEditRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerLocalizationEditRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsSet_preferencesRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsSet_preferencesRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRouteChildren: AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerSettingsRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerSettingsRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerBrandingEditRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerBrandingEditRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerLocalizationEditRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerLocalizationEditRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsSet_preferencesRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsSet_preferencesRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerTopicsIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsActionsActionIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsActionsActionIdRoute;
}

const AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteChildren: AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsActionsActionIdRoute:
      AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsActionsActionIdRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdQueryRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdQueryRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdSettingsRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdSettingsRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRouteChildren: AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdQueryRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdQueryRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdSettingsRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdSettingsRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeNewRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRouteChildren: AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeSqlImportIdRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeNewRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeNewRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDevelopersRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDevelopersRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDirectoryRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDirectoryRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllOverviewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllOverviewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllWebhooksRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllWebhooksRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRouteChildren: AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDevelopersRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDevelopersRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDirectoryRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllDirectoryRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllOverviewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllOverviewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllWebhooksRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllWebhooksRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksWebhookIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksWebhookIdRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksNewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRouteChildren: AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksWebhookIdRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksWebhookIdRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksNewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksNewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRouteChildren: AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsSubscriptionIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsSubscriptionIdRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsAddRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsAddRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteChildren: AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsSubscriptionIdRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsSubscriptionIdRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsAddRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsAddRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdDataOutRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdDataOutRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdExportsRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdExportsRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSettingsRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSettingsRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdTesterRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdTesterRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteChildren: AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdDataOutRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdDataOutRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdExportsRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdExportsRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSettingsRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSettingsRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdSubscriptionsRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdTesterRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdTesterRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDataInRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDataInRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDatabasesRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDatabasesRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdImportsRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdImportsRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSettingsRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSettingsRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteChildren: AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDataInRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDataInRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDatabasesRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdDatabasesRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdImportsRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdImportsRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSettingsRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSettingsRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDefaultsRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDefaultsRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDeliverabilityRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDeliverabilityRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDynamic_addressesRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDynamic_addressesRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailFrom_addressesRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailFrom_addressesRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSmtpRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSmtpRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSuppression_listRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSuppression_listRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsDomainIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsDomainIdRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRouteChildren: AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDefaultsRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDefaultsRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDeliverabilityRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDeliverabilityRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDynamic_addressesRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailDynamic_addressesRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailFrom_addressesRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailFrom_addressesRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSmtpRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSmtpRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSuppression_listRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSuppression_listRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsDomainIdRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsDomainIdRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailSending_domainsIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersCredentialsCredentialIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersCredentialsCredentialIdRoute;
}

const AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRouteChildren: AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersCredentialsCredentialIdRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersCredentialsCredentialIdRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsEditRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsEditRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsIndexRoute;
}

const AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRouteChildren: AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsEditRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsEditRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsIndexRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeNewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdQueryRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdQueryRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdSettingsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdSettingsRoute;
}

const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRouteChildren: AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeNewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeNewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdQueryRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdQueryRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdRelationshipsQueryRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdSettingsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeSqlImportIdSettingsRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRouteChildren,
  );

interface AuthenticatedWorkspacesWorkspaceIdRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdSplatRoute: typeof AuthenticatedWorkspacesWorkspaceIdSplatRoute;
  AuthenticatedWorkspacesWorkspaceIdAgentRoute: typeof AuthenticatedWorkspacesWorkspaceIdAgentRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdAssetsRoute: typeof AuthenticatedWorkspacesWorkspaceIdAssetsRoute;
  AuthenticatedWorkspacesWorkspaceIdDesignStudioRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdExperimentsRoute: typeof AuthenticatedWorkspacesWorkspaceIdExperimentsRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdExportsRoute: typeof AuthenticatedWorkspacesWorkspaceIdExportsRoute;
  AuthenticatedWorkspacesWorkspaceIdGeosetsRoute: typeof AuthenticatedWorkspacesWorkspaceIdGeosetsRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdHealthRoute: typeof AuthenticatedWorkspacesWorkspaceIdHealthRoute;
  AuthenticatedWorkspacesWorkspaceIdHomeRoute: typeof AuthenticatedWorkspacesWorkspaceIdHomeRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdJourneysRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysRoute;
  AuthenticatedWorkspacesWorkspaceIdMessageLibraryRoute: typeof AuthenticatedWorkspacesWorkspaceIdMessageLibraryRoute;
  AuthenticatedWorkspacesWorkspaceIdOutcomesRoute: typeof AuthenticatedWorkspacesWorkspaceIdOutcomesRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdSnippetsRoute: typeof AuthenticatedWorkspacesWorkspaceIdSnippetsRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdTasksRoute: typeof AuthenticatedWorkspacesWorkspaceIdTasksRoute;
  AuthenticatedWorkspacesWorkspaceIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdAnalysisDeliverabilityRoute: typeof AuthenticatedWorkspacesWorkspaceIdAnalysisDeliverabilityRoute;
  AuthenticatedWorkspacesWorkspaceIdAnalysisEmailClientsRoute: typeof AuthenticatedWorkspacesWorkspaceIdAnalysisEmailClientsRoute;
  AuthenticatedWorkspacesWorkspaceIdBoardsBoardIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdBoardsBoardIdRoute;
  AuthenticatedWorkspacesWorkspaceIdDesignStudioDashboardRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioDashboardRoute;
  AuthenticatedWorkspacesWorkspaceIdDesignStudioGlobalStylesRoute: typeof AuthenticatedWorkspacesWorkspaceIdDesignStudioGlobalStylesRoute;
  AuthenticatedWorkspacesWorkspaceIdDevConditionViewerRoute: typeof AuthenticatedWorkspacesWorkspaceIdDevConditionViewerRoute;
  AuthenticatedWorkspacesWorkspaceIdImportsNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsNewRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsTypeRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsTypeRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_inRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_inRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_outRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_outRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsCustomerioRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsCustomerioRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsMparticle_outRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsMparticle_outRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_inRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_inRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_outRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_outRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysSplatRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSplatRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysAssetsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAssetsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdJourneysDeliveriesRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysDeliveriesRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysDraftsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysDraftsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysExportsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysExportsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdJourneysMessageLibraryRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysMessageLibraryRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdJourneysTasksRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTasksRoute;
  AuthenticatedWorkspacesWorkspaceIdParcelSplatRoute: typeof AuthenticatedWorkspacesWorkspaceIdParcelSplatRoute;
  AuthenticatedWorkspacesWorkspaceIdPeopleCreateRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeopleCreateRoute;
  AuthenticatedWorkspacesWorkspaceIdPeopleMergeRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeopleMergeRoute;
  AuthenticatedWorkspacesWorkspaceIdPeopleNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeopleNewRoute;
  AuthenticatedWorkspacesWorkspaceIdPeopleWelcomeRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeopleWelcomeRoute;
  AuthenticatedWorkspacesWorkspaceIdProfilesCreateRoute: typeof AuthenticatedWorkspacesWorkspaceIdProfilesCreateRoute;
  AuthenticatedWorkspacesWorkspaceIdProfilesMergeRoute: typeof AuthenticatedWorkspacesWorkspaceIdProfilesMergeRoute;
  AuthenticatedWorkspacesWorkspaceIdProfilesNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdProfilesNewRoute;
  AuthenticatedWorkspacesWorkspaceIdProfilesWelcomeRoute: typeof AuthenticatedWorkspacesWorkspaceIdProfilesWelcomeRoute;
  AuthenticatedWorkspacesWorkspaceIdReportsDeliverabilityRoute: typeof AuthenticatedWorkspacesWorkspaceIdReportsDeliverabilityRoute;
  AuthenticatedWorkspacesWorkspaceIdReportsEmailClientsRoute: typeof AuthenticatedWorkspacesWorkspaceIdReportsEmailClientsRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsSplatRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSplatRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsAiBusinessProfileRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsAiBusinessProfileRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsAnonymous_eventsRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsAnonymous_eventsRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsApiKeysRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsApiKeysRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsAuditLogsRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsAuditLogsRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsAuto_archiveRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsAuto_archiveRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsConfirm_deleteRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsConfirm_deleteRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsEditRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsEditRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsGeofencesRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsGeofencesRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsLanguageRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsLanguageRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdSettingsMerge_optionsRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsMerge_optionsRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdSettingsSuppressionsRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsSuppressionsRoute;
  AuthenticatedWorkspacesWorkspaceIdTemplateTemplateIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdTemplateTemplateIdRoute;
  AuthenticatedWorkspacesWorkspaceIdBoardsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdBoardsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdImportsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdObjectsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdParcelIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdParcelIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdPeopleIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdPeopleIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdProfilesIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdProfilesIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdTemplateIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdTemplateIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdWorkflowRoute: typeof AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdWorkflowRoute;
  AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRoute: typeof AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsData_outTypeRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsData_outTypeRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksWebhookIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksWebhookIdRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksNewRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseBigqueryRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseBigqueryRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseRedshiftRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseRedshiftRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseSnowflakeRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseSnowflakeRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsTabRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsTabRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisDeliverabilityRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisDeliverabilityRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsNewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsTypeRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsTypeRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_inRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_inRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_outRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_outRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCustomerioRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCustomerioRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsMparticle_outRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsMparticle_outRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_inRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_inRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_outRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_outRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsNewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsStartersRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsStartersRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysMessage_activitySplatRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysMessage_activitySplatRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysOutboxSplatRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysOutboxSplatRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysPeopleCreateRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleCreateRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysPeopleMergeRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleMergeRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysPeopleNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleNewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysPeopleWelcomeRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleWelcomeRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityTabRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityTabRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysProfilesCreateRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesCreateRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysProfilesMergeRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesMergeRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysProfilesNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesNewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysProfilesWelcomeRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesWelcomeRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysSetupGuideSplatRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysSetupGuideSplatRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysTemplateTemplateIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTemplateTemplateIdRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredNewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysV2SplatRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysV2SplatRoute;
  AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdObjectsSlugGuideRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugGuideRoute;
  AuthenticatedWorkspacesWorkspaceIdObjectsSlugNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugNewRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsJourneysRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsJourneysRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesJourneysRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesJourneysRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsLineRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsLineRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessage_frequency_limitsRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessage_frequency_limitsRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessaging_limitRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessaging_limitRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSlackRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSlackRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsTime_zone_matchRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsTime_zone_matchRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrban_airshipRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrban_airshipRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdSettingsObjectsNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsObjectsNewRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationNewRoute;
  AuthenticatedWorkspacesWorkspaceIdImportsImportIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysObjectsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysPeopleIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysPeopleIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysProfilesIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysProfilesIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysTemplateIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTemplateIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdObjectsSlugIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdObjectsSlugIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsObjectsIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsObjectsIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupFieldsRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupFieldsRoute;
  AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupImportingRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupImportingRoute;
  AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreprocessingRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreprocessingRoute;
  AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreviewRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreviewRoute;
  AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupReviewRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupReviewRoute;
  AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupValidatingRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupValidatingRoute;
  AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeSyncRoute: typeof AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeSyncRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsData_outTypeRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsData_outTypeRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRouteWithChildren;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseBigqueryRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseBigqueryRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseRedshiftRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseRedshiftRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseSnowflakeRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseSnowflakeRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdEditRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdEditRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugGuideRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugGuideRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugNewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugNewRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddDestinationOptionIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddDestinationOptionIdRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddSourceOptionIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddSourceOptionIdRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsService_accountsServiceAccountIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsService_accountsServiceAccountIdRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsObjectsEditObjectTypeRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsObjectsEditObjectTypeRoute;
  AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationWebhookIdEditRoute: typeof AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationWebhookIdEditRoute;
  AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupFieldsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupFieldsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupImportingRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupImportingRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreprocessingRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreprocessingRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreviewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreviewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupReviewRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupReviewRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupValidatingRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupValidatingRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeSyncRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeSyncRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsSyncIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsSyncIdRoute;
  AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsAddRoute: typeof AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsAddRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdIndexRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdIndexRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewWorkflowActionsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewWorkflowActionsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdSetupWorkflowActionsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdSetupWorkflowActionsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewWorkflowActionsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewWorkflowActionsRoute;
  AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdSetupWorkflowActionsRoute: typeof AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdSetupWorkflowActionsRoute;
}

const AuthenticatedWorkspacesWorkspaceIdRouteChildren: AuthenticatedWorkspacesWorkspaceIdRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdSplatRoute:
      AuthenticatedWorkspacesWorkspaceIdSplatRoute,
    AuthenticatedWorkspacesWorkspaceIdAgentRoute:
      AuthenticatedWorkspacesWorkspaceIdAgentRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdAssetsRoute:
      AuthenticatedWorkspacesWorkspaceIdAssetsRoute,
    AuthenticatedWorkspacesWorkspaceIdDesignStudioRoute:
      AuthenticatedWorkspacesWorkspaceIdDesignStudioRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdExperimentsRoute:
      AuthenticatedWorkspacesWorkspaceIdExperimentsRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdExportsRoute:
      AuthenticatedWorkspacesWorkspaceIdExportsRoute,
    AuthenticatedWorkspacesWorkspaceIdGeosetsRoute:
      AuthenticatedWorkspacesWorkspaceIdGeosetsRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdHealthRoute:
      AuthenticatedWorkspacesWorkspaceIdHealthRoute,
    AuthenticatedWorkspacesWorkspaceIdHomeRoute:
      AuthenticatedWorkspacesWorkspaceIdHomeRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdJourneysRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysRoute,
    AuthenticatedWorkspacesWorkspaceIdMessageLibraryRoute:
      AuthenticatedWorkspacesWorkspaceIdMessageLibraryRoute,
    AuthenticatedWorkspacesWorkspaceIdOutcomesRoute:
      AuthenticatedWorkspacesWorkspaceIdOutcomesRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdSnippetsRoute:
      AuthenticatedWorkspacesWorkspaceIdSnippetsRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdTasksRoute:
      AuthenticatedWorkspacesWorkspaceIdTasksRoute,
    AuthenticatedWorkspacesWorkspaceIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdAnalysisDeliverabilityRoute:
      AuthenticatedWorkspacesWorkspaceIdAnalysisDeliverabilityRoute,
    AuthenticatedWorkspacesWorkspaceIdAnalysisEmailClientsRoute:
      AuthenticatedWorkspacesWorkspaceIdAnalysisEmailClientsRoute,
    AuthenticatedWorkspacesWorkspaceIdBoardsBoardIdRoute:
      AuthenticatedWorkspacesWorkspaceIdBoardsBoardIdRoute,
    AuthenticatedWorkspacesWorkspaceIdDesignStudioDashboardRoute:
      AuthenticatedWorkspacesWorkspaceIdDesignStudioDashboardRoute,
    AuthenticatedWorkspacesWorkspaceIdDesignStudioGlobalStylesRoute:
      AuthenticatedWorkspacesWorkspaceIdDesignStudioGlobalStylesRoute,
    AuthenticatedWorkspacesWorkspaceIdDevConditionViewerRoute:
      AuthenticatedWorkspacesWorkspaceIdDevConditionViewerRoute,
    AuthenticatedWorkspacesWorkspaceIdImportsNewRoute:
      AuthenticatedWorkspacesWorkspaceIdImportsNewRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsTypeRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsTypeRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsAllRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_inRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_inRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_outRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsCdp_outRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsCustomerioRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsCustomerioRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsMparticle_outRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsMparticle_outRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_inRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_inRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_outRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsSegment_outRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysSplatRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysSplatRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysAssetsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysAssetsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysCollectionsRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdJourneysDeliveriesRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysDeliveriesRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysDraftsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysDraftsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysExportsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysExportsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysGeofencesRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdJourneysMessageLibraryRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysMessageLibraryRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysSettingsRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysSnippetsRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdJourneysTasksRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysTasksRoute,
    AuthenticatedWorkspacesWorkspaceIdParcelSplatRoute:
      AuthenticatedWorkspacesWorkspaceIdParcelSplatRoute,
    AuthenticatedWorkspacesWorkspaceIdPeopleCreateRoute:
      AuthenticatedWorkspacesWorkspaceIdPeopleCreateRoute,
    AuthenticatedWorkspacesWorkspaceIdPeopleMergeRoute:
      AuthenticatedWorkspacesWorkspaceIdPeopleMergeRoute,
    AuthenticatedWorkspacesWorkspaceIdPeopleNewRoute:
      AuthenticatedWorkspacesWorkspaceIdPeopleNewRoute,
    AuthenticatedWorkspacesWorkspaceIdPeopleWelcomeRoute:
      AuthenticatedWorkspacesWorkspaceIdPeopleWelcomeRoute,
    AuthenticatedWorkspacesWorkspaceIdProfilesCreateRoute:
      AuthenticatedWorkspacesWorkspaceIdProfilesCreateRoute,
    AuthenticatedWorkspacesWorkspaceIdProfilesMergeRoute:
      AuthenticatedWorkspacesWorkspaceIdProfilesMergeRoute,
    AuthenticatedWorkspacesWorkspaceIdProfilesNewRoute:
      AuthenticatedWorkspacesWorkspaceIdProfilesNewRoute,
    AuthenticatedWorkspacesWorkspaceIdProfilesWelcomeRoute:
      AuthenticatedWorkspacesWorkspaceIdProfilesWelcomeRoute,
    AuthenticatedWorkspacesWorkspaceIdReportsDeliverabilityRoute:
      AuthenticatedWorkspacesWorkspaceIdReportsDeliverabilityRoute,
    AuthenticatedWorkspacesWorkspaceIdReportsEmailClientsRoute:
      AuthenticatedWorkspacesWorkspaceIdReportsEmailClientsRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsSplatRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsSplatRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsAiBusinessProfileRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsAiBusinessProfileRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsAnonymous_eventsRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsAnonymous_eventsRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsApiKeysRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsApiKeysRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsAuditLogsRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsAuditLogsRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsAuto_archiveRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsAuto_archiveRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsConfirm_deleteRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsConfirm_deleteRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsEditRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsEditRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsGeofencesRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsGeofencesRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsLanguageRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsLanguageRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsLlm_configurationRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdSettingsMerge_optionsRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsMerge_optionsRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsSubscription_centerRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdSettingsSuppressionsRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsSuppressionsRoute,
    AuthenticatedWorkspacesWorkspaceIdTemplateTemplateIdRoute:
      AuthenticatedWorkspacesWorkspaceIdTemplateTemplateIdRoute,
    AuthenticatedWorkspacesWorkspaceIdBoardsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdBoardsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdImportsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdImportsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdObjectsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdObjectsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdParcelIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdParcelIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdPeopleIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdPeopleIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdProfilesIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdProfilesIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdTemplateIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdTemplateIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdWorkflowRoute:
      AuthenticatedWorkspacesWorkspaceIdAutomationsCampaignIdWorkflowRoute,
    AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRoute:
      AuthenticatedWorkspacesWorkspaceIdDevDbCampaignsRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsData_outTypeRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsData_outTypeRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksWebhookIdRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksWebhookIdRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksNewRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksNewRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsSqlSyncTypeRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseBigqueryRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseBigqueryRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseRedshiftRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseRedshiftRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseSnowflakeRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseSnowflakeRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsTabRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsTabRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisDeliverabilityRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysAnalysisDeliverabilityRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysImportsNewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysImportsNewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsTypeRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsTypeRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsAllRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_inRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_inRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_outRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCdp_outRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCustomerioRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsCustomerioRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsMparticle_outRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsMparticle_outRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsReportingWebhooksRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_inRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_inRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_outRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSegment_outRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsNewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsNewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsStartersRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsStartersRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysMessage_activitySplatRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysMessage_activitySplatRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysOutboxSplatRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysOutboxSplatRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysPeopleCreateRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysPeopleCreateRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysPeopleMergeRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysPeopleMergeRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysPeopleNewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysPeopleNewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysPeopleWelcomeRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysPeopleWelcomeRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityTabRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityTabRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysProfilesCreateRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysProfilesCreateRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysProfilesMergeRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysProfilesMergeRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysProfilesNewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysProfilesNewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysProfilesWelcomeRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysProfilesWelcomeRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysSetupGuideSplatRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysSetupGuideSplatRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysTemplateTemplateIdRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysTemplateTemplateIdRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredNewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredNewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysV2SplatRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysV2SplatRoute,
    AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRoute:
      AuthenticatedWorkspacesWorkspaceIdObjectsSlugObjectIdRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdObjectsSlugGuideRoute:
      AuthenticatedWorkspacesWorkspaceIdObjectsSlugGuideRoute,
    AuthenticatedWorkspacesWorkspaceIdObjectsSlugNewRoute:
      AuthenticatedWorkspacesWorkspaceIdObjectsSlugNewRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsDestinationIdRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsJourneysRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsJourneysRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesJourneysRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesJourneysRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsEmailRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsLineRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsLineRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessage_frequency_limitsRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessage_frequency_limitsRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessaging_limitRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsMessaging_limitRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsSlackRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsSlackRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsSmsProvidersRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsTime_zone_matchRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsTime_zone_matchRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrban_airshipRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrban_airshipRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsActionsUrl_paramsRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdSettingsObjectsNewRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsObjectsNewRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationNewRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationNewRoute,
    AuthenticatedWorkspacesWorkspaceIdImportsImportIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdImportsImportIdIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsReportingWebhooksIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysActivity_logsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysImportsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysImportsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysObjectsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysObjectsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysPeopleIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysPeopleIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysProfile_activityIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysProfilesIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysProfilesIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysTemplateIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysTemplateIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysTriggeredIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdObjectsSlugIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdObjectsSlugIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsObjectsIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsObjectsIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupFieldsRoute:
      AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupFieldsRoute,
    AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupImportingRoute:
      AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupImportingRoute,
    AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreprocessingRoute:
      AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreprocessingRoute,
    AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreviewRoute:
      AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupPreviewRoute,
    AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupReviewRoute:
      AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupReviewRoute,
    AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupValidatingRoute:
      AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupValidatingRoute,
    AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeSyncRoute:
      AuthenticatedWorkspacesWorkspaceIdIntegrationsWarehouseTypeSyncRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsData_outTypeRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsData_outTypeRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsSqlSyncTypeRouteWithChildren,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseBigqueryRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseBigqueryRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseRedshiftRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseRedshiftRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseSnowflakeRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseSnowflakeRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdEditRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdEditRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugGuideRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugGuideRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugNewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugNewRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddDestinationOptionIdRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesDestinationsAddDestinationOptionIdRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddSourceOptionIdRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesAddSourceOptionIdRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsService_accountsServiceAccountIdRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsApi_credentialsService_accountsServiceAccountIdRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsObjectsEditObjectTypeRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsObjectsEditObjectTypeRoute,
    AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationWebhookIdEditRoute:
      AuthenticatedWorkspacesWorkspaceIdSettingsWebhook_configurationWebhookIdEditRoute,
    AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdImportsImportIdSetupIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysLayoutsLayoutIdIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupFieldsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupFieldsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupImportingRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupImportingRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreprocessingRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreprocessingRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreviewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupPreviewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupReviewRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupReviewRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupValidatingRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupValidatingRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeSyncRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysIntegrationsWarehouseTypeSyncRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsSyncIdRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsSyncIdRoute,
    AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsAddRoute:
      AuthenticatedWorkspacesWorkspaceIdPipelinesSourcesSourceIdSyncsAddRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysImportsImportIdSetupIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdIndexRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysObjectsSlugObjectIdIndexRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewWorkflowActionsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdOverviewWorkflowActionsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdSetupWorkflowActionsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysAutomationsCampaignIdSetupWorkflowActionsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewWorkflowActionsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdOverviewWorkflowActionsRoute,
    AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdSetupWorkflowActionsRoute:
      AuthenticatedWorkspacesWorkspaceIdJourneysCampaignsCampaignIdSetupWorkflowActionsRoute,
  };

const AuthenticatedWorkspacesWorkspaceIdRouteWithChildren =
  AuthenticatedWorkspacesWorkspaceIdRoute._addFileChildren(
    AuthenticatedWorkspacesWorkspaceIdRouteChildren,
  );

interface AuthenticatedWorkspacesRouteChildren {
  AuthenticatedWorkspacesWorkspaceIdRoute: typeof AuthenticatedWorkspacesWorkspaceIdRouteWithChildren;
  AuthenticatedWorkspacesIndexRoute: typeof AuthenticatedWorkspacesIndexRoute;
}

const AuthenticatedWorkspacesRouteChildren: AuthenticatedWorkspacesRouteChildren =
  {
    AuthenticatedWorkspacesWorkspaceIdRoute:
      AuthenticatedWorkspacesWorkspaceIdRouteWithChildren,
    AuthenticatedWorkspacesIndexRoute: AuthenticatedWorkspacesIndexRoute,
  };

const AuthenticatedWorkspacesRouteWithChildren =
  AuthenticatedWorkspacesRoute._addFileChildren(
    AuthenticatedWorkspacesRouteChildren,
  );

interface AuthenticatedSettingsBillingRouteChildren {
  AuthenticatedSettingsBillingSplatRoute: typeof AuthenticatedSettingsBillingSplatRoute;
  AuthenticatedSettingsBillingBillingDetailsRoute: typeof AuthenticatedSettingsBillingBillingDetailsRoute;
  AuthenticatedSettingsBillingBillingHistoryRoute: typeof AuthenticatedSettingsBillingBillingHistoryRoute;
  AuthenticatedSettingsBillingCheckoutRoute: typeof AuthenticatedSettingsBillingCheckoutRoute;
  AuthenticatedSettingsBillingInboxPreviewUsageRoute: typeof AuthenticatedSettingsBillingInboxPreviewUsageRoute;
  AuthenticatedSettingsBillingLlmUsageRoute: typeof AuthenticatedSettingsBillingLlmUsageRoute;
  AuthenticatedSettingsBillingOverviewRoute: typeof AuthenticatedSettingsBillingOverviewRoute;
  AuthenticatedSettingsBillingPaymentMethodsRoute: typeof AuthenticatedSettingsBillingPaymentMethodsRoute;
  AuthenticatedSettingsBillingProfileGrowthRoute: typeof AuthenticatedSettingsBillingProfileGrowthRoute;
  AuthenticatedSettingsBillingUsageRoute: typeof AuthenticatedSettingsBillingUsageRoute;
  AuthenticatedSettingsBillingYourPlanRoute: typeof AuthenticatedSettingsBillingYourPlanRoute;
  AuthenticatedSettingsBillingIndexRoute: typeof AuthenticatedSettingsBillingIndexRoute;
  AuthenticatedSettingsBillingAvailablePlansJourneysRoute: typeof AuthenticatedSettingsBillingAvailablePlansJourneysRoute;
  AuthenticatedSettingsBillingAvailablePlansIndexRoute: typeof AuthenticatedSettingsBillingAvailablePlansIndexRoute;
}

const AuthenticatedSettingsBillingRouteChildren: AuthenticatedSettingsBillingRouteChildren =
  {
    AuthenticatedSettingsBillingSplatRoute:
      AuthenticatedSettingsBillingSplatRoute,
    AuthenticatedSettingsBillingBillingDetailsRoute:
      AuthenticatedSettingsBillingBillingDetailsRoute,
    AuthenticatedSettingsBillingBillingHistoryRoute:
      AuthenticatedSettingsBillingBillingHistoryRoute,
    AuthenticatedSettingsBillingCheckoutRoute:
      AuthenticatedSettingsBillingCheckoutRoute,
    AuthenticatedSettingsBillingInboxPreviewUsageRoute:
      AuthenticatedSettingsBillingInboxPreviewUsageRoute,
    AuthenticatedSettingsBillingLlmUsageRoute:
      AuthenticatedSettingsBillingLlmUsageRoute,
    AuthenticatedSettingsBillingOverviewRoute:
      AuthenticatedSettingsBillingOverviewRoute,
    AuthenticatedSettingsBillingPaymentMethodsRoute:
      AuthenticatedSettingsBillingPaymentMethodsRoute,
    AuthenticatedSettingsBillingProfileGrowthRoute:
      AuthenticatedSettingsBillingProfileGrowthRoute,
    AuthenticatedSettingsBillingUsageRoute:
      AuthenticatedSettingsBillingUsageRoute,
    AuthenticatedSettingsBillingYourPlanRoute:
      AuthenticatedSettingsBillingYourPlanRoute,
    AuthenticatedSettingsBillingIndexRoute:
      AuthenticatedSettingsBillingIndexRoute,
    AuthenticatedSettingsBillingAvailablePlansJourneysRoute:
      AuthenticatedSettingsBillingAvailablePlansJourneysRoute,
    AuthenticatedSettingsBillingAvailablePlansIndexRoute:
      AuthenticatedSettingsBillingAvailablePlansIndexRoute,
  };

const AuthenticatedSettingsBillingRouteWithChildren =
  AuthenticatedSettingsBillingRoute._addFileChildren(
    AuthenticatedSettingsBillingRouteChildren,
  );

interface AuthenticatedSettingsPartnerRouteChildren {
  AuthenticatedSettingsPartnerCreateRoute: typeof AuthenticatedSettingsPartnerCreateRoute;
  AuthenticatedSettingsPartnerIndexRoute: typeof AuthenticatedSettingsPartnerIndexRoute;
}

const AuthenticatedSettingsPartnerRouteChildren: AuthenticatedSettingsPartnerRouteChildren =
  {
    AuthenticatedSettingsPartnerCreateRoute:
      AuthenticatedSettingsPartnerCreateRoute,
    AuthenticatedSettingsPartnerIndexRoute:
      AuthenticatedSettingsPartnerIndexRoute,
  };

const AuthenticatedSettingsPartnerRouteWithChildren =
  AuthenticatedSettingsPartnerRoute._addFileChildren(
    AuthenticatedSettingsPartnerRouteChildren,
  );

interface AuthenticatedRouteChildren {
  AuthenticatedSplatRoute: typeof AuthenticatedSplatRoute;
  AuthenticatedWorkspacesRoute: typeof AuthenticatedWorkspacesRouteWithChildren;
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute;
  AuthenticatedInternalToolsSplatRoute: typeof AuthenticatedInternalToolsSplatRoute;
  AuthenticatedSampleWorkspaceSplatRoute: typeof AuthenticatedSampleWorkspaceSplatRoute;
  AuthenticatedSettingsSplatRoute: typeof AuthenticatedSettingsSplatRoute;
  AuthenticatedSettingsAiRoute: typeof AuthenticatedSettingsAiRoute;
  AuthenticatedSettingsApiKeysRoute: typeof AuthenticatedSettingsApiKeysRoute;
  AuthenticatedSettingsAuditLogsRoute: typeof AuthenticatedSettingsAuditLogsRoute;
  AuthenticatedSettingsBillingRoute: typeof AuthenticatedSettingsBillingRouteWithChildren;
  AuthenticatedSettingsExperimentalFeaturesRoute: typeof AuthenticatedSettingsExperimentalFeaturesRoute;
  AuthenticatedSettingsPartnerRoute: typeof AuthenticatedSettingsPartnerRouteWithChildren;
  AuthenticatedSettingsPrivacyRoute: typeof AuthenticatedSettingsPrivacyRoute;
  AuthenticatedSettingsReceiptsRoute: typeof AuthenticatedSettingsReceiptsRoute;
  AuthenticatedSettingsSlackAgentRoute: typeof AuthenticatedSettingsSlackAgentRoute;
  AuthenticatedSettingsSubscriptionRoute: typeof AuthenticatedSettingsSubscriptionRoute;
  AuthenticatedTrialExpiredJourneysRoute: typeof AuthenticatedTrialExpiredJourneysRoute;
  AuthenticatedInternalToolsIndexRoute: typeof AuthenticatedInternalToolsIndexRoute;
  AuthenticatedSampleWorkspaceIndexRoute: typeof AuthenticatedSampleWorkspaceIndexRoute;
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute;
  AuthenticatedSettingsAccountEditRoute: typeof AuthenticatedSettingsAccountEditRoute;
  AuthenticatedSettingsPersonalGoogleIdentitiesRoute: typeof AuthenticatedSettingsPersonalGoogleIdentitiesRoute;
  AuthenticatedSettingsRolesRoleIdRoute: typeof AuthenticatedSettingsRolesRoleIdRoute;
  AuthenticatedSettingsRolesNewRoute: typeof AuthenticatedSettingsRolesNewRoute;
  AuthenticatedSettingsSecuritySsoRoute: typeof AuthenticatedSettingsSecuritySsoRoute;
  AuthenticatedSettingsSlackAgentLinkRoute: typeof AuthenticatedSettingsSlackAgentLinkRoute;
  AuthenticatedSettingsTeamAddRoute: typeof AuthenticatedSettingsTeamAddRoute;
  AuthenticatedSettingsTeamInviteGuestRoute: typeof AuthenticatedSettingsTeamInviteGuestRoute;
  AuthenticatedSettingsWorkspacesNewRoute: typeof AuthenticatedSettingsWorkspacesNewRoute;
  AuthenticatedSettingsAccountIndexRoute: typeof AuthenticatedSettingsAccountIndexRoute;
  AuthenticatedSettingsApi_credentialsIndexRoute: typeof AuthenticatedSettingsApi_credentialsIndexRoute;
  AuthenticatedSettingsPersonalIndexRoute: typeof AuthenticatedSettingsPersonalIndexRoute;
  AuthenticatedSettingsRolesIndexRoute: typeof AuthenticatedSettingsRolesIndexRoute;
  AuthenticatedSettingsSecurityIndexRoute: typeof AuthenticatedSettingsSecurityIndexRoute;
  AuthenticatedSettingsTeamIndexRoute: typeof AuthenticatedSettingsTeamIndexRoute;
  AuthenticatedSettingsWorkspacesIndexRoute: typeof AuthenticatedSettingsWorkspacesIndexRoute;
  AuthenticatedSettingsApi_credentialsService_accountsServiceAccountIdRoute: typeof AuthenticatedSettingsApi_credentialsService_accountsServiceAccountIdRoute;
  AuthenticatedSettingsTeamJoinRequestsRequestIdRoute: typeof AuthenticatedSettingsTeamJoinRequestsRequestIdRoute;
  AuthenticatedSettingsTeamMembersUserIdEditRoute: typeof AuthenticatedSettingsTeamMembersUserIdEditRoute;
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedSplatRoute: AuthenticatedSplatRoute,
  AuthenticatedWorkspacesRoute: AuthenticatedWorkspacesRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedInternalToolsSplatRoute: AuthenticatedInternalToolsSplatRoute,
  AuthenticatedSampleWorkspaceSplatRoute:
    AuthenticatedSampleWorkspaceSplatRoute,
  AuthenticatedSettingsSplatRoute: AuthenticatedSettingsSplatRoute,
  AuthenticatedSettingsAiRoute: AuthenticatedSettingsAiRoute,
  AuthenticatedSettingsApiKeysRoute: AuthenticatedSettingsApiKeysRoute,
  AuthenticatedSettingsAuditLogsRoute: AuthenticatedSettingsAuditLogsRoute,
  AuthenticatedSettingsBillingRoute:
    AuthenticatedSettingsBillingRouteWithChildren,
  AuthenticatedSettingsExperimentalFeaturesRoute:
    AuthenticatedSettingsExperimentalFeaturesRoute,
  AuthenticatedSettingsPartnerRoute:
    AuthenticatedSettingsPartnerRouteWithChildren,
  AuthenticatedSettingsPrivacyRoute: AuthenticatedSettingsPrivacyRoute,
  AuthenticatedSettingsReceiptsRoute: AuthenticatedSettingsReceiptsRoute,
  AuthenticatedSettingsSlackAgentRoute: AuthenticatedSettingsSlackAgentRoute,
  AuthenticatedSettingsSubscriptionRoute:
    AuthenticatedSettingsSubscriptionRoute,
  AuthenticatedTrialExpiredJourneysRoute:
    AuthenticatedTrialExpiredJourneysRoute,
  AuthenticatedInternalToolsIndexRoute: AuthenticatedInternalToolsIndexRoute,
  AuthenticatedSampleWorkspaceIndexRoute:
    AuthenticatedSampleWorkspaceIndexRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  AuthenticatedSettingsAccountEditRoute: AuthenticatedSettingsAccountEditRoute,
  AuthenticatedSettingsPersonalGoogleIdentitiesRoute:
    AuthenticatedSettingsPersonalGoogleIdentitiesRoute,
  AuthenticatedSettingsRolesRoleIdRoute: AuthenticatedSettingsRolesRoleIdRoute,
  AuthenticatedSettingsRolesNewRoute: AuthenticatedSettingsRolesNewRoute,
  AuthenticatedSettingsSecuritySsoRoute: AuthenticatedSettingsSecuritySsoRoute,
  AuthenticatedSettingsSlackAgentLinkRoute:
    AuthenticatedSettingsSlackAgentLinkRoute,
  AuthenticatedSettingsTeamAddRoute: AuthenticatedSettingsTeamAddRoute,
  AuthenticatedSettingsTeamInviteGuestRoute:
    AuthenticatedSettingsTeamInviteGuestRoute,
  AuthenticatedSettingsWorkspacesNewRoute:
    AuthenticatedSettingsWorkspacesNewRoute,
  AuthenticatedSettingsAccountIndexRoute:
    AuthenticatedSettingsAccountIndexRoute,
  AuthenticatedSettingsApi_credentialsIndexRoute:
    AuthenticatedSettingsApi_credentialsIndexRoute,
  AuthenticatedSettingsPersonalIndexRoute:
    AuthenticatedSettingsPersonalIndexRoute,
  AuthenticatedSettingsRolesIndexRoute: AuthenticatedSettingsRolesIndexRoute,
  AuthenticatedSettingsSecurityIndexRoute:
    AuthenticatedSettingsSecurityIndexRoute,
  AuthenticatedSettingsTeamIndexRoute: AuthenticatedSettingsTeamIndexRoute,
  AuthenticatedSettingsWorkspacesIndexRoute:
    AuthenticatedSettingsWorkspacesIndexRoute,
  AuthenticatedSettingsApi_credentialsService_accountsServiceAccountIdRoute:
    AuthenticatedSettingsApi_credentialsService_accountsServiceAccountIdRoute,
  AuthenticatedSettingsTeamJoinRequestsRequestIdRoute:
    AuthenticatedSettingsTeamJoinRequestsRequestIdRoute,
  AuthenticatedSettingsTeamMembersUserIdEditRoute:
    AuthenticatedSettingsTeamMembersUserIdEditRoute,
};

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
);

interface CliRouteChildren {
  CliDnsSetupRoute: typeof CliDnsSetupRoute;
  CliIndexRoute: typeof CliIndexRoute;
}

const CliRouteChildren: CliRouteChildren = {
  CliDnsSetupRoute: CliDnsSetupRoute,
  CliIndexRoute: CliIndexRoute,
};

const CliRouteWithChildren = CliRoute._addFileChildren(CliRouteChildren);

interface DesignStudioEmbedRouteChildren {
  DesignStudioEmbedCioSplatRoute: typeof DesignStudioEmbedCioSplatRoute;
  DesignStudioEmbedCioIndexRoute: typeof DesignStudioEmbedCioIndexRoute;
}

const DesignStudioEmbedRouteChildren: DesignStudioEmbedRouteChildren = {
  DesignStudioEmbedCioSplatRoute: DesignStudioEmbedCioSplatRoute,
  DesignStudioEmbedCioIndexRoute: DesignStudioEmbedCioIndexRoute,
};

const DesignStudioEmbedRouteWithChildren =
  DesignStudioEmbedRoute._addFileChildren(DesignStudioEmbedRouteChildren);

interface OnboardingRouteChildren {
  OnboardingGetStartedRoute: typeof OnboardingGetStartedRoute;
  OnboardingVerificationRoute: typeof OnboardingVerificationRoute;
  OnboardingWizardRoute: typeof OnboardingWizardRoute;
  OnboardingIndexRoute: typeof OnboardingIndexRoute;
}

const OnboardingRouteChildren: OnboardingRouteChildren = {
  OnboardingGetStartedRoute: OnboardingGetStartedRoute,
  OnboardingVerificationRoute: OnboardingVerificationRoute,
  OnboardingWizardRoute: OnboardingWizardRoute,
  OnboardingIndexRoute: OnboardingIndexRoute,
};

const OnboardingRouteWithChildren = OnboardingRoute._addFileChildren(
  OnboardingRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AcademyLoginRoute: AcademyLoginRoute,
  AcceptGuestInvitationRoute: AcceptGuestInvitationRoute,
  CheckoutRoute: CheckoutRoute,
  CliRoute: CliRouteWithChildren,
  DesignStudioEmbedRoute: DesignStudioEmbedRouteWithChildren,
  JoinRequestRoute: JoinRequestRoute,
  OnboardingRoute: OnboardingRouteWithChildren,
  R2fa_setupSplatRoute: R2fa_setupSplatRoute,
  AccountSplatRoute: AccountSplatRoute,
  Account_canceledSplatRoute: Account_canceledSplatRoute,
  Account_cancelledSplatRoute: Account_cancelledSplatRoute,
  Confirm_accountSplatRoute: Confirm_accountSplatRoute,
  Confirm_account_noticeSplatRoute: Confirm_account_noticeSplatRoute,
  EnvSplatRoute: EnvSplatRoute,
  HarSanitizerSplatRoute: HarSanitizerSplatRoute,
  IntegrationsSplatRoute: IntegrationsSplatRoute,
  JourneysSplatRoute: JourneysSplatRoute,
  LoginSplatRoute: LoginSplatRoute,
  LogoutSplatRoute: LogoutSplatRoute,
  No_accessible_workspacesSplatRoute: No_accessible_workspacesSplatRoute,
  OauthSplatRoute: OauthSplatRoute,
  Oauth2SplatRoute: Oauth2SplatRoute,
  Post_cancelSplatRoute: Post_cancelSplatRoute,
  Post_registrationSplatRoute: Post_registrationSplatRoute,
  Reset_passwordSplatRoute: Reset_passwordSplatRoute,
  SignupSplatRoute: SignupSplatRoute,
  UsersSplatRoute: UsersSplatRoute,
  VwbDemoSplatRoute: VwbDemoSplatRoute,
  AccountCancelledSplatRoute: AccountCancelledSplatRoute,
  PipelinesWorkspacesWorkspaceIdSplatRoute:
    PipelinesWorkspacesWorkspaceIdSplatRoute,
  PipelinesWorkspacesWorkspaceIdIndexRoute:
    PipelinesWorkspacesWorkspaceIdIndexRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
